export const platform_data = [
    {
        "id": 1,
        "name": "PC",
        "slug": "pc",
        "platforms": [
            {
                "id": 4,
                "name": "PC",
                "slug": "pc",
                "games_count": 443935,
                "image_background": "https://media.rawg.io/media/games/34b/34b1f1850a1c06fd971bc6ab3ac0ce0e.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 2,
        "name": "PlayStation",
        "slug": "playstation",
        "platforms": [
            {
                "id": 187,
                "name": "PlayStation 5",
                "slug": "playstation5",
                "games_count": 522,
                "image_background": "https://media.rawg.io/media/games/d89/d89bd0cf4fcdc10820892980cbba0f49.jpg",
                "image": null,
                "year_start": 2020,
                "year_end": null
            },
            {
                "id": 18,
                "name": "PlayStation 4",
                "slug": "playstation4",
                "games_count": 6300,
                "image_background": "https://media.rawg.io/media/games/9fa/9fa63622543e5d4f6d99aa9d73b043de.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 16,
                "name": "PlayStation 3",
                "slug": "playstation3",
                "games_count": 3622,
                "image_background": "https://media.rawg.io/media/games/562/562553814dd54e001a541e4ee83a591c.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 15,
                "name": "PlayStation 2",
                "slug": "playstation2",
                "games_count": 1923,
                "image_background": "https://media.rawg.io/media/games/2ee/2eef5ed5e82c28d1299ecc2a0e60f2cb.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 27,
                "name": "PlayStation",
                "slug": "playstation1",
                "games_count": 1574,
                "image_background": "https://media.rawg.io/media/games/47b/47b50d880be8453bf9cda6e5c007bc26.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 19,
                "name": "PS Vita",
                "slug": "ps-vita",
                "games_count": 1958,
                "image_background": "https://media.rawg.io/media/games/fd7/fd794a9f0ffe816038d981b3acc3eec9.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 17,
                "name": "PSP",
                "slug": "psp",
                "games_count": 1615,
                "image_background": "https://media.rawg.io/media/games/694/6940fa3fbe0d836e4a272c468e65e480.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 3,
        "name": "Xbox",
        "slug": "xbox",
        "platforms": [
            {
                "id": 1,
                "name": "Xbox One",
                "slug": "xbox-one",
                "games_count": 5226,
                "image_background": "https://media.rawg.io/media/games/942/9424d6bb763dc38d9378b488603c87fa.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 186,
                "name": "Xbox Series S/X",
                "slug": "xbox-series-x",
                "games_count": 456,
                "image_background": "https://media.rawg.io/media/games/9f1/9f1891779cb20f44de93cef33b067e50.jpg",
                "image": null,
                "year_start": 2020,
                "year_end": null
            },
            {
                "id": 14,
                "name": "Xbox 360",
                "slug": "xbox360",
                "games_count": 2766,
                "image_background": "https://media.rawg.io/media/games/d69/d69810315bd7e226ea2d21f9156af629.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 80,
                "name": "Xbox",
                "slug": "xbox-old",
                "games_count": 708,
                "image_background": "https://media.rawg.io/media/games/bc7/bc77b1eb8e35df2d90b952bac5342c75.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 4,
        "name": "iOS",
        "slug": "ios",
        "platforms": [
            {
                "id": 3,
                "name": "iOS",
                "slug": "ios",
                "games_count": 74373,
                "image_background": "https://media.rawg.io/media/games/f99/f9979698c43fd84c3ab69280576dd3af.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 8,
        "name": "Android",
        "slug": "android",
        "platforms": [
            {
                "id": 21,
                "name": "Android",
                "slug": "android",
                "games_count": 47696,
                "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 5,
        "name": "Apple Macintosh",
        "slug": "mac",
        "platforms": [
            {
                "id": 5,
                "name": "macOS",
                "slug": "macos",
                "games_count": 92175,
                "image_background": "https://media.rawg.io/media/games/942/9424d6bb763dc38d9378b488603c87fa.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 55,
                "name": "Classic Macintosh",
                "slug": "macintosh",
                "games_count": 670,
                "image_background": "https://media.rawg.io/media/games/2f5/2f5eb72fe45540e93ac2726877551a20.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 41,
                "name": "Apple II",
                "slug": "apple-ii",
                "games_count": 420,
                "image_background": "https://media.rawg.io/media/screenshots/773/7730495e8fc0fe7e1e747cb9449399ac.jpeg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 6,
        "name": "Linux",
        "slug": "linux",
        "platforms": [
            {
                "id": 6,
                "name": "Linux",
                "slug": "linux",
                "games_count": 66748,
                "image_background": "https://media.rawg.io/media/games/73e/73eecb8909e0c39fb246f457b5d6cbbe.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 7,
        "name": "Nintendo",
        "slug": "nintendo",
        "platforms": [
            {
                "id": 7,
                "name": "Nintendo Switch",
                "slug": "nintendo-switch",
                "games_count": 4789,
                "image_background": "https://media.rawg.io/media/games/f87/f87457e8347484033cb34cde6101d08d.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 8,
                "name": "Nintendo 3DS",
                "slug": "nintendo-3ds",
                "games_count": 1750,
                "image_background": "https://media.rawg.io/media/games/e4f/e4fb3fd188f61fabec48dca22e6ef28a.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 9,
                "name": "Nintendo DS",
                "slug": "nintendo-ds",
                "games_count": 2414,
                "image_background": "https://media.rawg.io/media/games/83b/83b59a9d512bec8bc8bda6b539b215b2.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 13,
                "name": "Nintendo DSi",
                "slug": "nintendo-dsi",
                "games_count": 37,
                "image_background": "https://media.rawg.io/media/screenshots/078/078629e997421ca28e9098bd7a87cb10.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 10,
                "name": "Wii U",
                "slug": "wii-u",
                "games_count": 1269,
                "image_background": "https://media.rawg.io/media/games/b4e/b4e4c73d5aa4ec66bbf75375c4847a2b.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 11,
                "name": "Wii",
                "slug": "wii",
                "games_count": 2368,
                "image_background": "https://media.rawg.io/media/screenshots/375/375f84d018242d7519a230f623981217.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 105,
                "name": "GameCube",
                "slug": "gamecube",
                "games_count": 640,
                "image_background": "https://media.rawg.io/media/games/7dd/7dd30ec2b261fa66c3567ddd845ec649.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 83,
                "name": "Nintendo 64",
                "slug": "nintendo-64",
                "games_count": 362,
                "image_background": "https://media.rawg.io/media/games/d64/d646810b629081cc12aec49ed9f49441.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 24,
                "name": "Game Boy Advance",
                "slug": "game-boy-advance",
                "games_count": 955,
                "image_background": "https://media.rawg.io/media/screenshots/d1c/d1cc5f44cb2d9d6b9130294e59cb70b8.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 43,
                "name": "Game Boy Color",
                "slug": "game-boy-color",
                "games_count": 407,
                "image_background": "https://media.rawg.io/media/screenshots/6df/6df71f3ff0f6d6bbac306cb9adf935ee.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 26,
                "name": "Game Boy",
                "slug": "game-boy",
                "games_count": 599,
                "image_background": "https://media.rawg.io/media/games/23e/23eecccb588a4a9c97f35ebf8f9f00ef.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 79,
                "name": "SNES",
                "slug": "snes",
                "games_count": 910,
                "image_background": "https://media.rawg.io/media/screenshots/584/58414628e8f172b4cf0221b554435da7.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 49,
                "name": "NES",
                "slug": "nes",
                "games_count": 943,
                "image_background": "https://media.rawg.io/media/games/5fe/5fe62882f1af83e36480ded84c49b984.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 9,
        "name": "Atari",
        "slug": "atari",
        "platforms": [
            {
                "id": 28,
                "name": "Atari 7800",
                "slug": "atari-7800",
                "games_count": 64,
                "image_background": "https://media.rawg.io/media/screenshots/565/56504b28b184dbc630a7de118e39d822.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 31,
                "name": "Atari 5200",
                "slug": "atari-5200",
                "games_count": 63,
                "image_background": "https://media.rawg.io/media/screenshots/c38/c381fe2913f790fc4d66620e8add37b0.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 23,
                "name": "Atari 2600",
                "slug": "atari-2600",
                "games_count": 286,
                "image_background": "https://media.rawg.io/media/games/23e/23eecccb588a4a9c97f35ebf8f9f00ef.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 22,
                "name": "Atari Flashback",
                "slug": "atari-flashback",
                "games_count": 30,
                "image_background": "https://media.rawg.io/media/screenshots/2aa/2aa07f58491e14b0183333f8956bc802.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 25,
                "name": "Atari 8-bit",
                "slug": "atari-8-bit",
                "games_count": 306,
                "image_background": "https://media.rawg.io/media/screenshots/518/5180f00f3d4626c94bdb0259a07a2903.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 34,
                "name": "Atari ST",
                "slug": "atari-st",
                "games_count": 836,
                "image_background": "https://media.rawg.io/media/screenshots/a7f/a7f3cb62af2ee95d92065da88583338b.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 46,
                "name": "Atari Lynx",
                "slug": "atari-lynx",
                "games_count": 56,
                "image_background": "https://media.rawg.io/media/screenshots/575/575b2838392ed177dd7d2c734c682f93.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 50,
                "name": "Atari XEGS",
                "slug": "atari-xegs",
                "games_count": 22,
                "image_background": "https://media.rawg.io/media/screenshots/769/7691726d70c23c029903df08858df001.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 112,
                "name": "Jaguar",
                "slug": "jaguar",
                "games_count": 31,
                "image_background": "https://media.rawg.io/media/screenshots/d5f/d5f66d7e5f49a1ac445983b8be60b118.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 10,
        "name": "Commodore / Amiga",
        "slug": "commodore-amiga",
        "platforms": [
            {
                "id": 166,
                "name": "Commodore / Amiga",
                "slug": "commodore-amiga",
                "games_count": 2059,
                "image_background": "https://media.rawg.io/media/screenshots/e11/e1152adc84db3182ab4c8bca6505fbd2.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 11,
        "name": "SEGA",
        "slug": "sega",
        "platforms": [
            {
                "id": 167,
                "name": "Genesis",
                "slug": "genesis",
                "games_count": 824,
                "image_background": "https://media.rawg.io/media/games/373/373a9a1f664de6e4c31f08644729e2db.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 107,
                "name": "SEGA Saturn",
                "slug": "sega-saturn",
                "games_count": 317,
                "image_background": "https://media.rawg.io/media/screenshots/d2a/d2a67fc84413d5341408da527e7dde60.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 119,
                "name": "SEGA CD",
                "slug": "sega-cd",
                "games_count": 158,
                "image_background": "https://media.rawg.io/media/games/855/8552687245f888ba388bc6ec0dcc3947.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 117,
                "name": "SEGA 32X",
                "slug": "sega-32x",
                "games_count": 46,
                "image_background": "https://media.rawg.io/media/screenshots/f12/f1290d54a99f637def413baa6642fa0c.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 74,
                "name": "SEGA Master System",
                "slug": "sega-master-system",
                "games_count": 213,
                "image_background": "https://media.rawg.io/media/screenshots/6c8/6c8a4e358693c814111f0cfecf290f34.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 106,
                "name": "Dreamcast",
                "slug": "dreamcast",
                "games_count": 346,
                "image_background": "https://media.rawg.io/media/games/838/838b3e1f39cb8e60c9287cc88607bf52.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            },
            {
                "id": 77,
                "name": "Game Gear",
                "slug": "game-gear",
                "games_count": 174,
                "image_background": "https://media.rawg.io/media/screenshots/f9a/f9ac59bb4af2ca2193ee9ffb979577cf.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 12,
        "name": "3DO",
        "slug": "3do",
        "platforms": [
            {
                "id": 111,
                "name": "3DO",
                "slug": "3do",
                "games_count": 92,
                "image_background": "https://media.rawg.io/media/screenshots/b45/b452e9b20e969a64d0088ae467d1dcab.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 13,
        "name": "Neo Geo",
        "slug": "neo-geo",
        "platforms": [
            {
                "id": 12,
                "name": "Neo Geo",
                "slug": "neogeo",
                "games_count": 97,
                "image_background": "https://media.rawg.io/media/screenshots/2da/2dab29baecf27327f4d896baa39b433d.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    },
    {
        "id": 14,
        "name": "Web",
        "slug": "web",
        "platforms": [
            {
                "id": 171,
                "name": "Web",
                "slug": "web",
                "games_count": 210887,
                "image_background": "https://media.rawg.io/media/screenshots/092/0922422089a8962bba5fb3b35d402714.jpg",
                "image": null,
                "year_start": null,
                "year_end": null
            }
        ]
    }
]

export const gameInfo_stores = [
    {
        "id": 354780,
        "game_id": 3328,
        "store_id": 5,
        "url": "https://www.gog.com/game/the_witcher_3_wild_hunt"
    },
    {
        "id": 3565,
        "game_id": 3328,
        "store_id": 3,
        "url": "https://store.playstation.com/en-us/product/UP4497-CUSA00527_00-0000000000000002"
    },
    {
        "id": 305376,
        "game_id": 3328,
        "store_id": 1,
        "url": "https://store.steampowered.com/app/292030/The_Witcher_3_Wild_Hunt/"
    },
    {
        "id": 312313,
        "game_id": 3328,
        "store_id": 2,
        "url": "https://www.microsoft.com/en-us/p/the-witcher-3-wild-hunt/br765873cqjd"
    },
    {
        "id": 676022,
        "game_id": 3328,
        "store_id": 6,
        "url": "https://www.nintendo.com/games/detail/the-witcher-3-wild-hunt-switch/"
    }
]

export const gameInfo = {
    "id": 3328,
    "slug": "the-witcher-3-wild-hunt",
    "name": "The Witcher 3: Wild Hunt",
    "name_original": "The Witcher 3: Wild Hunt",
    "description": "<p>The third game in a series, it holds nothing back from the player. Open world adventures of the renowned monster slayer Geralt of Rivia are now even on a larger scale. Following the source material more accurately, this time Geralt is trying to find the child of the prophecy, Ciri while making a quick coin from various contracts on the side. Great attention to the world building above all creates an immersive story, where your decisions will shape the world around you.</p>\n<p>CD Project Red are infamous for the amount of work they put into their games, and it shows, because aside from classic third-person action RPG base game they provided 2 massive DLCs with unique questlines and 16 smaller DLCs, containing extra quests and items.</p>\n<p>Players praise the game for its atmosphere and a wide open world that finds the balance between fantasy elements and realistic and believable mechanics, and the game deserved numerous awards for every aspect of the game, from music to direction.</p>",
    "metacritic": 92,
    "metacritic_platforms": [
        {
            "metascore": 91,
            "url": "https://www.metacritic.com/game/xbox-one/the-witcher-3-wild-hunt",
            "platform": {
                "platform": 1,
                "name": "Xbox One",
                "slug": "xbox-one"
            }
        },
        {
            "metascore": 93,
            "url": "https://www.metacritic.com/game/pc/the-witcher-3-wild-hunt",
            "platform": {
                "platform": 4,
                "name": "PC",
                "slug": "pc"
            }
        },
        {
            "metascore": 92,
            "url": "https://www.metacritic.com/game/playstation-4/the-witcher-3-wild-hunt",
            "platform": {
                "platform": 18,
                "name": "PlayStation 4",
                "slug": "playstation4"
            }
        }
    ],
    "released": "2015-05-18",
    "tba": false,
    "updated": "2022-01-02T10:49:58",
    "background_image": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg",
    "background_image_additional": "https://media.rawg.io/media/screenshots/3e4/3e4576a772b3df47bfc52b86e4cf7e03.jpg",
    "website": "https://thewitcher.com/en/witcher3",
    "rating": 3.67,
    "rating_top": 5,
    "ratings": [
        {
            "id": 5,
            "title": "exceptional",
            "count": 4129,
            "percent": 77.95
        },
        {
            "id": 4,
            "title": "recommended",
            "count": 827,
            "percent": 15.61
        },
        {
            "id": 3,
            "title": "meh",
            "count": 215,
            "percent": 4.06
        },
        {
            "id": 1,
            "title": "skip",
            "count": 126,
            "percent": 2.38
        }
    ],
    "reactions": {
        "1": 50,
        "2": 11,
        "3": 48,
        "4": 24,
        "5": 13,
        "6": 9,
        "7": 15,
        "10": 15,
        "11": 17,
        "12": 19,
        "14": 1,
        "15": 1,
        "16": 2,
        "21": 1
    },
    "added": 16038,
    "added_by_status": {
        "yet": 890,
        "owned": 9312,
        "beaten": 3740,
        "toplay": 653,
        "dropped": 691,
        "playing": 752
    },
    "playtime": 47,
    "screenshots_count": 107,
    "movies_count": 0,
    "creators_count": 34,
    "achievements_count": 684,
    "parent_achievements_count": 49,
    "reddit_url": "https://www.reddit.com/r/thewitcher3/",
    "reddit_name": "r/thewitcher3",
    "reddit_description": "A subreddit for veterans and new fans alike of The Witcher 3: Wild Hunt as well as for other Witcher games and the franchise in general. Everyone is welcome.",
    "reddit_logo": "",
    "reddit_count": 8495,
    "twitch_count": 106,
    "youtube_count": 1000000,
    "reviews_text_count": 78,
    "ratings_count": 5219,
    "suggestions_count": 666,
    "alternative_names": [],
    "metacritic_url": "https://www.metacritic.com/game/playstation-4/the-witcher-3-wild-hunt",
    "parents_count": 0,
    "additions_count": 3,
    "game_series_count": 6,
    "user_game": null,
    "reviews_count": 5297,
    "saturated_color": "0f0f0f",
    "dominant_color": "0f0f0f",
    "parent_platforms": [
        {
            "platform": {
                "id": 1,
                "name": "PC",
                "slug": "pc"
            }
        },
        {
            "platform": {
                "id": 2,
                "name": "PlayStation",
                "slug": "playstation"
            }
        },
        {
            "platform": {
                "id": 3,
                "name": "Xbox",
                "slug": "xbox"
            }
        },
        {
            "platform": {
                "id": 7,
                "name": "Nintendo",
                "slug": "nintendo"
            }
        }
    ],
    "platforms": [
        {
            "platform": {
                "id": 7,
                "name": "Nintendo Switch",
                "slug": "nintendo-switch",
                "image": null,
                "year_end": null,
                "year_start": null,
                "games_count": 4771,
                "image_background": "https://media.rawg.io/media/games/7cf/7cfc9220b401b7a300e409e539c9afd5.jpg"
            },
            "released_at": "2015-05-18",
            "requirements": {}
        },
        {
            "platform": {
                "id": 187,
                "name": "PlayStation 5",
                "slug": "playstation5",
                "image": null,
                "year_end": null,
                "year_start": 2020,
                "games_count": 512,
                "image_background": "https://media.rawg.io/media/games/560/56056a71c74f751552c9baedebf8f317.jpg"
            },
            "released_at": "2015-05-18",
            "requirements": {}
        },
        {
            "platform": {
                "id": 186,
                "name": "Xbox Series S/X",
                "slug": "xbox-series-x",
                "image": null,
                "year_end": null,
                "year_start": 2020,
                "games_count": 445,
                "image_background": "https://media.rawg.io/media/games/253/2534a46f3da7fa7c315f1387515ca393.jpg"
            },
            "released_at": "2015-05-18",
            "requirements": {}
        },
        {
            "platform": {
                "id": 1,
                "name": "Xbox One",
                "slug": "xbox-one",
                "image": null,
                "year_end": null,
                "year_start": null,
                "games_count": 5216,
                "image_background": "https://media.rawg.io/media/games/f46/f466571d536f2e3ea9e815ad17177501.jpg"
            },
            "released_at": "2015-05-18",
            "requirements": {}
        },
        {
            "platform": {
                "id": 4,
                "name": "PC",
                "slug": "pc",
                "image": null,
                "year_end": null,
                "year_start": null,
                "games_count": 441553,
                "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
            },
            "released_at": "2015-05-18",
            "requirements": {}
        },
        {
            "platform": {
                "id": 18,
                "name": "PlayStation 4",
                "slug": "playstation4",
                "image": null,
                "year_end": null,
                "year_start": null,
                "games_count": 6288,
                "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
            },
            "released_at": "2015-05-18",
            "requirements": {}
        }
    ],
    "stores": [
        {
            "id": 354780,
            "url": "",
            "store": {
                "id": 5,
                "name": "GOG",
                "slug": "gog",
                "domain": "gog.com",
                "games_count": 4149,
                "image_background": "https://media.rawg.io/media/games/713/713269608dc8f2f40f5a670a14b2de94.jpg"
            }
        },
        {
            "id": 3565,
            "url": "",
            "store": {
                "id": 3,
                "name": "PlayStation Store",
                "slug": "playstation-store",
                "domain": "store.playstation.com",
                "games_count": 7745,
                "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
            }
        },
        {
            "id": 305376,
            "url": "",
            "store": {
                "id": 1,
                "name": "Steam",
                "slug": "steam",
                "domain": "store.steampowered.com",
                "games_count": 62836,
                "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
            }
        },
        {
            "id": 312313,
            "url": "",
            "store": {
                "id": 2,
                "name": "Xbox Store",
                "slug": "xbox-store",
                "domain": "microsoft.com",
                "games_count": 4712,
                "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
            }
        },
        {
            "id": 676022,
            "url": "",
            "store": {
                "id": 6,
                "name": "Nintendo Store",
                "slug": "nintendo",
                "domain": "nintendo.com",
                "games_count": 8825,
                "image_background": "https://media.rawg.io/media/games/b72/b7233d5d5b1e75e86bb860ccc7aeca85.jpg"
            }
        }
    ],
    "developers": [
        {
            "id": 9023,
            "name": "CD PROJEKT RED",
            "slug": "cd-projekt-red",
            "games_count": 18,
            "image_background": "https://media.rawg.io/media/games/ee3/ee3e10193aafc3230ba1cae426967d10.jpg"
        }
    ],
    "genres": [
        {
            "id": 4,
            "name": "Action",
            "slug": "action",
            "games_count": 149659,
            "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
        },
        {
            "id": 3,
            "name": "Adventure",
            "slug": "adventure",
            "games_count": 113029,
            "image_background": "https://media.rawg.io/media/games/9dd/9ddabb34840ea9227556670606cf8ea3.jpg"
        },
        {
            "id": 5,
            "name": "RPG",
            "slug": "role-playing-games-rpg",
            "games_count": 45874,
            "image_background": "https://media.rawg.io/media/games/995/9951d9d55323d08967640f7b9ab3e342.jpg"
        }
    ],
    "tags": [
        {
            "id": 31,
            "name": "Singleplayer",
            "slug": "singleplayer",
            "language": "eng",
            "games_count": 162985,
            "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
        },
        {
            "id": 13,
            "name": "Atmospheric",
            "slug": "atmospheric",
            "language": "eng",
            "games_count": 21630,
            "image_background": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg"
        },
        {
            "id": 40836,
            "name": "Full controller support",
            "slug": "full-controller-support",
            "language": "eng",
            "games_count": 11963,
            "image_background": "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg"
        },
        {
            "id": 42,
            "name": "Great Soundtrack",
            "slug": "great-soundtrack",
            "language": "eng",
            "games_count": 3202,
            "image_background": "https://media.rawg.io/media/games/b7b/b7b8381707152afc7d91f5d95de70e39.jpg"
        },
        {
            "id": 24,
            "name": "RPG",
            "slug": "rpg",
            "language": "eng",
            "games_count": 14383,
            "image_background": "https://media.rawg.io/media/games/c24/c24ec439abf4a2e92f3429dfa83f7f94.jpg"
        },
        {
            "id": 118,
            "name": "Story Rich",
            "slug": "story-rich",
            "language": "eng",
            "games_count": 14512,
            "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
        },
        {
            "id": 36,
            "name": "Open World",
            "slug": "open-world",
            "language": "eng",
            "games_count": 5045,
            "image_background": "https://media.rawg.io/media/games/6cd/6cd653e0aaef5ff8bbd295bf4bcb12eb.jpg"
        },
        {
            "id": 149,
            "name": "Third Person",
            "slug": "third-person",
            "language": "eng",
            "games_count": 6912,
            "image_background": "https://media.rawg.io/media/games/d69/d69810315bd7e226ea2d21f9156af629.jpg"
        },
        {
            "id": 64,
            "name": "Fantasy",
            "slug": "fantasy",
            "language": "eng",
            "games_count": 19249,
            "image_background": "https://media.rawg.io/media/games/59a/59a3ebcba3d08c51532c6ca877aff256.jpg"
        },
        {
            "id": 37,
            "name": "Sandbox",
            "slug": "sandbox",
            "language": "eng",
            "games_count": 4817,
            "image_background": "https://media.rawg.io/media/games/48c/48cb04ca483be865e3a83119c94e6097.jpg"
        },
        {
            "id": 97,
            "name": "Action RPG",
            "slug": "action-rpg",
            "language": "eng",
            "games_count": 4647,
            "image_background": "https://media.rawg.io/media/games/83f/83f6f70a7c1b86cd2637b029d8b42caa.jpg"
        },
        {
            "id": 41,
            "name": "Dark",
            "slug": "dark",
            "language": "eng",
            "games_count": 10634,
            "image_background": "https://media.rawg.io/media/games/7f6/7f6cd70ba2ad57053b4847c13569f2d8.jpg"
        },
        {
            "id": 44,
            "name": "Nudity",
            "slug": "nudity",
            "language": "eng",
            "games_count": 3680,
            "image_background": "https://media.rawg.io/media/games/858/858c016de0cf7bc21a57dcc698a04a0c.jpg"
        },
        {
            "id": 336,
            "name": "controller support",
            "slug": "controller-support",
            "language": "eng",
            "games_count": 293,
            "image_background": "https://media.rawg.io/media/games/003/0031c0067559d41df19cf98ad87e02aa.jpg"
        },
        {
            "id": 192,
            "name": "Mature",
            "slug": "mature",
            "language": "eng",
            "games_count": 1417,
            "image_background": "https://media.rawg.io/media/games/8ca/8ca40b562a755d6a0e30d48e6c74b178.jpg"
        },
        {
            "id": 145,
            "name": "Choices Matter",
            "slug": "choices-matter",
            "language": "eng",
            "games_count": 2190,
            "image_background": "https://media.rawg.io/media/screenshots/8f0/8f0b94922ad5e59968852649697b2643.jpg"
        },
        {
            "id": 40,
            "name": "Dark Fantasy",
            "slug": "dark-fantasy",
            "language": "eng",
            "games_count": 2400,
            "image_background": "https://media.rawg.io/media/games/21a/21ad672cedee9b4378abb6c2d2e626ee.jpg"
        },
        {
            "id": 66,
            "name": "Medieval",
            "slug": "medieval",
            "language": "eng",
            "games_count": 4081,
            "image_background": "https://media.rawg.io/media/games/d8f/d8f3b28fc747ed6f92943cdd33fb91b5.jpeg"
        },
        {
            "id": 82,
            "name": "Magic",
            "slug": "magic",
            "language": "eng",
            "games_count": 6533,
            "image_background": "https://media.rawg.io/media/games/3c3/3c363e31f4add887affadc82c641de72.jpg"
        },
        {
            "id": 218,
            "name": "Multiple Endings",
            "slug": "multiple-endings",
            "language": "eng",
            "games_count": 5129,
            "image_background": "https://media.rawg.io/media/games/214/2140885d34e3a3398b45036e5d870971.jpg"
        }
    ],
    "publishers": [
        {
            "id": 7411,
            "name": "CD PROJEKT RED",
            "slug": "cd-projekt-red",
            "games_count": 17,
            "image_background": "https://media.rawg.io/media/games/b51/b51c3649322ac0de9dfbe83435eda449.jpg"
        }
    ],
    "esrb_rating": {
        "id": 4,
        "name": "Mature",
        "slug": "mature"
    },
    "clip": null,
    "description_raw": "The third game in a series, it holds nothing back from the player. Open world adventures of the renowned monster slayer Geralt of Rivia are now even on a larger scale. Following the source material more accurately, this time Geralt is trying to find the child of the prophecy, Ciri while making a quick coin from various contracts on the side. Great attention to the world building above all creates an immersive story, where your decisions will shape the world around you.\n\nCD Project Red are infamous for the amount of work they put into their games, and it shows, because aside from classic third-person action RPG base game they provided 2 massive DLCs with unique questlines and 16 smaller DLCs, containing extra quests and items.\n\nPlayers praise the game for its atmosphere and a wide open world that finds the balance between fantasy elements and realistic and believable mechanics, and the game deserved numerous awards for every aspect of the game, from music to direction."
}

export const gameData = [
  {
      "id": 3498,
      "slug": "grand-theft-auto-v",
      "name": "Grand Theft Auto V",
      "released": "2013-09-17",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg",
      "rating": 4.48,
      "rating_top": 5,
      "ratings": [
          {
              "id": 5,
              "title": "exceptional",
              "count": 3370,
              "percent": 59.12
          },
          {
              "id": 4,
              "title": "recommended",
              "count": 1870,
              "percent": 32.81
          },
          {
              "id": 3,
              "title": "meh",
              "count": 361,
              "percent": 6.33
          },
          {
              "id": 1,
              "title": "skip",
              "count": 99,
              "percent": 1.74
          }
      ],
      "ratings_count": 5627,
      "reviews_text_count": 41,
      "added": 17309,
      "added_by_status": {
          "yet": 432,
          "owned": 10184,
          "beaten": 4702,
          "toplay": 506,
          "dropped": 862,
          "playing": 623
      },
      "metacritic": 72,
      "playtime": 72,
      "suggestions_count": 406,
      "updated": "2022-05-11T12:26:10",
      "user_game": null,
      "reviews_count": 5700,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2013-09-17",
              "requirements_en": {
                  "minimum": "Minimum:OS: Windows 10 64 Bit, Windows 8.1 64 Bit, Windows 8 64 Bit, Windows 7 64 Bit Service Pack 1, Windows Vista 64 Bit Service Pack 2* (*NVIDIA video card recommended if running Vista OS)Processor: Intel Core 2 Quad CPU Q6600 @ 2.40GHz (4 CPUs) / AMD Phenom 9850 Quad-Core Processor (4 CPUs) @ 2.5GHzMemory: 4 GB RAMGraphics: NVIDIA 9800 GT 1GB / AMD HD 4870 1GB (DX 10, 10.1, 11)Storage: 72 GB available spaceSound Card: 100% DirectX 10 compatibleAdditional Notes: Over time downloadable content and programming changes will change the system requirements for this game.  Please refer to your hardware manufacturer and www.rockstargames.com/support for current compatibility information. Some system components such as mobile chipsets, integrated, and AGP graphics cards may be incompatible. Unlisted specifications may not be supported by publisher.     Other requirements:  Installation and online play requires log-in to Rockstar Games Social Club (13+) network; internet connection required for activation, online play, and periodic entitlement verification; software installations required including Rockstar Games Social Club platform, DirectX , Chromium, and Microsoft Visual C++ 2008 sp1 Redistributable Package, and authentication software that recognizes certain hardware attributes for entitlement, digital rights management, system, and other support purposes.     SINGLE USE SERIAL CODE REGISTRATION VIA INTERNET REQUIRED; REGISTRATION IS LIMITED TO ONE ROCKSTAR GAMES SOCIAL CLUB ACCOUNT (13+) PER SERIAL CODE; ONLY ONE PC LOG-IN ALLOWED PER SOCIAL CLUB ACCOUNT AT ANY TIME; SERIAL CODE(S) ARE NON-TRANSFERABLE ONCE USED; SOCIAL CLUB ACCOUNTS ARE NON-TRANSFERABLE.  Partner Requirements:  Please check the terms of service of this site before purchasing this software.",
                  "recommended": "Recommended:OS: Windows 10 64 Bit, Windows 8.1 64 Bit, Windows 8 64 Bit, Windows 7 64 Bit Service Pack 1Processor: Intel Core i5 3470 @ 3.2GHz (4 CPUs) / AMD X8 FX-8350 @ 4GHz (8 CPUs)Memory: 8 GB RAMGraphics: NVIDIA GTX 660 2GB / AMD HD 7870 2GBStorage: 72 GB available spaceSound Card: 100% DirectX 10 compatibleAdditional Notes:"
              },
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 186,
                  "name": "Xbox Series S/X",
                  "slug": "xbox-series-x",
                  "image": null,
                  "year_end": null,
                  "year_start": 2020,
                  "games_count": 445,
                  "image_background": "https://media.rawg.io/media/games/253/2534a46f3da7fa7c315f1387515ca393.jpg"
              },
              "released_at": "2013-09-17",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 18,
                  "name": "PlayStation 4",
                  "slug": "playstation4",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 6288,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2013-09-17",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 16,
                  "name": "PlayStation 3",
                  "slug": "playstation3",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 3626,
                  "image_background": "https://media.rawg.io/media/games/490/49016e06ae2103881ff6373248843069.jpg"
              },
              "released_at": "2013-09-17",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 14,
                  "name": "Xbox 360",
                  "slug": "xbox360",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 2764,
                  "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
              },
              "released_at": "2013-09-17",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 1,
                  "name": "Xbox One",
                  "slug": "xbox-one",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 5216,
                  "image_background": "https://media.rawg.io/media/games/f46/f466571d536f2e3ea9e815ad17177501.jpg"
              },
              "released_at": "2013-09-17",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 187,
                  "name": "PlayStation 5",
                  "slug": "playstation5",
                  "image": null,
                  "year_end": null,
                  "year_start": 2020,
                  "games_count": 512,
                  "image_background": "https://media.rawg.io/media/games/560/56056a71c74f751552c9baedebf8f317.jpg"
              },
              "released_at": "2013-09-17",
              "requirements_en": null,
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 2,
                  "name": "PlayStation",
                  "slug": "playstation"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          }
      ],
      "genres": [
          {
              "id": 4,
              "name": "Action",
              "slug": "action",
              "games_count": 149659,
              "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
          },
          {
              "id": 3,
              "name": "Adventure",
              "slug": "adventure",
              "games_count": 113029,
              "image_background": "https://media.rawg.io/media/games/9dd/9ddabb34840ea9227556670606cf8ea3.jpg"
          }
      ],
      "stores": [
          {
              "id": 290375,
              "store": {
                  "id": 3,
                  "name": "PlayStation Store",
                  "slug": "playstation-store",
                  "domain": "store.playstation.com",
                  "games_count": 7745,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 438095,
              "store": {
                  "id": 11,
                  "name": "Epic Games",
                  "slug": "epic-games",
                  "domain": "epicgames.com",
                  "games_count": 942,
                  "image_background": "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg"
              }
          },
          {
              "id": 290376,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          },
          {
              "id": 290377,
              "store": {
                  "id": 7,
                  "name": "Xbox 360 Store",
                  "slug": "xbox360",
                  "domain": "marketplace.xbox.com",
                  "games_count": 1917,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 290378,
              "store": {
                  "id": 2,
                  "name": "Xbox Store",
                  "slug": "xbox-store",
                  "domain": "microsoft.com",
                  "games_count": 4712,
                  "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 31,
              "name": "Singleplayer",
              "slug": "singleplayer",
              "language": "eng",
              "games_count": 162985,
              "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 40847,
              "name": "Steam Achievements",
              "slug": "steam-achievements",
              "language": "eng",
              "games_count": 25765,
              "image_background": "https://media.rawg.io/media/games/4ba/4ba9b4b68ffcc7019b112174883ba4d6.jpg"
          },
          {
              "id": 7,
              "name": "Multiplayer",
              "slug": "multiplayer",
              "language": "eng",
              "games_count": 30873,
              "image_background": "https://media.rawg.io/media/games/8cc/8cce7c0e99dcc43d66c8efd42f9d03e3.jpg"
          },
          {
              "id": 13,
              "name": "Atmospheric",
              "slug": "atmospheric",
              "language": "eng",
              "games_count": 21630,
              "image_background": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg"
          },
          {
              "id": 40836,
              "name": "Full controller support",
              "slug": "full-controller-support",
              "language": "eng",
              "games_count": 11963,
              "image_background": "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg"
          },
          {
              "id": 42,
              "name": "Great Soundtrack",
              "slug": "great-soundtrack",
              "language": "eng",
              "games_count": 3202,
              "image_background": "https://media.rawg.io/media/games/b7b/b7b8381707152afc7d91f5d95de70e39.jpg"
          },
          {
              "id": 24,
              "name": "RPG",
              "slug": "rpg",
              "language": "eng",
              "games_count": 14383,
              "image_background": "https://media.rawg.io/media/games/c24/c24ec439abf4a2e92f3429dfa83f7f94.jpg"
          },
          {
              "id": 18,
              "name": "Co-op",
              "slug": "co-op",
              "language": "eng",
              "games_count": 8306,
              "image_background": "https://media.rawg.io/media/games/ec3/ec3a7db7b8ab5a71aad622fe7c62632f.jpg"
          },
          {
              "id": 36,
              "name": "Open World",
              "slug": "open-world",
              "language": "eng",
              "games_count": 5045,
              "image_background": "https://media.rawg.io/media/games/6cd/6cd653e0aaef5ff8bbd295bf4bcb12eb.jpg"
          },
          {
              "id": 411,
              "name": "cooperative",
              "slug": "cooperative",
              "language": "eng",
              "games_count": 3372,
              "image_background": "https://media.rawg.io/media/games/f87/f87457e8347484033cb34cde6101d08d.jpg"
          },
          {
              "id": 8,
              "name": "First-Person",
              "slug": "first-person",
              "language": "eng",
              "games_count": 21101,
              "image_background": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg"
          },
          {
              "id": 149,
              "name": "Third Person",
              "slug": "third-person",
              "language": "eng",
              "games_count": 6912,
              "image_background": "https://media.rawg.io/media/games/d69/d69810315bd7e226ea2d21f9156af629.jpg"
          },
          {
              "id": 4,
              "name": "Funny",
              "slug": "funny",
              "language": "eng",
              "games_count": 18531,
              "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
          },
          {
              "id": 37,
              "name": "Sandbox",
              "slug": "sandbox",
              "language": "eng",
              "games_count": 4817,
              "image_background": "https://media.rawg.io/media/games/48c/48cb04ca483be865e3a83119c94e6097.jpg"
          },
          {
              "id": 123,
              "name": "Comedy",
              "slug": "comedy",
              "language": "eng",
              "games_count": 8823,
              "image_background": "https://media.rawg.io/media/games/ffe/ffed87105b14f5beff72ff44a7793fd5.jpg"
          },
          {
              "id": 150,
              "name": "Third-Person Shooter",
              "slug": "third-person-shooter",
              "language": "eng",
              "games_count": 2264,
              "image_background": "https://media.rawg.io/media/games/a3c/a3c529a12c896c0ef02db5b4741de2ba.jpg"
          },
          {
              "id": 62,
              "name": "Moddable",
              "slug": "moddable",
              "language": "eng",
              "games_count": 679,
              "image_background": "https://media.rawg.io/media/games/4a0/4a0a1316102366260e6f38fd2a9cfdce.jpg"
          },
          {
              "id": 144,
              "name": "Crime",
              "slug": "crime",
              "language": "eng",
              "games_count": 2199,
              "image_background": "https://media.rawg.io/media/games/5fa/5fae5fec3c943179e09da67a4427d68f.jpg"
          },
          {
              "id": 62349,
              "name": "vr mod",
              "slug": "vr-mod",
              "language": "eng",
              "games_count": 17,
              "image_background": "https://media.rawg.io/media/games/645/64578c2a6daa30995692525172fd13ef.jpg"
          }
      ],
      "esrb_rating": {
          "id": 4,
          "name": "Mature",
          "slug": "mature"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
          },
          {
              "id": 1827221,
              "image": "https://media.rawg.io/media/screenshots/a7c/a7c43871a54bed6573a6a429451564ef.jpg"
          },
          {
              "id": 1827222,
              "image": "https://media.rawg.io/media/screenshots/cf4/cf4367daf6a1e33684bf19adb02d16d6.jpg"
          },
          {
              "id": 1827223,
              "image": "https://media.rawg.io/media/screenshots/f95/f9518b1d99210c0cae21fc09e95b4e31.jpg"
          },
          {
              "id": 1827225,
              "image": "https://media.rawg.io/media/screenshots/a5c/a5c95ea539c87d5f538763e16e18fb99.jpg"
          },
          {
              "id": 1827226,
              "image": "https://media.rawg.io/media/screenshots/a7e/a7e990bc574f4d34e03b5926361d1ee7.jpg"
          },
          {
              "id": 1827227,
              "image": "https://media.rawg.io/media/screenshots/592/592e2501d8734b802b2a34fee2df59fa.jpg"
          }
      ]
  },
  {
      "id": 3328,
      "slug": "the-witcher-3-wild-hunt",
      "name": "The Witcher 3: Wild Hunt",
      "released": "2015-05-18",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg",
      "rating": 4.67,
      "rating_top": 5,
      "ratings": [
          {
              "id": 5,
              "title": "exceptional",
              "count": 4127,
              "percent": 77.96
          },
          {
              "id": 4,
              "title": "recommended",
              "count": 827,
              "percent": 15.62
          },
          {
              "id": 3,
              "title": "meh",
              "count": 215,
              "percent": 4.06
          },
          {
              "id": 1,
              "title": "skip",
              "count": 125,
              "percent": 2.36
          }
      ],
      "ratings_count": 5216,
      "reviews_text_count": 56,
      "added": 16028,
      "added_by_status": {
          "yet": 890,
          "owned": 9303,
          "beaten": 3739,
          "toplay": 652,
          "dropped": 691,
          "playing": 753
      },
      "metacritic": 92,
      "playtime": 47,
      "suggestions_count": 670,
      "updated": "2022-01-02T10:49:58",
      "user_game": null,
      "reviews_count": 5294,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 7,
                  "name": "Nintendo Switch",
                  "slug": "nintendo-switch",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 4771,
                  "image_background": "https://media.rawg.io/media/games/7cf/7cfc9220b401b7a300e409e539c9afd5.jpg"
              },
              "released_at": "2015-05-18",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 187,
                  "name": "PlayStation 5",
                  "slug": "playstation5",
                  "image": null,
                  "year_end": null,
                  "year_start": 2020,
                  "games_count": 512,
                  "image_background": "https://media.rawg.io/media/games/560/56056a71c74f751552c9baedebf8f317.jpg"
              },
              "released_at": "2015-05-18",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 186,
                  "name": "Xbox Series S/X",
                  "slug": "xbox-series-x",
                  "image": null,
                  "year_end": null,
                  "year_start": 2020,
                  "games_count": 445,
                  "image_background": "https://media.rawg.io/media/games/253/2534a46f3da7fa7c315f1387515ca393.jpg"
              },
              "released_at": "2015-05-18",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 1,
                  "name": "Xbox One",
                  "slug": "xbox-one",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 5216,
                  "image_background": "https://media.rawg.io/media/games/f46/f466571d536f2e3ea9e815ad17177501.jpg"
              },
              "released_at": "2015-05-18",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2015-05-18",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 18,
                  "name": "PlayStation 4",
                  "slug": "playstation4",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 6288,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2015-05-18",
              "requirements_en": null,
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 2,
                  "name": "PlayStation",
                  "slug": "playstation"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          },
          {
              "platform": {
                  "id": 7,
                  "name": "Nintendo",
                  "slug": "nintendo"
              }
          }
      ],
      "genres": [
          {
              "id": 4,
              "name": "Action",
              "slug": "action",
              "games_count": 149659,
              "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
          },
          {
              "id": 3,
              "name": "Adventure",
              "slug": "adventure",
              "games_count": 113029,
              "image_background": "https://media.rawg.io/media/games/9dd/9ddabb34840ea9227556670606cf8ea3.jpg"
          },
          {
              "id": 5,
              "name": "RPG",
              "slug": "role-playing-games-rpg",
              "games_count": 45874,
              "image_background": "https://media.rawg.io/media/games/995/9951d9d55323d08967640f7b9ab3e342.jpg"
          }
      ],
      "stores": [
          {
              "id": 354780,
              "store": {
                  "id": 5,
                  "name": "GOG",
                  "slug": "gog",
                  "domain": "gog.com",
                  "games_count": 4149,
                  "image_background": "https://media.rawg.io/media/games/713/713269608dc8f2f40f5a670a14b2de94.jpg"
              }
          },
          {
              "id": 3565,
              "store": {
                  "id": 3,
                  "name": "PlayStation Store",
                  "slug": "playstation-store",
                  "domain": "store.playstation.com",
                  "games_count": 7745,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 305376,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          },
          {
              "id": 312313,
              "store": {
                  "id": 2,
                  "name": "Xbox Store",
                  "slug": "xbox-store",
                  "domain": "microsoft.com",
                  "games_count": 4712,
                  "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
              }
          },
          {
              "id": 676022,
              "store": {
                  "id": 6,
                  "name": "Nintendo Store",
                  "slug": "nintendo",
                  "domain": "nintendo.com",
                  "games_count": 8825,
                  "image_background": "https://media.rawg.io/media/games/b72/b7233d5d5b1e75e86bb860ccc7aeca85.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 31,
              "name": "Singleplayer",
              "slug": "singleplayer",
              "language": "eng",
              "games_count": 162985,
              "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 13,
              "name": "Atmospheric",
              "slug": "atmospheric",
              "language": "eng",
              "games_count": 21630,
              "image_background": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg"
          },
          {
              "id": 40836,
              "name": "Full controller support",
              "slug": "full-controller-support",
              "language": "eng",
              "games_count": 11963,
              "image_background": "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg"
          },
          {
              "id": 42,
              "name": "Great Soundtrack",
              "slug": "great-soundtrack",
              "language": "eng",
              "games_count": 3202,
              "image_background": "https://media.rawg.io/media/games/b7b/b7b8381707152afc7d91f5d95de70e39.jpg"
          },
          {
              "id": 24,
              "name": "RPG",
              "slug": "rpg",
              "language": "eng",
              "games_count": 14383,
              "image_background": "https://media.rawg.io/media/games/c24/c24ec439abf4a2e92f3429dfa83f7f94.jpg"
          },
          {
              "id": 118,
              "name": "Story Rich",
              "slug": "story-rich",
              "language": "eng",
              "games_count": 14512,
              "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
          },
          {
              "id": 36,
              "name": "Open World",
              "slug": "open-world",
              "language": "eng",
              "games_count": 5045,
              "image_background": "https://media.rawg.io/media/games/6cd/6cd653e0aaef5ff8bbd295bf4bcb12eb.jpg"
          },
          {
              "id": 149,
              "name": "Third Person",
              "slug": "third-person",
              "language": "eng",
              "games_count": 6912,
              "image_background": "https://media.rawg.io/media/games/d69/d69810315bd7e226ea2d21f9156af629.jpg"
          },
          {
              "id": 64,
              "name": "Fantasy",
              "slug": "fantasy",
              "language": "eng",
              "games_count": 19249,
              "image_background": "https://media.rawg.io/media/games/59a/59a3ebcba3d08c51532c6ca877aff256.jpg"
          },
          {
              "id": 37,
              "name": "Sandbox",
              "slug": "sandbox",
              "language": "eng",
              "games_count": 4817,
              "image_background": "https://media.rawg.io/media/games/48c/48cb04ca483be865e3a83119c94e6097.jpg"
          },
          {
              "id": 97,
              "name": "Action RPG",
              "slug": "action-rpg",
              "language": "eng",
              "games_count": 4647,
              "image_background": "https://media.rawg.io/media/games/83f/83f6f70a7c1b86cd2637b029d8b42caa.jpg"
          },
          {
              "id": 41,
              "name": "Dark",
              "slug": "dark",
              "language": "eng",
              "games_count": 10634,
              "image_background": "https://media.rawg.io/media/games/7f6/7f6cd70ba2ad57053b4847c13569f2d8.jpg"
          },
          {
              "id": 44,
              "name": "Nudity",
              "slug": "nudity",
              "language": "eng",
              "games_count": 3680,
              "image_background": "https://media.rawg.io/media/games/858/858c016de0cf7bc21a57dcc698a04a0c.jpg"
          },
          {
              "id": 336,
              "name": "controller support",
              "slug": "controller-support",
              "language": "eng",
              "games_count": 293,
              "image_background": "https://media.rawg.io/media/games/003/0031c0067559d41df19cf98ad87e02aa.jpg"
          },
          {
              "id": 192,
              "name": "Mature",
              "slug": "mature",
              "language": "eng",
              "games_count": 1417,
              "image_background": "https://media.rawg.io/media/games/8ca/8ca40b562a755d6a0e30d48e6c74b178.jpg"
          },
          {
              "id": 145,
              "name": "Choices Matter",
              "slug": "choices-matter",
              "language": "eng",
              "games_count": 2190,
              "image_background": "https://media.rawg.io/media/screenshots/8f0/8f0b94922ad5e59968852649697b2643.jpg"
          },
          {
              "id": 40,
              "name": "Dark Fantasy",
              "slug": "dark-fantasy",
              "language": "eng",
              "games_count": 2400,
              "image_background": "https://media.rawg.io/media/games/21a/21ad672cedee9b4378abb6c2d2e626ee.jpg"
          },
          {
              "id": 66,
              "name": "Medieval",
              "slug": "medieval",
              "language": "eng",
              "games_count": 4081,
              "image_background": "https://media.rawg.io/media/games/d8f/d8f3b28fc747ed6f92943cdd33fb91b5.jpeg"
          },
          {
              "id": 82,
              "name": "Magic",
              "slug": "magic",
              "language": "eng",
              "games_count": 6533,
              "image_background": "https://media.rawg.io/media/games/3c3/3c363e31f4add887affadc82c641de72.jpg"
          },
          {
              "id": 218,
              "name": "Multiple Endings",
              "slug": "multiple-endings",
              "language": "eng",
              "games_count": 5129,
              "image_background": "https://media.rawg.io/media/games/214/2140885d34e3a3398b45036e5d870971.jpg"
          }
      ],
      "esrb_rating": {
          "id": 4,
          "name": "Mature",
          "slug": "mature"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg"
          },
          {
              "id": 30336,
              "image": "https://media.rawg.io/media/screenshots/1ac/1ac19f31974314855ad7be266adeb500.jpg"
          },
          {
              "id": 30337,
              "image": "https://media.rawg.io/media/screenshots/6a0/6a08afca95261a2fe221ea9e01d28762.jpg"
          },
          {
              "id": 30338,
              "image": "https://media.rawg.io/media/screenshots/cdd/cdd31b6b4a687425a87b5ce231ac89d7.jpg"
          },
          {
              "id": 30339,
              "image": "https://media.rawg.io/media/screenshots/862/862397b153221a625922d3bb66337834.jpg"
          },
          {
              "id": 30340,
              "image": "https://media.rawg.io/media/screenshots/166/166787c442a45f52f4f230c33fd7d605.jpg"
          },
          {
              "id": 30342,
              "image": "https://media.rawg.io/media/screenshots/f63/f6373ee614046d81503d63f167181803.jpg"
          }
      ]
  },
  {
      "id": 4200,
      "slug": "portal-2",
      "name": "Portal 2",
      "released": "2011-04-18",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg",
      "rating": 4.62,
      "rating_top": 5,
      "ratings": [
          {
              "id": 5,
              "title": "exceptional",
              "count": 3312,
              "percent": 70.54
          },
          {
              "id": 4,
              "title": "recommended",
              "count": 1157,
              "percent": 24.64
          },
          {
              "id": 3,
              "title": "meh",
              "count": 129,
              "percent": 2.75
          },
          {
              "id": 1,
              "title": "skip",
              "count": 97,
              "percent": 2.07
          }
      ],
      "ratings_count": 4655,
      "reviews_text_count": 27,
      "added": 15132,
      "added_by_status": {
          "yet": 504,
          "owned": 9347,
          "beaten": 4418,
          "toplay": 293,
          "dropped": 448,
          "playing": 122
      },
      "metacritic": 25,
      "playtime": 11,
      "suggestions_count": 548,
      "updated": "2020-08-03T02:17:38",
      "user_game": null,
      "reviews_count": 4695,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 14,
                  "name": "Xbox 360",
                  "slug": "xbox360",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 2764,
                  "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
              },
              "released_at": "2011-04-19",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 6,
                  "name": "Linux",
                  "slug": "linux",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 66467,
                  "image_background": "https://media.rawg.io/media/games/d69/d69810315bd7e226ea2d21f9156af629.jpg"
              },
              "released_at": "2011-04-19",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 5,
                  "name": "macOS",
                  "slug": "macos",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 91804,
                  "image_background": "https://media.rawg.io/media/games/b54/b54598d1d5cc31899f4f0a7e3122a7b0.jpg"
              },
              "released_at": null,
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 16,
                  "name": "PlayStation 3",
                  "slug": "playstation3",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 3626,
                  "image_background": "https://media.rawg.io/media/games/490/49016e06ae2103881ff6373248843069.jpg"
              },
              "released_at": "2011-04-19",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": null,
              "requirements_en": null,
              "requirements_ru": {
                  "minimum": "Core 2 Duo/Athlon X2 2 ГГц,1 Гб памяти,GeForce 7600/Radeon X800,10 Гб на винчестере,интернет-соединение",
                  "recommended": "Core 2 Duo/Athlon X2 2.5 ГГц,2 Гб памяти,GeForce GTX 280/Radeon HD 2600,10 Гб на винчестере,интернет-соединение"
              }
          },
          {
              "platform": {
                  "id": 1,
                  "name": "Xbox One",
                  "slug": "xbox-one",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 5216,
                  "image_background": "https://media.rawg.io/media/games/f46/f466571d536f2e3ea9e815ad17177501.jpg"
              },
              "released_at": "2011-04-18",
              "requirements_en": null,
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 2,
                  "name": "PlayStation",
                  "slug": "playstation"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          },
          {
              "platform": {
                  "id": 5,
                  "name": "Apple Macintosh",
                  "slug": "mac"
              }
          },
          {
              "platform": {
                  "id": 6,
                  "name": "Linux",
                  "slug": "linux"
              }
          }
      ],
      "genres": [
          {
              "id": 2,
              "name": "Shooter",
              "slug": "shooter",
              "games_count": 51719,
              "image_background": "https://media.rawg.io/media/games/9fa/9fa63622543e5d4f6d99aa9d73b043de.jpg"
          },
          {
              "id": 7,
              "name": "Puzzle",
              "slug": "puzzle",
              "games_count": 84387,
              "image_background": "https://media.rawg.io/media/games/8cd/8cd179c85bd3de8f79bef245b15075fb.jpg"
          }
      ],
      "stores": [
          {
              "id": 465889,
              "store": {
                  "id": 2,
                  "name": "Xbox Store",
                  "slug": "xbox-store",
                  "domain": "microsoft.com",
                  "games_count": 4712,
                  "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
              }
          },
          {
              "id": 13134,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          },
          {
              "id": 4526,
              "store": {
                  "id": 3,
                  "name": "PlayStation Store",
                  "slug": "playstation-store",
                  "domain": "store.playstation.com",
                  "games_count": 7745,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 33916,
              "store": {
                  "id": 7,
                  "name": "Xbox 360 Store",
                  "slug": "xbox360",
                  "domain": "marketplace.xbox.com",
                  "games_count": 1917,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 31,
              "name": "Singleplayer",
              "slug": "singleplayer",
              "language": "eng",
              "games_count": 162985,
              "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 40847,
              "name": "Steam Achievements",
              "slug": "steam-achievements",
              "language": "eng",
              "games_count": 25765,
              "image_background": "https://media.rawg.io/media/games/4ba/4ba9b4b68ffcc7019b112174883ba4d6.jpg"
          },
          {
              "id": 7,
              "name": "Multiplayer",
              "slug": "multiplayer",
              "language": "eng",
              "games_count": 30873,
              "image_background": "https://media.rawg.io/media/games/8cc/8cce7c0e99dcc43d66c8efd42f9d03e3.jpg"
          },
          {
              "id": 7808,
              "name": "steam-trading-cards",
              "slug": "steam-trading-cards",
              "language": "eng",
              "games_count": 7582,
              "image_background": "https://media.rawg.io/media/games/4cf/4cfc6b7f1850590a4634b08bfab308ab.jpg"
          },
          {
              "id": 13,
              "name": "Atmospheric",
              "slug": "atmospheric",
              "language": "eng",
              "games_count": 21630,
              "image_background": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg"
          },
          {
              "id": 40849,
              "name": "Steam Cloud",
              "slug": "steam-cloud",
              "language": "eng",
              "games_count": 11732,
              "image_background": "https://media.rawg.io/media/games/c6b/c6bfece1daf8d06bc0a60632ac78e5bf.jpg"
          },
          {
              "id": 40836,
              "name": "Full controller support",
              "slug": "full-controller-support",
              "language": "eng",
              "games_count": 11963,
              "image_background": "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg"
          },
          {
              "id": 18,
              "name": "Co-op",
              "slug": "co-op",
              "language": "eng",
              "games_count": 8306,
              "image_background": "https://media.rawg.io/media/games/ec3/ec3a7db7b8ab5a71aad622fe7c62632f.jpg"
          },
          {
              "id": 118,
              "name": "Story Rich",
              "slug": "story-rich",
              "language": "eng",
              "games_count": 14512,
              "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
          },
          {
              "id": 411,
              "name": "cooperative",
              "slug": "cooperative",
              "language": "eng",
              "games_count": 3372,
              "image_background": "https://media.rawg.io/media/games/f87/f87457e8347484033cb34cde6101d08d.jpg"
          },
          {
              "id": 8,
              "name": "First-Person",
              "slug": "first-person",
              "language": "eng",
              "games_count": 21101,
              "image_background": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg"
          },
          {
              "id": 32,
              "name": "Sci-fi",
              "slug": "sci-fi",
              "language": "eng",
              "games_count": 14086,
              "image_background": "https://media.rawg.io/media/games/8e4/8e4de3f54ac659e08a7ba6a2b731682a.jpg"
          },
          {
              "id": 30,
              "name": "FPS",
              "slug": "fps",
              "language": "eng",
              "games_count": 10374,
              "image_background": "https://media.rawg.io/media/games/26d/26d4437715bee60138dab4a7c8c59c92.jpg"
          },
          {
              "id": 9,
              "name": "Online Co-Op",
              "slug": "online-co-op",
              "language": "eng",
              "games_count": 3482,
              "image_background": "https://media.rawg.io/media/games/48c/48cb04ca483be865e3a83119c94e6097.jpg"
          },
          {
              "id": 4,
              "name": "Funny",
              "slug": "funny",
              "language": "eng",
              "games_count": 18531,
              "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
          },
          {
              "id": 189,
              "name": "Female Protagonist",
              "slug": "female-protagonist",
              "language": "eng",
              "games_count": 8207,
              "image_background": "https://media.rawg.io/media/games/b7d/b7d3f1715fa8381a4e780173a197a615.jpg"
          },
          {
              "id": 123,
              "name": "Comedy",
              "slug": "comedy",
              "language": "eng",
              "games_count": 8823,
              "image_background": "https://media.rawg.io/media/games/ffe/ffed87105b14f5beff72ff44a7793fd5.jpg"
          },
          {
              "id": 75,
              "name": "Local Co-Op",
              "slug": "local-co-op",
              "language": "eng",
              "games_count": 4453,
              "image_background": "https://media.rawg.io/media/games/f6f/f6f39c5b56413f7f4513b25989a1b747.jpg"
          },
          {
              "id": 11669,
              "name": "stats",
              "slug": "stats",
              "language": "eng",
              "games_count": 4077,
              "image_background": "https://media.rawg.io/media/games/bff/bff077fb7c3b037bd5ed920bf447c863.jpg"
          },
          {
              "id": 40852,
              "name": "Steam Workshop",
              "slug": "steam-workshop",
              "language": "eng",
              "games_count": 1196,
              "image_background": "https://media.rawg.io/media/games/d58/d588947d4286e7b5e0e12e1bea7d9844.jpg"
          },
          {
              "id": 25,
              "name": "Space",
              "slug": "space",
              "language": "eng",
              "games_count": 36092,
              "image_background": "https://media.rawg.io/media/games/530/5302dd22a190e664531236ca724e8726.jpg"
          },
          {
              "id": 40838,
              "name": "Includes level editor",
              "slug": "includes-level-editor",
              "language": "eng",
              "games_count": 1498,
              "image_background": "https://media.rawg.io/media/games/93e/93ee6101e1c943732f06080dddb0fe4c.jpg"
          },
          {
              "id": 40833,
              "name": "Captions available",
              "slug": "captions-available",
              "language": "eng",
              "games_count": 1146,
              "image_background": "https://media.rawg.io/media/games/226/2262cea0b385db6cf399f4be831603b0.jpg"
          },
          {
              "id": 40834,
              "name": "Commentary available",
              "slug": "commentary-available",
              "language": "eng",
              "games_count": 243,
              "image_background": "https://media.rawg.io/media/games/b7b/b7b8381707152afc7d91f5d95de70e39.jpg"
          },
          {
              "id": 87,
              "name": "Science",
              "slug": "science",
              "language": "eng",
              "games_count": 1306,
              "image_background": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg"
          }
      ],
      "esrb_rating": {
          "id": 2,
          "name": "Everyone 10+",
          "slug": "everyone-10-plus"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg"
          },
          {
              "id": 99018,
              "image": "https://media.rawg.io/media/screenshots/221/221a03c11e5ff9f765d62f60d4b4cbf5.jpg"
          },
          {
              "id": 99019,
              "image": "https://media.rawg.io/media/screenshots/173/1737ff43c14f40294011a209b1012875.jpg"
          },
          {
              "id": 99020,
              "image": "https://media.rawg.io/media/screenshots/b11/b11a2ae0664f0e8a1ef2346f99df26e1.jpg"
          },
          {
              "id": 99021,
              "image": "https://media.rawg.io/media/screenshots/9b1/9b107a790909b31918ebe2f40547cc85.jpg"
          },
          {
              "id": 99022,
              "image": "https://media.rawg.io/media/screenshots/d05/d058fc7f7fa6128916c311eb14267fed.jpg"
          },
          {
              "id": 99023,
              "image": "https://media.rawg.io/media/screenshots/415/41543dcc12dffc8e97d85a56ad42cda8.jpg"
          }
      ]
  },
  {
      "id": 5286,
      "slug": "tomb-raider",
      "name": "Tomb Raider (2013)",
      "released": "2013-03-05",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/021/021c4e21a1824d2526f925eff6324653.jpg",
      "rating": 4.05,
      "rating_top": 4,
      "ratings": [
          {
              "id": 4,
              "title": "recommended",
              "count": 1994,
              "percent": 60.37
          },
          {
              "id": 5,
              "title": "exceptional",
              "count": 839,
              "percent": 25.4
          },
          {
              "id": 3,
              "title": "meh",
              "count": 376,
              "percent": 11.38
          },
          {
              "id": 1,
              "title": "skip",
              "count": 94,
              "percent": 2.85
          }
      ],
      "ratings_count": 3281,
      "reviews_text_count": 10,
      "added": 13569,
      "added_by_status": {
          "yet": 539,
          "owned": 8899,
          "beaten": 3429,
          "toplay": 200,
          "dropped": 407,
          "playing": 95
      },
      "metacritic": 86,
      "playtime": 11,
      "suggestions_count": 630,
      "updated": "2022-04-19T18:00:57",
      "user_game": null,
      "reviews_count": 3303,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 18,
                  "name": "PlayStation 4",
                  "slug": "playstation4",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 6288,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2013-03-05",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 5,
                  "name": "macOS",
                  "slug": "macos",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 91804,
                  "image_background": "https://media.rawg.io/media/games/b54/b54598d1d5cc31899f4f0a7e3122a7b0.jpg"
              },
              "released_at": "2013-03-05",
              "requirements_en": {
                  "minimum": "Minimum:\r\n\r\nOS: macOS 10.9.1\r\n\r\nProcessor: 2.0GHz Intel or greater\r\n\r\nMemory: 4GB\r\n\r\nGraphics: 512Mb AMD 4850, 512Mb Nvidia 650M, Intel HD4000\r\n\r\nHard Drive: 14GB"
              },
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2013-03-05",
              "requirements_en": {
                  "minimum": "<strong>Minimum:</strong><br><ul class=\"bb_ul\"><li><strong>OS:</strong>Windows XP / Windows Vista / Windows 7<br>\t</li><li><strong>Processor:</strong>1.8 GHz Processor<br>\t</li><li><strong>Memory:</strong>512 MB RAM<br>\t</li><li><strong>Graphics:</strong>3D graphics card compatible with DirectX 9<br>\t</li><li><strong>DirectX®:</strong>9.0<br>\t</li><li><strong>Hard Drive:</strong>2 GB HD space</li></ul>"
              },
              "requirements_ru": {
                  "minimum": "i486-100, 8 Мб",
                  "recommended": "Pentium 166, 16 Мб"
              }
          },
          {
              "platform": {
                  "id": 1,
                  "name": "Xbox One",
                  "slug": "xbox-one",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 5216,
                  "image_background": "https://media.rawg.io/media/games/f46/f466571d536f2e3ea9e815ad17177501.jpg"
              },
              "released_at": "2013-03-05",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 14,
                  "name": "Xbox 360",
                  "slug": "xbox360",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 2764,
                  "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
              },
              "released_at": "2013-03-05",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 16,
                  "name": "PlayStation 3",
                  "slug": "playstation3",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 3626,
                  "image_background": "https://media.rawg.io/media/games/490/49016e06ae2103881ff6373248843069.jpg"
              },
              "released_at": "2013-03-05",
              "requirements_en": null,
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 2,
                  "name": "PlayStation",
                  "slug": "playstation"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          },
          {
              "platform": {
                  "id": 5,
                  "name": "Apple Macintosh",
                  "slug": "mac"
              }
          }
      ],
      "genres": [
          {
              "id": 4,
              "name": "Action",
              "slug": "action",
              "games_count": 149659,
              "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
          },
          {
              "id": 3,
              "name": "Adventure",
              "slug": "adventure",
              "games_count": 113029,
              "image_background": "https://media.rawg.io/media/games/9dd/9ddabb34840ea9227556670606cf8ea3.jpg"
          }
      ],
      "stores": [
          {
              "id": 33824,
              "store": {
                  "id": 7,
                  "name": "Xbox 360 Store",
                  "slug": "xbox360",
                  "domain": "marketplace.xbox.com",
                  "games_count": 1917,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 13151,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          },
          {
              "id": 5640,
              "store": {
                  "id": 3,
                  "name": "PlayStation Store",
                  "slug": "playstation-store",
                  "domain": "store.playstation.com",
                  "games_count": 7745,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 218233,
              "store": {
                  "id": 8,
                  "name": "Google Play",
                  "slug": "google-play",
                  "domain": "play.google.com",
                  "games_count": 16824,
                  "image_background": "https://media.rawg.io/media/games/1bd/1bd2657b81eb0c99338120ad444b24ff.jpg"
              }
          },
          {
              "id": 79036,
              "store": {
                  "id": 4,
                  "name": "App Store",
                  "slug": "apple-appstore",
                  "domain": "apps.apple.com",
                  "games_count": 72461,
                  "image_background": "https://media.rawg.io/media/games/7ac/7aca7ccf0e70cd0974cb899ab9e5158e.jpg"
              }
          },
          {
              "id": 713685,
              "store": {
                  "id": 11,
                  "name": "Epic Games",
                  "slug": "epic-games",
                  "domain": "epicgames.com",
                  "games_count": 942,
                  "image_background": "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 31,
              "name": "Singleplayer",
              "slug": "singleplayer",
              "language": "eng",
              "games_count": 162985,
              "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 7,
              "name": "Multiplayer",
              "slug": "multiplayer",
              "language": "eng",
              "games_count": 30873,
              "image_background": "https://media.rawg.io/media/games/8cc/8cce7c0e99dcc43d66c8efd42f9d03e3.jpg"
          },
          {
              "id": 13,
              "name": "Atmospheric",
              "slug": "atmospheric",
              "language": "eng",
              "games_count": 21630,
              "image_background": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg"
          },
          {
              "id": 40836,
              "name": "Full controller support",
              "slug": "full-controller-support",
              "language": "eng",
              "games_count": 11963,
              "image_background": "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg"
          },
          {
              "id": 24,
              "name": "RPG",
              "slug": "rpg",
              "language": "eng",
              "games_count": 14383,
              "image_background": "https://media.rawg.io/media/games/c24/c24ec439abf4a2e92f3429dfa83f7f94.jpg"
          },
          {
              "id": 149,
              "name": "Third Person",
              "slug": "third-person",
              "language": "eng",
              "games_count": 6912,
              "image_background": "https://media.rawg.io/media/games/d69/d69810315bd7e226ea2d21f9156af629.jpg"
          },
          {
              "id": 193,
              "name": "Classic",
              "slug": "classic",
              "language": "eng",
              "games_count": 1676,
              "image_background": "https://media.rawg.io/media/games/4ba/4ba9b4b68ffcc7019b112174883ba4d6.jpg"
          },
          {
              "id": 189,
              "name": "Female Protagonist",
              "slug": "female-protagonist",
              "language": "eng",
              "games_count": 8207,
              "image_background": "https://media.rawg.io/media/games/b7d/b7d3f1715fa8381a4e780173a197a615.jpg"
          },
          {
              "id": 6,
              "name": "Exploration",
              "slug": "exploration",
              "language": "eng",
              "games_count": 15127,
              "image_background": "https://media.rawg.io/media/games/d82/d82990b9c67ba0d2d09d4e6fa88885a7.jpg"
          },
          {
              "id": 15,
              "name": "Stealth",
              "slug": "stealth",
              "language": "eng",
              "games_count": 4855,
              "image_background": "https://media.rawg.io/media/games/15c/15c95a4915f88a3e89c821526afe05fc.jpg"
          },
          {
              "id": 150,
              "name": "Third-Person Shooter",
              "slug": "third-person-shooter",
              "language": "eng",
              "games_count": 2264,
              "image_background": "https://media.rawg.io/media/games/a3c/a3c529a12c896c0ef02db5b4741de2ba.jpg"
          },
          {
              "id": 74,
              "name": "Retro",
              "slug": "retro",
              "language": "eng",
              "games_count": 30872,
              "image_background": "https://media.rawg.io/media/games/abd/abdb7e589f0a8ccd36c0582673120b1e.jpg"
          },
          {
              "id": 69,
              "name": "Action-Adventure",
              "slug": "action-adventure",
              "language": "eng",
              "games_count": 10881,
              "image_background": "https://media.rawg.io/media/games/2ad/2ad87a4a69b1104f02435c14c5196095.jpg"
          },
          {
              "id": 110,
              "name": "Cinematic",
              "slug": "cinematic",
              "language": "eng",
              "games_count": 896,
              "image_background": "https://media.rawg.io/media/games/569/56978b5a77f13aa2ec5d09ec81d01cad.jpg"
          },
          {
              "id": 269,
              "name": "Quick-Time Events",
              "slug": "quick-time-events",
              "language": "eng",
              "games_count": 248,
              "image_background": "https://media.rawg.io/media/screenshots/59e/59e83c7c485f9915205dd23ced6c0b12.jpg"
          },
          {
              "id": 126,
              "name": "Dinosaurs",
              "slug": "dinosaurs",
              "language": "eng",
              "games_count": 1424,
              "image_background": "https://media.rawg.io/media/screenshots/dbb/dbbedafecf59e1f1f19464f0d2033eba.jpg"
          },
          {
              "id": 306,
              "name": "Lara Croft",
              "slug": "lara-croft",
              "language": "eng",
              "games_count": 14,
              "image_background": "https://media.rawg.io/media/games/e6b/e6b025951f9a72673f41c0588fb85758.jpg"
          }
      ],
      "esrb_rating": {
          "id": 4,
          "name": "Mature",
          "slug": "mature"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/021/021c4e21a1824d2526f925eff6324653.jpg"
          },
          {
              "id": 99160,
              "image": "https://media.rawg.io/media/screenshots/4f9/4f9d5efdecfb63cb99f1baa4c0ceb3bf.jpg"
          },
          {
              "id": 99161,
              "image": "https://media.rawg.io/media/screenshots/80f/80f373082b2a74da3f9c3fe2b877dcd0.jpg"
          },
          {
              "id": 99162,
              "image": "https://media.rawg.io/media/screenshots/a87/a8733e877f8fbe45e4a727c22a06aa2e.jpg"
          },
          {
              "id": 99163,
              "image": "https://media.rawg.io/media/screenshots/3f9/3f91678c6805a76419fa4ea3a045a909.jpg"
          },
          {
              "id": 99164,
              "image": "https://media.rawg.io/media/screenshots/417/4170bf07be43a8d8249193883f87f1c1.jpg"
          },
          {
              "id": 99165,
              "image": "https://media.rawg.io/media/screenshots/2a4/2a4250f83ad9e959d8b4ca9376ae34ea.jpg"
          }
      ]
  },
  {
      "id": 5679,
      "slug": "the-elder-scrolls-v-skyrim",
      "name": "The Elder Scrolls V: Skyrim",
      "released": "2011-11-11",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/7cf/7cfc9220b401b7a300e409e539c9afd5.jpg",
      "rating": 4.42,
      "rating_top": 5,
      "ratings": [
          {
              "id": 5,
              "title": "exceptional",
              "count": 2244,
              "percent": 57.29
          },
          {
              "id": 4,
              "title": "recommended",
              "count": 1240,
              "percent": 31.66
          },
          {
              "id": 3,
              "title": "meh",
              "count": 350,
              "percent": 8.94
          },
          {
              "id": 1,
              "title": "skip",
              "count": 83,
              "percent": 2.12
          }
      ],
      "ratings_count": 3885,
      "reviews_text_count": 22,
      "added": 13155,
      "added_by_status": {
          "yet": 419,
          "owned": 8019,
          "beaten": 3026,
          "toplay": 319,
          "dropped": 1042,
          "playing": 330
      },
      "metacritic": 94,
      "playtime": 46,
      "suggestions_count": 591,
      "updated": "2020-07-06T04:26:04",
      "user_game": null,
      "reviews_count": 3917,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2011-11-11",
              "requirements_en": {
                  "minimum": "<strong>Minimum:</strong><br>\t\t\t\t\t\t\t\t<ul class=\"bb_ul\"><li><strong>OS:</strong> Windows 7/Vista/XP PC (32 or 64 bit)<br>\t\t\t\t\t\t\t\t</li><li><strong>Processor:</strong> Dual Core 2.0GHz or equivalent processor<br>\t\t\t\t\t\t\t\t</li><li><strong>Memory:</strong> 2GB System RAM<br>\t\t\t\t\t\t\t\t</li><li><strong>Hard Disk Space:</strong> 6GB free HDD Space<br>\t\t\t\t\t\t\t\t</li><li><strong>Video Card:</strong> Direct X 9.0c compliant video card with 512 MB of RAM<br>\t\t\t\t\t\t\t\t</li><li><strong>Sound:</strong> DirectX compatible sound card<br>\t\t\t\t\t\t\t\t</li></ul>",
                  "recommended": "<strong>Recommended:</strong><br>\t\t\t\t\t\t\t\t<ul class=\"bb_ul\"><li><strong>Processor:</strong> Quad-core Intel or AMD CPU<br>\t\t\t\t\t\t\t\t</li><li><strong>Memory:</strong> 4GB System RAM<br>\t\t\t\t\t\t\t\t</li><li><strong>Video Card:</strong> DirectX 9.0c compatible NVIDIA or AMD ATI video card with 1GB of RAM (Nvidia GeForce GTX 260 or higher; ATI Radeon 4890 or higher)<br>\t\t\t\t\t\t\t\t</li></ul>"
              },
              "requirements_ru": {
                  "minimum": "Core 2 Duo/Athlon X2 2 ГГц,2 Гб памяти,GeForce 8800/Radeon X1900,6 Гб на винчестере",
                  "recommended": "Core 2 Quad/Phenom X4 2.5 ГГц,4 Гб памяти,GeForce GTX 260/Radeon HD 4890,6 Гб на винчестере"
              }
          },
          {
              "platform": {
                  "id": 7,
                  "name": "Nintendo Switch",
                  "slug": "nintendo-switch",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 4771,
                  "image_background": "https://media.rawg.io/media/games/7cf/7cfc9220b401b7a300e409e539c9afd5.jpg"
              },
              "released_at": "2011-11-11",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 14,
                  "name": "Xbox 360",
                  "slug": "xbox360",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 2764,
                  "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
              },
              "released_at": "2011-11-11",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 16,
                  "name": "PlayStation 3",
                  "slug": "playstation3",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 3626,
                  "image_background": "https://media.rawg.io/media/games/490/49016e06ae2103881ff6373248843069.jpg"
              },
              "released_at": "2011-11-11",
              "requirements_en": null,
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 2,
                  "name": "PlayStation",
                  "slug": "playstation"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          },
          {
              "platform": {
                  "id": 7,
                  "name": "Nintendo",
                  "slug": "nintendo"
              }
          }
      ],
      "genres": [
          {
              "id": 4,
              "name": "Action",
              "slug": "action",
              "games_count": 149659,
              "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
          },
          {
              "id": 5,
              "name": "RPG",
              "slug": "role-playing-games-rpg",
              "games_count": 45874,
              "image_background": "https://media.rawg.io/media/games/995/9951d9d55323d08967640f7b9ab3e342.jpg"
          }
      ],
      "stores": [
          {
              "id": 6037,
              "store": {
                  "id": 3,
                  "name": "PlayStation Store",
                  "slug": "playstation-store",
                  "domain": "store.playstation.com",
                  "games_count": 7745,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 15144,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          },
          {
              "id": 32919,
              "store": {
                  "id": 6,
                  "name": "Nintendo Store",
                  "slug": "nintendo",
                  "domain": "nintendo.com",
                  "games_count": 8825,
                  "image_background": "https://media.rawg.io/media/games/b72/b7233d5d5b1e75e86bb860ccc7aeca85.jpg"
              }
          },
          {
              "id": 49792,
              "store": {
                  "id": 7,
                  "name": "Xbox 360 Store",
                  "slug": "xbox360",
                  "domain": "marketplace.xbox.com",
                  "games_count": 1917,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 31,
              "name": "Singleplayer",
              "slug": "singleplayer",
              "language": "eng",
              "games_count": 162985,
              "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 40847,
              "name": "Steam Achievements",
              "slug": "steam-achievements",
              "language": "eng",
              "games_count": 25765,
              "image_background": "https://media.rawg.io/media/games/4ba/4ba9b4b68ffcc7019b112174883ba4d6.jpg"
          },
          {
              "id": 7808,
              "name": "steam-trading-cards",
              "slug": "steam-trading-cards",
              "language": "eng",
              "games_count": 7582,
              "image_background": "https://media.rawg.io/media/games/4cf/4cfc6b7f1850590a4634b08bfab308ab.jpg"
          },
          {
              "id": 13,
              "name": "Atmospheric",
              "slug": "atmospheric",
              "language": "eng",
              "games_count": 21630,
              "image_background": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg"
          },
          {
              "id": 40849,
              "name": "Steam Cloud",
              "slug": "steam-cloud",
              "language": "eng",
              "games_count": 11732,
              "image_background": "https://media.rawg.io/media/games/c6b/c6bfece1daf8d06bc0a60632ac78e5bf.jpg"
          },
          {
              "id": 42,
              "name": "Great Soundtrack",
              "slug": "great-soundtrack",
              "language": "eng",
              "games_count": 3202,
              "image_background": "https://media.rawg.io/media/games/b7b/b7b8381707152afc7d91f5d95de70e39.jpg"
          },
          {
              "id": 24,
              "name": "RPG",
              "slug": "rpg",
              "language": "eng",
              "games_count": 14383,
              "image_background": "https://media.rawg.io/media/games/c24/c24ec439abf4a2e92f3429dfa83f7f94.jpg"
          },
          {
              "id": 118,
              "name": "Story Rich",
              "slug": "story-rich",
              "language": "eng",
              "games_count": 14512,
              "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
          },
          {
              "id": 36,
              "name": "Open World",
              "slug": "open-world",
              "language": "eng",
              "games_count": 5045,
              "image_background": "https://media.rawg.io/media/games/6cd/6cd653e0aaef5ff8bbd295bf4bcb12eb.jpg"
          },
          {
              "id": 8,
              "name": "First-Person",
              "slug": "first-person",
              "language": "eng",
              "games_count": 21101,
              "image_background": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg"
          },
          {
              "id": 149,
              "name": "Third Person",
              "slug": "third-person",
              "language": "eng",
              "games_count": 6912,
              "image_background": "https://media.rawg.io/media/games/d69/d69810315bd7e226ea2d21f9156af629.jpg"
          },
          {
              "id": 40845,
              "name": "Partial Controller Support",
              "slug": "partial-controller-support",
              "language": "eng",
              "games_count": 8369,
              "image_background": "https://media.rawg.io/media/games/c80/c80bcf321da44d69b18a06c04d942662.jpg"
          },
          {
              "id": 64,
              "name": "Fantasy",
              "slug": "fantasy",
              "language": "eng",
              "games_count": 19249,
              "image_background": "https://media.rawg.io/media/games/59a/59a3ebcba3d08c51532c6ca877aff256.jpg"
          },
          {
              "id": 37,
              "name": "Sandbox",
              "slug": "sandbox",
              "language": "eng",
              "games_count": 4817,
              "image_background": "https://media.rawg.io/media/games/48c/48cb04ca483be865e3a83119c94e6097.jpg"
          },
          {
              "id": 97,
              "name": "Action RPG",
              "slug": "action-rpg",
              "language": "eng",
              "games_count": 4647,
              "image_background": "https://media.rawg.io/media/games/83f/83f6f70a7c1b86cd2637b029d8b42caa.jpg"
          },
          {
              "id": 40852,
              "name": "Steam Workshop",
              "slug": "steam-workshop",
              "language": "eng",
              "games_count": 1196,
              "image_background": "https://media.rawg.io/media/games/d58/d588947d4286e7b5e0e12e1bea7d9844.jpg"
          },
          {
              "id": 62,
              "name": "Moddable",
              "slug": "moddable",
              "language": "eng",
              "games_count": 679,
              "image_background": "https://media.rawg.io/media/games/4a0/4a0a1316102366260e6f38fd2a9cfdce.jpg"
          },
          {
              "id": 468,
              "name": "role-playing",
              "slug": "role-playing",
              "language": "eng",
              "games_count": 1337,
              "image_background": "https://media.rawg.io/media/games/c40/c40f9f0a3d1b4601a7a44d230c95f126.jpg"
          },
          {
              "id": 121,
              "name": "Character Customization",
              "slug": "character-customization",
              "language": "eng",
              "games_count": 2473,
              "image_background": "https://media.rawg.io/media/games/260/26023c855f1769a93411d6a7ea084632.jpeg"
          },
          {
              "id": 40,
              "name": "Dark Fantasy",
              "slug": "dark-fantasy",
              "language": "eng",
              "games_count": 2400,
              "image_background": "https://media.rawg.io/media/games/21a/21ad672cedee9b4378abb6c2d2e626ee.jpg"
          },
          {
              "id": 66,
              "name": "Medieval",
              "slug": "medieval",
              "language": "eng",
              "games_count": 4081,
              "image_background": "https://media.rawg.io/media/games/d8f/d8f3b28fc747ed6f92943cdd33fb91b5.jpeg"
          },
          {
              "id": 82,
              "name": "Magic",
              "slug": "magic",
              "language": "eng",
              "games_count": 6533,
              "image_background": "https://media.rawg.io/media/games/3c3/3c363e31f4add887affadc82c641de72.jpg"
          },
          {
              "id": 205,
              "name": "Lore-Rich",
              "slug": "lore-rich",
              "language": "eng",
              "games_count": 454,
              "image_background": "https://media.rawg.io/media/screenshots/bf0/bf08a4fb21df12939e94782ccfa7a858.jpg"
          },
          {
              "id": 215,
              "name": "Dragons",
              "slug": "dragons",
              "language": "eng",
              "games_count": 2129,
              "image_background": "https://media.rawg.io/media/games/c81/c812e158129e00c9b0f096ae8a0bb7d6.jpg"
          }
      ],
      "esrb_rating": {
          "id": 4,
          "name": "Mature",
          "slug": "mature"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/7cf/7cfc9220b401b7a300e409e539c9afd5.jpg"
          },
          {
              "id": 118307,
              "image": "https://media.rawg.io/media/screenshots/3bd/3bd2710bd1ffb6664fdea7b83afd067e.jpg"
          },
          {
              "id": 118308,
              "image": "https://media.rawg.io/media/screenshots/d4e/d4e9b13f54748584ccbd6f998094dade.jpg"
          },
          {
              "id": 118309,
              "image": "https://media.rawg.io/media/screenshots/599/59946a630e9c7871003763d63184404a.jpg"
          },
          {
              "id": 118310,
              "image": "https://media.rawg.io/media/screenshots/c5d/c5dad426038d7d12f933eedbeab48ff3.jpg"
          },
          {
              "id": 118311,
              "image": "https://media.rawg.io/media/screenshots/b32/b326fa01c82db82edd41ed299886ee44.jpg"
          },
          {
              "id": 118312,
              "image": "https://media.rawg.io/media/screenshots/091/091e95b49d5a22de036698fc731395a2.jpg"
          }
      ]
  },
  {
      "id": 4291,
      "slug": "counter-strike-global-offensive",
      "name": "Counter-Strike: Global Offensive",
      "released": "2012-08-21",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/736/73619bd336c894d6941d926bfd563946.jpg",
      "rating": 3.57,
      "rating_top": 4,
      "ratings": [
          {
              "id": 4,
              "title": "recommended",
              "count": 1331,
              "percent": 47.1
          },
          {
              "id": 3,
              "title": "meh",
              "count": 746,
              "percent": 26.4
          },
          {
              "id": 5,
              "title": "exceptional",
              "count": 445,
              "percent": 15.75
          },
          {
              "id": 1,
              "title": "skip",
              "count": 304,
              "percent": 10.76
          }
      ],
      "ratings_count": 2801,
      "reviews_text_count": 19,
      "added": 13025,
      "added_by_status": {
          "yet": 211,
          "owned": 9954,
          "beaten": 744,
          "toplay": 64,
          "dropped": 1511,
          "playing": 541
      },
      "metacritic": 81,
      "playtime": 64,
      "suggestions_count": 588,
      "updated": "2020-08-07T06:18:15",
      "user_game": null,
      "reviews_count": 2826,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2012-08-21",
              "requirements_en": {
                  "minimum": "<strong>Minimum:</strong><br><ul class=\"bb_ul\"><li><strong>OS:</strong> Windows® 7/Vista/XP<br></li><li><strong>Processor:</strong> Intel® Core™ 2 Duo E6600 or AMD Phenom™ X3 8750 processor or better<br></li><li><strong>Memory:</strong> 2 GB RAM<br></li><li><strong>Graphics:</strong> Video card must be 256 MB or more and should be a DirectX 9-compatible with support for Pixel Shader 3.0<br></li><li><strong>DirectX:</strong> Version 9.0c<br></li><li><strong>Storage:</strong> 15 GB available space</li></ul>"
              },
              "requirements_ru": {
                  "minimum": "Сore 2 Duo/Athlon x2 64 1.8 ГГц,2 Гб памяти,GeForce 8800/Radeon X9800,7.6 Гб на винчестере,интернет-соединение",
                  "recommended": "Core 2 Duo E6600/Phenom X3 8750,4 Гб памяти,GeForce 480 GTX/Radeon HD 6970,7.6 Гб на винчестере,интернет-соединение"
              }
          },
          {
              "platform": {
                  "id": 14,
                  "name": "Xbox 360",
                  "slug": "xbox360",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 2764,
                  "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
              },
              "released_at": "2012-08-21",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 16,
                  "name": "PlayStation 3",
                  "slug": "playstation3",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 3626,
                  "image_background": "https://media.rawg.io/media/games/490/49016e06ae2103881ff6373248843069.jpg"
              },
              "released_at": "2012-08-21",
              "requirements_en": null,
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 2,
                  "name": "PlayStation",
                  "slug": "playstation"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          }
      ],
      "genres": [
          {
              "id": 4,
              "name": "Action",
              "slug": "action",
              "games_count": 149659,
              "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
          },
          {
              "id": 2,
              "name": "Shooter",
              "slug": "shooter",
              "games_count": 51719,
              "image_background": "https://media.rawg.io/media/games/9fa/9fa63622543e5d4f6d99aa9d73b043de.jpg"
          }
      ],
      "stores": [
          {
              "id": 4619,
              "store": {
                  "id": 3,
                  "name": "PlayStation Store",
                  "slug": "playstation-store",
                  "domain": "store.playstation.com",
                  "games_count": 7745,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 11489,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          },
          {
              "id": 49169,
              "store": {
                  "id": 7,
                  "name": "Xbox 360 Store",
                  "slug": "xbox360",
                  "domain": "marketplace.xbox.com",
                  "games_count": 1917,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 40847,
              "name": "Steam Achievements",
              "slug": "steam-achievements",
              "language": "eng",
              "games_count": 25765,
              "image_background": "https://media.rawg.io/media/games/4ba/4ba9b4b68ffcc7019b112174883ba4d6.jpg"
          },
          {
              "id": 7,
              "name": "Multiplayer",
              "slug": "multiplayer",
              "language": "eng",
              "games_count": 30873,
              "image_background": "https://media.rawg.io/media/games/8cc/8cce7c0e99dcc43d66c8efd42f9d03e3.jpg"
          },
          {
              "id": 7808,
              "name": "steam-trading-cards",
              "slug": "steam-trading-cards",
              "language": "eng",
              "games_count": 7582,
              "image_background": "https://media.rawg.io/media/games/4cf/4cfc6b7f1850590a4634b08bfab308ab.jpg"
          },
          {
              "id": 40836,
              "name": "Full controller support",
              "slug": "full-controller-support",
              "language": "eng",
              "games_count": 11963,
              "image_background": "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg"
          },
          {
              "id": 18,
              "name": "Co-op",
              "slug": "co-op",
              "language": "eng",
              "games_count": 8306,
              "image_background": "https://media.rawg.io/media/games/ec3/ec3a7db7b8ab5a71aad622fe7c62632f.jpg"
          },
          {
              "id": 411,
              "name": "cooperative",
              "slug": "cooperative",
              "language": "eng",
              "games_count": 3372,
              "image_background": "https://media.rawg.io/media/games/f87/f87457e8347484033cb34cde6101d08d.jpg"
          },
          {
              "id": 8,
              "name": "First-Person",
              "slug": "first-person",
              "language": "eng",
              "games_count": 21101,
              "image_background": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg"
          },
          {
              "id": 30,
              "name": "FPS",
              "slug": "fps",
              "language": "eng",
              "games_count": 10374,
              "image_background": "https://media.rawg.io/media/games/26d/26d4437715bee60138dab4a7c8c59c92.jpg"
          },
          {
              "id": 9,
              "name": "Online Co-Op",
              "slug": "online-co-op",
              "language": "eng",
              "games_count": 3482,
              "image_background": "https://media.rawg.io/media/games/48c/48cb04ca483be865e3a83119c94e6097.jpg"
          },
          {
              "id": 80,
              "name": "Tactical",
              "slug": "tactical",
              "language": "eng",
              "games_count": 3179,
              "image_background": "https://media.rawg.io/media/games/238/2383a172b4d50a7b44e07980eb7141ea.jpg"
          },
          {
              "id": 11669,
              "name": "stats",
              "slug": "stats",
              "language": "eng",
              "games_count": 4077,
              "image_background": "https://media.rawg.io/media/games/bff/bff077fb7c3b037bd5ed920bf447c863.jpg"
          },
          {
              "id": 40852,
              "name": "Steam Workshop",
              "slug": "steam-workshop",
              "language": "eng",
              "games_count": 1196,
              "image_background": "https://media.rawg.io/media/games/d58/d588947d4286e7b5e0e12e1bea7d9844.jpg"
          },
          {
              "id": 62,
              "name": "Moddable",
              "slug": "moddable",
              "language": "eng",
              "games_count": 679,
              "image_background": "https://media.rawg.io/media/games/4a0/4a0a1316102366260e6f38fd2a9cfdce.jpg"
          },
          {
              "id": 157,
              "name": "PvP",
              "slug": "pvp",
              "language": "eng",
              "games_count": 5486,
              "image_background": "https://media.rawg.io/media/games/569/56978b5a77f13aa2ec5d09ec81d01cad.jpg"
          },
          {
              "id": 70,
              "name": "War",
              "slug": "war",
              "language": "eng",
              "games_count": 7754,
              "image_background": "https://media.rawg.io/media/games/1e5/1e5e33b88be978f451196a751424a72e.jpg"
          },
          {
              "id": 40837,
              "name": "In-App Purchases",
              "slug": "in-app-purchases",
              "language": "eng",
              "games_count": 1679,
              "image_background": "https://media.rawg.io/media/games/26b/26b27e1da9e3727fcb12e3e4e86c8c19.jpg"
          },
          {
              "id": 11,
              "name": "Team-Based",
              "slug": "team-based",
              "language": "eng",
              "games_count": 1000,
              "image_background": "https://media.rawg.io/media/games/0fa/0fadc446fd1e9ae9e23a32793d9a5406.jpg"
          },
          {
              "id": 131,
              "name": "Fast-Paced",
              "slug": "fast-paced",
              "language": "eng",
              "games_count": 9049,
              "image_background": "https://media.rawg.io/media/games/736/73619bd336c894d6941d926bfd563946.jpg"
          },
          {
              "id": 40856,
              "name": "Valve Anti-Cheat enabled",
              "slug": "valve-anti-cheat-enabled",
              "language": "eng",
              "games_count": 104,
              "image_background": "https://media.rawg.io/media/games/736/73619bd336c894d6941d926bfd563946.jpg"
          },
          {
              "id": 77,
              "name": "Realistic",
              "slug": "realistic",
              "language": "eng",
              "games_count": 2490,
              "image_background": "https://media.rawg.io/media/games/511/5115617b4180a4e4505e0de09e62c6a0.jpg"
          },
          {
              "id": 81,
              "name": "Military",
              "slug": "military",
              "language": "eng",
              "games_count": 987,
              "image_background": "https://media.rawg.io/media/games/ac7/ac7b8327343da12c971cfc418f390a11.jpg"
          },
          {
              "id": 170,
              "name": "Competitive",
              "slug": "competitive",
              "language": "eng",
              "games_count": 896,
              "image_background": "https://media.rawg.io/media/screenshots/69b/69bb243ea9896ddfc2e051b58e81624d.jpg"
          },
          {
              "id": 73,
              "name": "e-sports",
              "slug": "e-sports",
              "language": "eng",
              "games_count": 80,
              "image_background": "https://media.rawg.io/media/screenshots/316/31651e0ec39c6718c5136ab624431e7f.jpg"
          },
          {
              "id": 245,
              "name": "Trading",
              "slug": "trading",
              "language": "eng",
              "games_count": 844,
              "image_background": "https://media.rawg.io/media/games/099/09958b7676fce13f46b59b56154e23cd.jpg"
          }
      ],
      "esrb_rating": {
          "id": 4,
          "name": "Mature",
          "slug": "mature"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/736/73619bd336c894d6941d926bfd563946.jpg"
          },
          {
              "id": 81644,
              "image": "https://media.rawg.io/media/screenshots/ff1/ff16661bb15f7969b44f6c4118870e44.jpg"
          },
          {
              "id": 81645,
              "image": "https://media.rawg.io/media/screenshots/41b/41bb769d247412eac3336dec934aed72.jpg"
          },
          {
              "id": 81646,
              "image": "https://media.rawg.io/media/screenshots/754/754545acdbf71f56e8902a07c7d20696.jpg"
          },
          {
              "id": 81647,
              "image": "https://media.rawg.io/media/screenshots/fd8/fd873cab4c66db0b8e85d8a66e940074.jpg"
          },
          {
              "id": 81648,
              "image": "https://media.rawg.io/media/screenshots/7db/7db2954f7908b6749c36a5f3c9052f65.jpg"
          },
          {
              "id": 81649,
              "image": "https://media.rawg.io/media/screenshots/337/337a3e98b5933f456a2b37b59fab5f39.jpg"
          }
      ]
  },
  {
      "id": 12020,
      "slug": "left-4-dead-2",
      "name": "Left 4 Dead 2",
      "released": "2009-11-17",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/d58/d588947d4286e7b5e0e12e1bea7d9844.jpg",
      "rating": 4.09,
      "rating_top": 4,
      "ratings": [
          {
              "id": 4,
              "title": "recommended",
              "count": 1450,
              "percent": 53.15
          },
          {
              "id": 5,
              "title": "exceptional",
              "count": 857,
              "percent": 31.41
          },
          {
              "id": 3,
              "title": "meh",
              "count": 323,
              "percent": 11.84
          },
          {
              "id": 1,
              "title": "skip",
              "count": 98,
              "percent": 3.59
          }
      ],
      "ratings_count": 2713,
      "reviews_text_count": 8,
      "added": 12907,
      "added_by_status": {
          "yet": 331,
          "owned": 9482,
          "beaten": 2010,
          "toplay": 79,
          "dropped": 883,
          "playing": 122
      },
      "metacritic": 89,
      "playtime": 9,
      "suggestions_count": 583,
      "updated": "2021-11-24T08:44:34",
      "user_game": null,
      "reviews_count": 2728,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 5,
                  "name": "macOS",
                  "slug": "macos",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 91804,
                  "image_background": "https://media.rawg.io/media/games/b54/b54598d1d5cc31899f4f0a7e3122a7b0.jpg"
              },
              "released_at": "2009-11-17",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 6,
                  "name": "Linux",
                  "slug": "linux",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 66467,
                  "image_background": "https://media.rawg.io/media/games/d69/d69810315bd7e226ea2d21f9156af629.jpg"
              },
              "released_at": "2009-11-17",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2009-11-17",
              "requirements_en": {
                  "minimum": "<strong>Minimum:</strong><br><ul class=\"bb_ul\"><li><strong>OS:</strong> Windows® 7 32/64-bit / Vista 32/64 / XP<br></li><li><strong>Processor:</strong> Pentium 4 3.0GHz<br></li><li><strong>Memory:</strong> 2 GB RAM<br></li><li><strong>Graphics:</strong> Video card with 128 MB, Shader model 2.0. ATI X800, NVidia 6600 or better<br></li><li><strong>DirectX:</strong> Version 9.0c<br></li><li><strong>Storage:</strong> 13 GB available space<br></li><li><strong>Sound Card:</strong> DirectX 9.0c compatible sound card</li></ul>",
                  "recommended": "<strong>Recommended:</strong><br><ul class=\"bb_ul\"><li><strong>OS:</strong> Windows® 7 32/64-bit / Vista 32/64 / XP<br></li><li><strong>Processor:</strong> Intel core 2 duo 2.4GHz<br></li><li><strong>Memory:</strong> 2 GB RAM<br></li><li><strong>Graphics:</strong> Video Card Shader model 3.0. NVidia 7600, ATI X1600 or better<br></li><li><strong>DirectX:</strong> Version 9.0c<br></li><li><strong>Storage:</strong> 13 GB available space<br></li><li><strong>Sound Card:</strong> DirectX 9.0c compatible sound card</li></ul>"
              },
              "requirements_ru": {
                  "minimum": "Pentium 4/Athlon 64 3 ГГц,1 Гб памяти,GeForce 6600/Radeon X800,7.5 Гб на винчестере",
                  "recommended": "Core 2 Duo/Athlon 64 X2 2.4 ГГц,2 Гб памяти,GeForce 7600/Radeon X1600,7.5 Гб на винчестере"
              }
          },
          {
              "platform": {
                  "id": 14,
                  "name": "Xbox 360",
                  "slug": "xbox360",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 2764,
                  "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
              },
              "released_at": "2009-11-17",
              "requirements_en": null,
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          },
          {
              "platform": {
                  "id": 5,
                  "name": "Apple Macintosh",
                  "slug": "mac"
              }
          },
          {
              "platform": {
                  "id": 6,
                  "name": "Linux",
                  "slug": "linux"
              }
          }
      ],
      "genres": [
          {
              "id": 4,
              "name": "Action",
              "slug": "action",
              "games_count": 149659,
              "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
          },
          {
              "id": 2,
              "name": "Shooter",
              "slug": "shooter",
              "games_count": 51719,
              "image_background": "https://media.rawg.io/media/games/9fa/9fa63622543e5d4f6d99aa9d73b043de.jpg"
          }
      ],
      "stores": [
          {
              "id": 13208,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          },
          {
              "id": 34000,
              "store": {
                  "id": 7,
                  "name": "Xbox 360 Store",
                  "slug": "xbox360",
                  "domain": "marketplace.xbox.com",
                  "games_count": 1917,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 31,
              "name": "Singleplayer",
              "slug": "singleplayer",
              "language": "eng",
              "games_count": 162985,
              "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 40847,
              "name": "Steam Achievements",
              "slug": "steam-achievements",
              "language": "eng",
              "games_count": 25765,
              "image_background": "https://media.rawg.io/media/games/4ba/4ba9b4b68ffcc7019b112174883ba4d6.jpg"
          },
          {
              "id": 7,
              "name": "Multiplayer",
              "slug": "multiplayer",
              "language": "eng",
              "games_count": 30873,
              "image_background": "https://media.rawg.io/media/games/8cc/8cce7c0e99dcc43d66c8efd42f9d03e3.jpg"
          },
          {
              "id": 7808,
              "name": "steam-trading-cards",
              "slug": "steam-trading-cards",
              "language": "eng",
              "games_count": 7582,
              "image_background": "https://media.rawg.io/media/games/4cf/4cfc6b7f1850590a4634b08bfab308ab.jpg"
          },
          {
              "id": 40849,
              "name": "Steam Cloud",
              "slug": "steam-cloud",
              "language": "eng",
              "games_count": 11732,
              "image_background": "https://media.rawg.io/media/games/c6b/c6bfece1daf8d06bc0a60632ac78e5bf.jpg"
          },
          {
              "id": 40836,
              "name": "Full controller support",
              "slug": "full-controller-support",
              "language": "eng",
              "games_count": 11963,
              "image_background": "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg"
          },
          {
              "id": 18,
              "name": "Co-op",
              "slug": "co-op",
              "language": "eng",
              "games_count": 8306,
              "image_background": "https://media.rawg.io/media/games/ec3/ec3a7db7b8ab5a71aad622fe7c62632f.jpg"
          },
          {
              "id": 411,
              "name": "cooperative",
              "slug": "cooperative",
              "language": "eng",
              "games_count": 3372,
              "image_background": "https://media.rawg.io/media/games/f87/f87457e8347484033cb34cde6101d08d.jpg"
          },
          {
              "id": 8,
              "name": "First-Person",
              "slug": "first-person",
              "language": "eng",
              "games_count": 21101,
              "image_background": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg"
          },
          {
              "id": 16,
              "name": "Horror",
              "slug": "horror",
              "language": "eng",
              "games_count": 32483,
              "image_background": "https://media.rawg.io/media/games/e6d/e6de699bd788497f4b52e2f41f9698f2.jpg"
          },
          {
              "id": 30,
              "name": "FPS",
              "slug": "fps",
              "language": "eng",
              "games_count": 10374,
              "image_background": "https://media.rawg.io/media/games/26d/26d4437715bee60138dab4a7c8c59c92.jpg"
          },
          {
              "id": 9,
              "name": "Online Co-Op",
              "slug": "online-co-op",
              "language": "eng",
              "games_count": 3482,
              "image_background": "https://media.rawg.io/media/games/48c/48cb04ca483be865e3a83119c94e6097.jpg"
          },
          {
              "id": 26,
              "name": "Gore",
              "slug": "gore",
              "language": "eng",
              "games_count": 4411,
              "image_background": "https://media.rawg.io/media/games/d58/d588947d4286e7b5e0e12e1bea7d9844.jpg"
          },
          {
              "id": 1,
              "name": "Survival",
              "slug": "survival",
              "language": "eng",
              "games_count": 5948,
              "image_background": "https://media.rawg.io/media/games/476/476178ef18ab0534771d099f51cdc694.jpg"
          },
          {
              "id": 75,
              "name": "Local Co-Op",
              "slug": "local-co-op",
              "language": "eng",
              "games_count": 4453,
              "image_background": "https://media.rawg.io/media/games/f6f/f6f39c5b56413f7f4513b25989a1b747.jpg"
          },
          {
              "id": 80,
              "name": "Tactical",
              "slug": "tactical",
              "language": "eng",
              "games_count": 3179,
              "image_background": "https://media.rawg.io/media/games/238/2383a172b4d50a7b44e07980eb7141ea.jpg"
          },
          {
              "id": 11669,
              "name": "stats",
              "slug": "stats",
              "language": "eng",
              "games_count": 4077,
              "image_background": "https://media.rawg.io/media/games/bff/bff077fb7c3b037bd5ed920bf447c863.jpg"
          },
          {
              "id": 40852,
              "name": "Steam Workshop",
              "slug": "steam-workshop",
              "language": "eng",
              "games_count": 1196,
              "image_background": "https://media.rawg.io/media/games/d58/d588947d4286e7b5e0e12e1bea7d9844.jpg"
          },
          {
              "id": 63,
              "name": "Zombies",
              "slug": "zombies",
              "language": "eng",
              "games_count": 8465,
              "image_background": "https://media.rawg.io/media/games/4cb/4cb463b5588adc672124fb041f09e91c.jpg"
          },
          {
              "id": 62,
              "name": "Moddable",
              "slug": "moddable",
              "language": "eng",
              "games_count": 679,
              "image_background": "https://media.rawg.io/media/games/4a0/4a0a1316102366260e6f38fd2a9cfdce.jpg"
          },
          {
              "id": 43,
              "name": "Post-apocalyptic",
              "slug": "post-apocalyptic",
              "language": "eng",
              "games_count": 2587,
              "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
          },
          {
              "id": 40833,
              "name": "Captions available",
              "slug": "captions-available",
              "language": "eng",
              "games_count": 1146,
              "image_background": "https://media.rawg.io/media/games/226/2262cea0b385db6cf399f4be831603b0.jpg"
          },
          {
              "id": 5,
              "name": "Replay Value",
              "slug": "replay-value",
              "language": "eng",
              "games_count": 1084,
              "image_background": "https://media.rawg.io/media/games/6d3/6d33014a4ed48a19c30a77ead5a0f62e.jpg"
          },
          {
              "id": 17,
              "name": "Survival Horror",
              "slug": "survival-horror",
              "language": "eng",
              "games_count": 6148,
              "image_background": "https://media.rawg.io/media/games/d64/d646810b629081cc12aec49ed9f49441.jpg"
          },
          {
              "id": 11,
              "name": "Team-Based",
              "slug": "team-based",
              "language": "eng",
              "games_count": 1000,
              "image_background": "https://media.rawg.io/media/games/0fa/0fadc446fd1e9ae9e23a32793d9a5406.jpg"
          },
          {
              "id": 40856,
              "name": "Valve Anti-Cheat enabled",
              "slug": "valve-anti-cheat-enabled",
              "language": "eng",
              "games_count": 104,
              "image_background": "https://media.rawg.io/media/games/736/73619bd336c894d6941d926bfd563946.jpg"
          },
          {
              "id": 40834,
              "name": "Commentary available",
              "slug": "commentary-available",
              "language": "eng",
              "games_count": 243,
              "image_background": "https://media.rawg.io/media/games/b7b/b7b8381707152afc7d91f5d95de70e39.jpg"
          },
          {
              "id": 40839,
              "name": "Includes Source SDK",
              "slug": "includes-source-sdk",
              "language": "eng",
              "games_count": 55,
              "image_background": "https://media.rawg.io/media/screenshots/4e5/4e5e71d53468bcf5d6686c46fec95d78.jpg"
          }
      ],
      "esrb_rating": {
          "id": 4,
          "name": "Mature",
          "slug": "mature"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/d58/d588947d4286e7b5e0e12e1bea7d9844.jpg"
          },
          {
              "id": 99748,
              "image": "https://media.rawg.io/media/screenshots/4c0/4c043fd1a5ff78900483f2e82580fea0.jpg"
          },
          {
              "id": 99749,
              "image": "https://media.rawg.io/media/screenshots/c90/c9071628c238fbc20b366e2413dd8b4a.jpg"
          },
          {
              "id": 99750,
              "image": "https://media.rawg.io/media/screenshots/e29/e293b0f98092b8c0dbe24d66846088bb.jpg"
          },
          {
              "id": 99751,
              "image": "https://media.rawg.io/media/screenshots/168/16867bc76b385eb0fb749e41f7ada93d.jpg"
          },
          {
              "id": 99752,
              "image": "https://media.rawg.io/media/screenshots/fb9/fb917e562f311f48ff8d27632bd29a80.jpg"
          },
          {
              "id": 99753,
              "image": "https://media.rawg.io/media/screenshots/5f2/5f2ca569912add2a211b20ba3f576b97.jpg"
          }
      ]
  },
  {
      "id": 13536,
      "slug": "portal",
      "name": "Portal",
      "released": "2007-10-09",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/7fa/7fa0b586293c5861ee32490e953a4996.jpg",
      "rating": 4.51,
      "rating_top": 5,
      "ratings": [
          {
              "id": 5,
              "title": "exceptional",
              "count": 2380,
              "percent": 61.01
          },
          {
              "id": 4,
              "title": "recommended",
              "count": 1285,
              "percent": 32.94
          },
          {
              "id": 3,
              "title": "meh",
              "count": 158,
              "percent": 4.05
          },
          {
              "id": 1,
              "title": "skip",
              "count": 78,
              "percent": 2.0
          }
      ],
      "ratings_count": 3872,
      "reviews_text_count": 20,
      "added": 12802,
      "added_by_status": {
          "yet": 355,
          "owned": 7931,
          "beaten": 3962,
          "toplay": 197,
          "dropped": 292,
          "playing": 65
      },
      "metacritic": 90,
      "playtime": 4,
      "suggestions_count": 291,
      "updated": "2021-11-24T09:14:31",
      "user_game": null,
      "reviews_count": 3901,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2007-10-09",
              "requirements_en": {
                  "minimum": "<p><strong>Minimum: </strong>1.7 GHz Processor, 512MB RAM, DirectX&reg; 8.1 level Graphics Card (Requires support for SSE), Windows&reg; 7 (32/64-bit)/Vista/XP, Mouse, Keyboard, Internet Connection</p>\r\n\t\t\t<p><strong>Recommended: </strong>Pentium 4 processor (3.0GHz, or better), 1GB RAM, DirectX&reg; 9 level Graphics Card, Windows&reg; 7 (32/64-bit)/Vista/XP, Mouse, Keyboard, Internet Connection</p>"
              },
              "requirements_ru": {
                  "minimum": "Pentium 4/Athlon XP 1.7 ГГц,512 Мб памяти,3D-ускоритель со 128 Мб памяти,7.5 Гб на винчестере,Интернет-соединение 128 Кб/c",
                  "recommended": "Core 2 Duo/Athlon 64 3 ГГц,1 Гб памяти,3D-ускоритель с 512 Мб памяти,12 Гб на винчестере,Интернет-соединение 512 Кб/c"
              }
          },
          {
              "platform": {
                  "id": 5,
                  "name": "macOS",
                  "slug": "macos",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 91804,
                  "image_background": "https://media.rawg.io/media/games/b54/b54598d1d5cc31899f4f0a7e3122a7b0.jpg"
              },
              "released_at": "2007-10-09",
              "requirements_en": {
                  "minimum": "<strong>Minimum: </strong>OS X version Leopard 10.5.8, Snow Leopard 10.6.3, 1GB RAM, NVIDIA GeForce 8 or higher, ATI X1600 or higher, or Intel HD 3000 or higher Mouse, Keyboard, Internet Connection"
              },
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 6,
                  "name": "Linux",
                  "slug": "linux",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 66467,
                  "image_background": "https://media.rawg.io/media/games/d69/d69810315bd7e226ea2d21f9156af629.jpg"
              },
              "released_at": "2007-10-09",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 14,
                  "name": "Xbox 360",
                  "slug": "xbox360",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 2764,
                  "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
              },
              "released_at": "2007-10-09",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 16,
                  "name": "PlayStation 3",
                  "slug": "playstation3",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 3626,
                  "image_background": "https://media.rawg.io/media/games/490/49016e06ae2103881ff6373248843069.jpg"
              },
              "released_at": "2007-10-09",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 21,
                  "name": "Android",
                  "slug": "android",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 47490,
                  "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
              },
              "released_at": "2007-10-09",
              "requirements_en": {
                  "minimum": "4.4 and up"
              },
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 2,
                  "name": "PlayStation",
                  "slug": "playstation"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          },
          {
              "platform": {
                  "id": 8,
                  "name": "Android",
                  "slug": "android"
              }
          },
          {
              "platform": {
                  "id": 5,
                  "name": "Apple Macintosh",
                  "slug": "mac"
              }
          },
          {
              "platform": {
                  "id": 6,
                  "name": "Linux",
                  "slug": "linux"
              }
          }
      ],
      "genres": [
          {
              "id": 3,
              "name": "Adventure",
              "slug": "adventure",
              "games_count": 113029,
              "image_background": "https://media.rawg.io/media/games/9dd/9ddabb34840ea9227556670606cf8ea3.jpg"
          },
          {
              "id": 7,
              "name": "Puzzle",
              "slug": "puzzle",
              "games_count": 84387,
              "image_background": "https://media.rawg.io/media/games/8cd/8cd179c85bd3de8f79bef245b15075fb.jpg"
          }
      ],
      "stores": [
          {
              "id": 14890,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          },
          {
              "id": 40973,
              "store": {
                  "id": 8,
                  "name": "Google Play",
                  "slug": "google-play",
                  "domain": "play.google.com",
                  "games_count": 16824,
                  "image_background": "https://media.rawg.io/media/games/1bd/1bd2657b81eb0c99338120ad444b24ff.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 31,
              "name": "Singleplayer",
              "slug": "singleplayer",
              "language": "eng",
              "games_count": 162985,
              "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 40847,
              "name": "Steam Achievements",
              "slug": "steam-achievements",
              "language": "eng",
              "games_count": 25765,
              "image_background": "https://media.rawg.io/media/games/4ba/4ba9b4b68ffcc7019b112174883ba4d6.jpg"
          },
          {
              "id": 13,
              "name": "Atmospheric",
              "slug": "atmospheric",
              "language": "eng",
              "games_count": 21630,
              "image_background": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg"
          },
          {
              "id": 42,
              "name": "Great Soundtrack",
              "slug": "great-soundtrack",
              "language": "eng",
              "games_count": 3202,
              "image_background": "https://media.rawg.io/media/games/b7b/b7b8381707152afc7d91f5d95de70e39.jpg"
          },
          {
              "id": 118,
              "name": "Story Rich",
              "slug": "story-rich",
              "language": "eng",
              "games_count": 14512,
              "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
          },
          {
              "id": 8,
              "name": "First-Person",
              "slug": "first-person",
              "language": "eng",
              "games_count": 21101,
              "image_background": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg"
          },
          {
              "id": 32,
              "name": "Sci-fi",
              "slug": "sci-fi",
              "language": "eng",
              "games_count": 14086,
              "image_background": "https://media.rawg.io/media/games/8e4/8e4de3f54ac659e08a7ba6a2b731682a.jpg"
          },
          {
              "id": 40845,
              "name": "Partial Controller Support",
              "slug": "partial-controller-support",
              "language": "eng",
              "games_count": 8369,
              "image_background": "https://media.rawg.io/media/games/c80/c80bcf321da44d69b18a06c04d942662.jpg"
          },
          {
              "id": 30,
              "name": "FPS",
              "slug": "fps",
              "language": "eng",
              "games_count": 10374,
              "image_background": "https://media.rawg.io/media/games/26d/26d4437715bee60138dab4a7c8c59c92.jpg"
          },
          {
              "id": 4,
              "name": "Funny",
              "slug": "funny",
              "language": "eng",
              "games_count": 18531,
              "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
          },
          {
              "id": 193,
              "name": "Classic",
              "slug": "classic",
              "language": "eng",
              "games_count": 1676,
              "image_background": "https://media.rawg.io/media/games/4ba/4ba9b4b68ffcc7019b112174883ba4d6.jpg"
          },
          {
              "id": 189,
              "name": "Female Protagonist",
              "slug": "female-protagonist",
              "language": "eng",
              "games_count": 8207,
              "image_background": "https://media.rawg.io/media/games/b7d/b7d3f1715fa8381a4e780173a197a615.jpg"
          },
          {
              "id": 123,
              "name": "Comedy",
              "slug": "comedy",
              "language": "eng",
              "games_count": 8823,
              "image_background": "https://media.rawg.io/media/games/ffe/ffed87105b14f5beff72ff44a7793fd5.jpg"
          },
          {
              "id": 40838,
              "name": "Includes level editor",
              "slug": "includes-level-editor",
              "language": "eng",
              "games_count": 1498,
              "image_background": "https://media.rawg.io/media/games/93e/93ee6101e1c943732f06080dddb0fe4c.jpg"
          },
          {
              "id": 111,
              "name": "Short",
              "slug": "short",
              "language": "eng",
              "games_count": 42002,
              "image_background": "https://media.rawg.io/media/games/8ca/8ca40b562a755d6a0e30d48e6c74b178.jpg"
          },
          {
              "id": 40833,
              "name": "Captions available",
              "slug": "captions-available",
              "language": "eng",
              "games_count": 1146,
              "image_background": "https://media.rawg.io/media/games/226/2262cea0b385db6cf399f4be831603b0.jpg"
          },
          {
              "id": 114,
              "name": "Physics",
              "slug": "physics",
              "language": "eng",
              "games_count": 15622,
              "image_background": "https://media.rawg.io/media/games/a3c/a3c529a12c896c0ef02db5b4741de2ba.jpg"
          },
          {
              "id": 148,
              "name": "Dark Humor",
              "slug": "dark-humor",
              "language": "eng",
              "games_count": 2049,
              "image_background": "https://media.rawg.io/media/games/37a/37adf971ee0732869c431e4936bb2080.jpg"
          },
          {
              "id": 40834,
              "name": "Commentary available",
              "slug": "commentary-available",
              "language": "eng",
              "games_count": 243,
              "image_background": "https://media.rawg.io/media/games/b7b/b7b8381707152afc7d91f5d95de70e39.jpg"
          },
          {
              "id": 40839,
              "name": "Includes Source SDK",
              "slug": "includes-source-sdk",
              "language": "eng",
              "games_count": 55,
              "image_background": "https://media.rawg.io/media/screenshots/4e5/4e5e71d53468bcf5d6686c46fec95d78.jpg"
          },
          {
              "id": 87,
              "name": "Science",
              "slug": "science",
              "language": "eng",
              "games_count": 1306,
              "image_background": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg"
          }
      ],
      "esrb_rating": {
          "id": 3,
          "name": "Teen",
          "slug": "teen"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/7fa/7fa0b586293c5861ee32490e953a4996.jpg"
          },
          {
              "id": 115793,
              "image": "https://media.rawg.io/media/screenshots/99e/99e94bd55eb75fa6e75c3dcbb1a570b2.jpg"
          },
          {
              "id": 115794,
              "image": "https://media.rawg.io/media/screenshots/2f0/2f0297a46934d9fa914c626902b1ce20.jpg"
          },
          {
              "id": 115795,
              "image": "https://media.rawg.io/media/screenshots/3b3/3b3713fbca6194dfc4d6e8a8d006d354.jpg"
          },
          {
              "id": 115796,
              "image": "https://media.rawg.io/media/screenshots/c6f/c6f9afc3e4dd51068b22f04acbc6ca99.jpg"
          },
          {
              "id": 115797,
              "image": "https://media.rawg.io/media/screenshots/748/74841207eec76ebc7fc03210168bfb7e.jpg"
          },
          {
              "id": 115798,
              "image": "https://media.rawg.io/media/screenshots/e72/e7256b4caedf099bcb8ebd332f892334.jpg"
          }
      ]
  },
  {
      "id": 4062,
      "slug": "bioshock-infinite",
      "name": "BioShock Infinite",
      "released": "2013-03-26",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/fc1/fc1307a2774506b5bd65d7e8424664a7.jpg",
      "rating": 4.38,
      "rating_top": 5,
      "ratings": [
          {
              "id": 5,
              "title": "exceptional",
              "count": 1908,
              "percent": 55.05
          },
          {
              "id": 4,
              "title": "recommended",
              "count": 1163,
              "percent": 33.55
          },
          {
              "id": 3,
              "title": "meh",
              "count": 305,
              "percent": 8.8
          },
          {
              "id": 1,
              "title": "skip",
              "count": 90,
              "percent": 2.6
          }
      ],
      "ratings_count": 3435,
      "reviews_text_count": 20,
      "added": 12611,
      "added_by_status": {
          "yet": 671,
          "owned": 7584,
          "beaten": 3589,
          "toplay": 311,
          "dropped": 375,
          "playing": 81
      },
      "metacritic": 94,
      "playtime": 12,
      "suggestions_count": 612,
      "updated": "2020-08-03T02:19:32",
      "user_game": null,
      "reviews_count": 3466,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 14,
                  "name": "Xbox 360",
                  "slug": "xbox360",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 2764,
                  "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
              },
              "released_at": "2013-03-26",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 7,
                  "name": "Nintendo Switch",
                  "slug": "nintendo-switch",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 4771,
                  "image_background": "https://media.rawg.io/media/games/7cf/7cfc9220b401b7a300e409e539c9afd5.jpg"
              },
              "released_at": "2013-03-26",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2013-03-26",
              "requirements_en": {
                  "minimum": "<strong>Minimum:</strong><br><ul class=\"bb_ul\"><li><strong>OS:</strong> Windows Vista Service Pack 2 32-bit<br>\t</li><li><strong>Processor:</strong> Intel Core 2 DUO 2.4 GHz / AMD Athlon X2 2.7 GHz<br>\t</li><li><strong>Memory:</strong> 2GB<br>\t</li><li><strong>Hard Disk Space:</strong> 20 GB free<br>\t</li><li><strong>Video Card:</strong> DirectX10 Compatible ATI Radeon HD 3870 / NVIDIA 8800 GT / Intel HD 3000 Integrated Graphics<br>\t</li><li><strong>Video Card Memory:</strong> 512 MB\t<br>\t</li><li><strong>Sound:</strong> DirectX Compatible</li></ul>",
                  "recommended": "<strong>Recommended:</strong><br><ul class=\"bb_ul\"><li><strong>OS:</strong> Windows 7 Service Pack 1 64-bit<br>\t</li><li><strong>Processor:</strong> Quad Core Processor<br>\t</li><li><strong>Memory:</strong> 4GB<br>\t</li><li><strong>Hard Disk Space:</strong> 30 GB free<br>\t</li><li><strong>Video Card:</strong> DirectX11 Compatible, AMD Radeon HD 6950 / NVIDIA GeForce GTX 560<br>\t</li><li><strong>Video Card Memory:</strong> 1024 MB\t<br>\t</li><li><strong>Sound:</strong> DirectX Compatible</li></ul>"
              },
              "requirements_ru": {
                  "minimum": "Win Vista 32\nCore 2 Duo E4600/Athlon 64 X2 5200+\nGeForce GT 340/Radeon HD 3800\n2 GB RAM\n20 GB HDD",
                  "recommended": "Win 7 64\nCore 2 Quad Q6600/Athlon II X4 610e\nGeForce GTX 560/Radeon HD 6950\n4 GB RAM\n20 GB HDD"
              }
          },
          {
              "platform": {
                  "id": 6,
                  "name": "Linux",
                  "slug": "linux",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 66467,
                  "image_background": "https://media.rawg.io/media/games/d69/d69810315bd7e226ea2d21f9156af629.jpg"
              },
              "released_at": "2013-03-26",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 16,
                  "name": "PlayStation 3",
                  "slug": "playstation3",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 3626,
                  "image_background": "https://media.rawg.io/media/games/490/49016e06ae2103881ff6373248843069.jpg"
              },
              "released_at": "2013-03-26",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 18,
                  "name": "PlayStation 4",
                  "slug": "playstation4",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 6288,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2013-03-26",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 1,
                  "name": "Xbox One",
                  "slug": "xbox-one",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 5216,
                  "image_background": "https://media.rawg.io/media/games/f46/f466571d536f2e3ea9e815ad17177501.jpg"
              },
              "released_at": "2013-03-26",
              "requirements_en": null,
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 2,
                  "name": "PlayStation",
                  "slug": "playstation"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          },
          {
              "platform": {
                  "id": 6,
                  "name": "Linux",
                  "slug": "linux"
              }
          },
          {
              "platform": {
                  "id": 7,
                  "name": "Nintendo",
                  "slug": "nintendo"
              }
          }
      ],
      "genres": [
          {
              "id": 4,
              "name": "Action",
              "slug": "action",
              "games_count": 149659,
              "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
          },
          {
              "id": 2,
              "name": "Shooter",
              "slug": "shooter",
              "games_count": 51719,
              "image_background": "https://media.rawg.io/media/games/9fa/9fa63622543e5d4f6d99aa9d73b043de.jpg"
          }
      ],
      "stores": [
          {
              "id": 71727,
              "store": {
                  "id": 4,
                  "name": "App Store",
                  "slug": "apple-appstore",
                  "domain": "apps.apple.com",
                  "games_count": 72461,
                  "image_background": "https://media.rawg.io/media/games/7ac/7aca7ccf0e70cd0974cb899ab9e5158e.jpg"
              }
          },
          {
              "id": 440409,
              "store": {
                  "id": 2,
                  "name": "Xbox Store",
                  "slug": "xbox-store",
                  "domain": "microsoft.com",
                  "games_count": 4712,
                  "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
              }
          },
          {
              "id": 461035,
              "store": {
                  "id": 6,
                  "name": "Nintendo Store",
                  "slug": "nintendo",
                  "domain": "nintendo.com",
                  "games_count": 8825,
                  "image_background": "https://media.rawg.io/media/games/b72/b7233d5d5b1e75e86bb860ccc7aeca85.jpg"
              }
          },
          {
              "id": 4382,
              "store": {
                  "id": 3,
                  "name": "PlayStation Store",
                  "slug": "playstation-store",
                  "domain": "store.playstation.com",
                  "games_count": 7745,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 13084,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          },
          {
              "id": 33810,
              "store": {
                  "id": 7,
                  "name": "Xbox 360 Store",
                  "slug": "xbox360",
                  "domain": "marketplace.xbox.com",
                  "games_count": 1917,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 31,
              "name": "Singleplayer",
              "slug": "singleplayer",
              "language": "eng",
              "games_count": 162985,
              "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 40847,
              "name": "Steam Achievements",
              "slug": "steam-achievements",
              "language": "eng",
              "games_count": 25765,
              "image_background": "https://media.rawg.io/media/games/4ba/4ba9b4b68ffcc7019b112174883ba4d6.jpg"
          },
          {
              "id": 7808,
              "name": "steam-trading-cards",
              "slug": "steam-trading-cards",
              "language": "eng",
              "games_count": 7582,
              "image_background": "https://media.rawg.io/media/games/4cf/4cfc6b7f1850590a4634b08bfab308ab.jpg"
          },
          {
              "id": 13,
              "name": "Atmospheric",
              "slug": "atmospheric",
              "language": "eng",
              "games_count": 21630,
              "image_background": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg"
          },
          {
              "id": 40849,
              "name": "Steam Cloud",
              "slug": "steam-cloud",
              "language": "eng",
              "games_count": 11732,
              "image_background": "https://media.rawg.io/media/games/c6b/c6bfece1daf8d06bc0a60632ac78e5bf.jpg"
          },
          {
              "id": 40836,
              "name": "Full controller support",
              "slug": "full-controller-support",
              "language": "eng",
              "games_count": 11963,
              "image_background": "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg"
          },
          {
              "id": 42,
              "name": "Great Soundtrack",
              "slug": "great-soundtrack",
              "language": "eng",
              "games_count": 3202,
              "image_background": "https://media.rawg.io/media/games/b7b/b7b8381707152afc7d91f5d95de70e39.jpg"
          },
          {
              "id": 24,
              "name": "RPG",
              "slug": "rpg",
              "language": "eng",
              "games_count": 14383,
              "image_background": "https://media.rawg.io/media/games/c24/c24ec439abf4a2e92f3429dfa83f7f94.jpg"
          },
          {
              "id": 118,
              "name": "Story Rich",
              "slug": "story-rich",
              "language": "eng",
              "games_count": 14512,
              "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
          },
          {
              "id": 8,
              "name": "First-Person",
              "slug": "first-person",
              "language": "eng",
              "games_count": 21101,
              "image_background": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg"
          },
          {
              "id": 32,
              "name": "Sci-fi",
              "slug": "sci-fi",
              "language": "eng",
              "games_count": 14086,
              "image_background": "https://media.rawg.io/media/games/8e4/8e4de3f54ac659e08a7ba6a2b731682a.jpg"
          },
          {
              "id": 30,
              "name": "FPS",
              "slug": "fps",
              "language": "eng",
              "games_count": 10374,
              "image_background": "https://media.rawg.io/media/games/26d/26d4437715bee60138dab4a7c8c59c92.jpg"
          },
          {
              "id": 64,
              "name": "Fantasy",
              "slug": "fantasy",
              "language": "eng",
              "games_count": 19249,
              "image_background": "https://media.rawg.io/media/games/59a/59a3ebcba3d08c51532c6ca877aff256.jpg"
          },
          {
              "id": 26,
              "name": "Gore",
              "slug": "gore",
              "language": "eng",
              "games_count": 4411,
              "image_background": "https://media.rawg.io/media/games/d58/d588947d4286e7b5e0e12e1bea7d9844.jpg"
          },
          {
              "id": 115,
              "name": "Controller",
              "slug": "controller",
              "language": "eng",
              "games_count": 7311,
              "image_background": "https://media.rawg.io/media/games/b80/b80de593e66136f8a35c57960cc8fa3b.jpg"
          },
          {
              "id": 119,
              "name": "Dystopian",
              "slug": "dystopian",
              "language": "eng",
              "games_count": 1445,
              "image_background": "https://media.rawg.io/media/games/c2e/c2e6ad5c838d551aeff376f1f3d9d65e.jpg"
          },
          {
              "id": 154,
              "name": "Steampunk",
              "slug": "steampunk",
              "language": "eng",
              "games_count": 920,
              "image_background": "https://media.rawg.io/media/games/c5b/c5b3b6aa220050f7f504f4477cb51d3b.jpg"
          },
          {
              "id": 305,
              "name": "Linear",
              "slug": "linear",
              "language": "eng",
              "games_count": 2327,
              "image_background": "https://media.rawg.io/media/games/9af/9af24c1886e2c7b52a4a2c65aa874638.jpg"
          },
          {
              "id": 208,
              "name": "Alternate History",
              "slug": "alternate-history",
              "language": "eng",
              "games_count": 1202,
              "image_background": "https://media.rawg.io/media/screenshots/245/245579c536d2a06e69d391573d911679.jpg"
          },
          {
              "id": 317,
              "name": "Time Travel",
              "slug": "time-travel",
              "language": "eng",
              "games_count": 1414,
              "image_background": "https://media.rawg.io/media/games/9a1/9a18c226cf379272c698f26d2b79b3da.jpg"
          },
          {
              "id": 287,
              "name": "Political",
              "slug": "political",
              "language": "eng",
              "games_count": 423,
              "image_background": "https://media.rawg.io/media/screenshots/617/6173ebd9a0ed696369e25a9066e57a68.jpg"
          }
      ],
      "esrb_rating": {
          "id": 4,
          "name": "Mature",
          "slug": "mature"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/fc1/fc1307a2774506b5bd65d7e8424664a7.jpg"
          },
          {
              "id": 98549,
              "image": "https://media.rawg.io/media/screenshots/bf0/bf07e2c6d2c888d372917d9ef453c8a4.jpg"
          },
          {
              "id": 98550,
              "image": "https://media.rawg.io/media/screenshots/9d3/9d38833952812ad7888a6dc21699934f.jpg"
          },
          {
              "id": 98551,
              "image": "https://media.rawg.io/media/screenshots/595/59572d257b6797986e4eabcd1ee023fd.jpg"
          },
          {
              "id": 98552,
              "image": "https://media.rawg.io/media/screenshots/f71/f71c23eb76f050d6180490e82d58d799.jpg"
          },
          {
              "id": 98553,
              "image": "https://media.rawg.io/media/screenshots/871/8713411d5332ceb2b4092073a6f5f3f2.jpg"
          },
          {
              "id": 98554,
              "image": "https://media.rawg.io/media/screenshots/985/985b56daa78e0a23133518d4226e9f97.jpg"
          }
      ]
  },
  {
      "id": 3439,
      "slug": "life-is-strange-episode-1-2",
      "name": "Life is Strange",
      "released": "2015-01-29",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/562/562553814dd54e001a541e4ee83a591c.jpg",
      "rating": 4.11,
      "rating_top": 5,
      "ratings": [
          {
              "id": 5,
              "title": "exceptional",
              "count": 1380,
              "percent": 43.77
          },
          {
              "id": 4,
              "title": "recommended",
              "count": 1143,
              "percent": 36.25
          },
          {
              "id": 3,
              "title": "meh",
              "count": 425,
              "percent": 13.48
          },
          {
              "id": 1,
              "title": "skip",
              "count": 205,
              "percent": 6.5
          }
      ],
      "ratings_count": 3119,
      "reviews_text_count": 22,
      "added": 12548,
      "added_by_status": {
          "yet": 677,
          "owned": 8112,
          "beaten": 2821,
          "toplay": 287,
          "dropped": 513,
          "playing": 138
      },
      "metacritic": 83,
      "playtime": 7,
      "suggestions_count": 525,
      "updated": "2020-06-29T10:40:03",
      "user_game": null,
      "reviews_count": 3153,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2015-01-29",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 6,
                  "name": "Linux",
                  "slug": "linux",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 66467,
                  "image_background": "https://media.rawg.io/media/games/d69/d69810315bd7e226ea2d21f9156af629.jpg"
              },
              "released_at": "2015-01-29",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 16,
                  "name": "PlayStation 3",
                  "slug": "playstation3",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 3626,
                  "image_background": "https://media.rawg.io/media/games/490/49016e06ae2103881ff6373248843069.jpg"
              },
              "released_at": "2015-01-29",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 5,
                  "name": "macOS",
                  "slug": "macos",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 91804,
                  "image_background": "https://media.rawg.io/media/games/b54/b54598d1d5cc31899f4f0a7e3122a7b0.jpg"
              },
              "released_at": "2015-01-29",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 3,
                  "name": "iOS",
                  "slug": "ios",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 74133,
                  "image_background": "https://media.rawg.io/media/games/d5a/d5a24f9f71315427fa6e966fdd98dfa6.jpg"
              },
              "released_at": "2015-01-29",
              "requirements_en": {
                  "minimum": "iPhone 5s, iPad Air, iPad Air Cellular, iPad Mini Retina, iPad Mini Retina Cellular, iPhone 6, iPhone 6 Plus, iPad Air 2, iPad Air 2 Cellular, iPad Mini 3, iPad Mini 3 Cellular, iPod Touch Sixth Gen, iPhone 6s, iPhone 6s Plus, iPad Mini 4, iPad Mini 4 Cellular, iPad Pro, iPad Pro Cellular, iPad Pro 9.7, iPad Pro 9.7 Cellular, iPhone SE, iPhone 7, iPhone 7 Plus, iPad 6 1 1, iPad 6 1 2, iPad 7 1, iPad 7 2, iPad 7 3, iPad 7 4, iPhone 8, iPhone 8 Plus, iPhone X, iPad 7 5, iPad 7 6, iPhone X S, iPhone X S Max, iPhone X R, iPad 8 1 2, iPad 8 3 4, iPad 8 5 6, iPad 8 7 8, iPad Mini 5, iPad Mini 5 Cellular, iPad Air 3, iPad Air 3 Cellular, iPod Touch Seventh Gen"
              },
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 14,
                  "name": "Xbox 360",
                  "slug": "xbox360",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 2764,
                  "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
              },
              "released_at": "2015-01-29",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 21,
                  "name": "Android",
                  "slug": "android",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 47490,
                  "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
              },
              "released_at": "2015-01-29",
              "requirements_en": {
                  "minimum": "6.0 and up"
              },
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 18,
                  "name": "PlayStation 4",
                  "slug": "playstation4",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 6288,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2015-01-29",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 1,
                  "name": "Xbox One",
                  "slug": "xbox-one",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 5216,
                  "image_background": "https://media.rawg.io/media/games/f46/f466571d536f2e3ea9e815ad17177501.jpg"
              },
              "released_at": "2015-01-29",
              "requirements_en": null,
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 2,
                  "name": "PlayStation",
                  "slug": "playstation"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          },
          {
              "platform": {
                  "id": 4,
                  "name": "iOS",
                  "slug": "ios"
              }
          },
          {
              "platform": {
                  "id": 8,
                  "name": "Android",
                  "slug": "android"
              }
          },
          {
              "platform": {
                  "id": 5,
                  "name": "Apple Macintosh",
                  "slug": "mac"
              }
          },
          {
              "platform": {
                  "id": 6,
                  "name": "Linux",
                  "slug": "linux"
              }
          }
      ],
      "genres": [
          {
              "id": 3,
              "name": "Adventure",
              "slug": "adventure",
              "games_count": 113029,
              "image_background": "https://media.rawg.io/media/games/9dd/9ddabb34840ea9227556670606cf8ea3.jpg"
          }
      ],
      "stores": [
          {
              "id": 451321,
              "store": {
                  "id": 5,
                  "name": "GOG",
                  "slug": "gog",
                  "domain": "gog.com",
                  "games_count": 4149,
                  "image_background": "https://media.rawg.io/media/games/713/713269608dc8f2f40f5a670a14b2de94.jpg"
              }
          },
          {
              "id": 3702,
              "store": {
                  "id": 3,
                  "name": "PlayStation Store",
                  "slug": "playstation-store",
                  "domain": "store.playstation.com",
                  "games_count": 7745,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 35603,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          },
          {
              "id": 35602,
              "store": {
                  "id": 2,
                  "name": "Xbox Store",
                  "slug": "xbox-store",
                  "domain": "microsoft.com",
                  "games_count": 4712,
                  "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
              }
          },
          {
              "id": 217695,
              "store": {
                  "id": 8,
                  "name": "Google Play",
                  "slug": "google-play",
                  "domain": "play.google.com",
                  "games_count": 16824,
                  "image_background": "https://media.rawg.io/media/games/1bd/1bd2657b81eb0c99338120ad444b24ff.jpg"
              }
          },
          {
              "id": 245823,
              "store": {
                  "id": 7,
                  "name": "Xbox 360 Store",
                  "slug": "xbox360",
                  "domain": "marketplace.xbox.com",
                  "games_count": 1917,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 44714,
              "store": {
                  "id": 4,
                  "name": "App Store",
                  "slug": "apple-appstore",
                  "domain": "apps.apple.com",
                  "games_count": 72461,
                  "image_background": "https://media.rawg.io/media/games/7ac/7aca7ccf0e70cd0974cb899ab9e5158e.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 31,
              "name": "Singleplayer",
              "slug": "singleplayer",
              "language": "eng",
              "games_count": 162985,
              "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 7808,
              "name": "steam-trading-cards",
              "slug": "steam-trading-cards",
              "language": "eng",
              "games_count": 7582,
              "image_background": "https://media.rawg.io/media/games/4cf/4cfc6b7f1850590a4634b08bfab308ab.jpg"
          },
          {
              "id": 13,
              "name": "Atmospheric",
              "slug": "atmospheric",
              "language": "eng",
              "games_count": 21630,
              "image_background": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg"
          },
          {
              "id": 40836,
              "name": "Full controller support",
              "slug": "full-controller-support",
              "language": "eng",
              "games_count": 11963,
              "image_background": "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg"
          },
          {
              "id": 42,
              "name": "Great Soundtrack",
              "slug": "great-soundtrack",
              "language": "eng",
              "games_count": 3202,
              "image_background": "https://media.rawg.io/media/games/b7b/b7b8381707152afc7d91f5d95de70e39.jpg"
          },
          {
              "id": 118,
              "name": "Story Rich",
              "slug": "story-rich",
              "language": "eng",
              "games_count": 14512,
              "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
          },
          {
              "id": 149,
              "name": "Third Person",
              "slug": "third-person",
              "language": "eng",
              "games_count": 6912,
              "image_background": "https://media.rawg.io/media/games/d69/d69810315bd7e226ea2d21f9156af629.jpg"
          },
          {
              "id": 189,
              "name": "Female Protagonist",
              "slug": "female-protagonist",
              "language": "eng",
              "games_count": 8207,
              "image_background": "https://media.rawg.io/media/games/b7d/b7d3f1715fa8381a4e780173a197a615.jpg"
          },
          {
              "id": 41,
              "name": "Dark",
              "slug": "dark",
              "language": "eng",
              "games_count": 10634,
              "image_background": "https://media.rawg.io/media/games/7f6/7f6cd70ba2ad57053b4847c13569f2d8.jpg"
          },
          {
              "id": 141,
              "name": "Point & Click",
              "slug": "point-click",
              "language": "eng",
              "games_count": 9609,
              "image_background": "https://media.rawg.io/media/games/2e1/2e187b31e5cee21c110bd16798d75fab.jpg"
          },
          {
              "id": 111,
              "name": "Short",
              "slug": "short",
              "language": "eng",
              "games_count": 42002,
              "image_background": "https://media.rawg.io/media/games/8ca/8ca40b562a755d6a0e30d48e6c74b178.jpg"
          },
          {
              "id": 117,
              "name": "Mystery",
              "slug": "mystery",
              "language": "eng",
              "games_count": 9470,
              "image_background": "https://media.rawg.io/media/games/813/813f9dab418a3d549f8b9ad8ef2f3d9c.jpg"
          },
          {
              "id": 145,
              "name": "Choices Matter",
              "slug": "choices-matter",
              "language": "eng",
              "games_count": 2190,
              "image_background": "https://media.rawg.io/media/screenshots/8f0/8f0b94922ad5e59968852649697b2643.jpg"
          },
          {
              "id": 120,
              "name": "Memes",
              "slug": "memes",
              "language": "eng",
              "games_count": 1384,
              "image_background": "https://media.rawg.io/media/games/270/270b412b66688081497b3d70c100b208.jpg"
          },
          {
              "id": 91,
              "name": "Walking Simulator",
              "slug": "walking-simulator",
              "language": "eng",
              "games_count": 5200,
              "image_background": "https://media.rawg.io/media/games/34e/34e100b1f648de99f32d477065f04653.jpg"
          },
          {
              "id": 406,
              "name": "Story",
              "slug": "story",
              "language": "eng",
              "games_count": 10246,
              "image_background": "https://media.rawg.io/media/games/615/61503312a95d451198d80d9bae275f79.jpg"
          },
          {
              "id": 218,
              "name": "Multiple Endings",
              "slug": "multiple-endings",
              "language": "eng",
              "games_count": 5129,
              "image_background": "https://media.rawg.io/media/games/214/2140885d34e3a3398b45036e5d870971.jpg"
          },
          {
              "id": 232,
              "name": "Episodic",
              "slug": "episodic",
              "language": "eng",
              "games_count": 413,
              "image_background": "https://media.rawg.io/media/screenshots/25d/25df88db8714961a93e5ae1ecaa50e45.jpg"
          },
          {
              "id": 317,
              "name": "Time Travel",
              "slug": "time-travel",
              "language": "eng",
              "games_count": 1414,
              "image_background": "https://media.rawg.io/media/games/9a1/9a18c226cf379272c698f26d2b79b3da.jpg"
          },
          {
              "id": 295,
              "name": "Soundtrack",
              "slug": "soundtrack",
              "language": "eng",
              "games_count": 2498,
              "image_background": "https://media.rawg.io/media/games/ed0/ed05e3f2303b644e3b95b409a7909f5a.jpg"
          },
          {
              "id": 302,
              "name": "Time Manipulation",
              "slug": "time-manipulation",
              "language": "eng",
              "games_count": 277,
              "image_background": "https://media.rawg.io/media/screenshots/62f/62ffa88bda2ddf991835f583fe7d4bef.jpeg"
          },
          {
              "id": 992,
              "name": "student",
              "slug": "student",
              "language": "eng",
              "games_count": 1324,
              "image_background": "https://media.rawg.io/media/screenshots/f50/f503ddde3265b93db86fb50e8d9cc8df.jpg"
          },
          {
              "id": 2682,
              "name": "strange",
              "slug": "strange",
              "language": "eng",
              "games_count": 328,
              "image_background": "https://media.rawg.io/media/screenshots/98d/98d5f359e9cd19069486844d74e77131_ZoInylb.jpg"
          },
          {
              "id": 3197,
              "name": "photography",
              "slug": "photography",
              "language": "eng",
              "games_count": 178,
              "image_background": "https://media.rawg.io/media/screenshots/2b2/2b2d88a35e058bfa6f3418898e3bfeab.jpg"
          }
      ],
      "esrb_rating": {
          "id": 4,
          "name": "Mature",
          "slug": "mature"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/562/562553814dd54e001a541e4ee83a591c.jpg"
          },
          {
              "id": 1826487,
              "image": "https://media.rawg.io/media/screenshots/edf/edfcbdf85f02f871263dabf1b4f0aa87.jpg"
          },
          {
              "id": 1826488,
              "image": "https://media.rawg.io/media/screenshots/4c6/4c6da2f36396d4ed51f82ba6159fa39b.jpg"
          },
          {
              "id": 1826489,
              "image": "https://media.rawg.io/media/screenshots/6aa/6aa56ef1485c8b287a913fa842883daa.jpg"
          },
          {
              "id": 1826490,
              "image": "https://media.rawg.io/media/screenshots/cb1/cb148b52fe857f5b0b83ae9c01f56d8e.jpg"
          },
          {
              "id": 1826491,
              "image": "https://media.rawg.io/media/screenshots/aea/aea38b33b90054f8fe4cc8bb05253b1d.jpg"
          },
          {
              "id": 1826492,
              "image": "https://media.rawg.io/media/screenshots/c1d/c1d6333b2da0f920e8de10c14d3c6093.jpg"
          }
      ]
  },
  {
      "id": 802,
      "slug": "borderlands-2",
      "name": "Borderlands 2",
      "released": "2012-09-18",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg",
      "rating": 4.03,
      "rating_top": 4,
      "ratings": [
          {
              "id": 4,
              "title": "recommended",
              "count": 1326,
              "percent": 47.82
          },
          {
              "id": 5,
              "title": "exceptional",
              "count": 878,
              "percent": 31.66
          },
          {
              "id": 3,
              "title": "meh",
              "count": 463,
              "percent": 16.7
          },
          {
              "id": 1,
              "title": "skip",
              "count": 106,
              "percent": 3.82
          }
      ],
      "ratings_count": 2756,
      "reviews_text_count": 12,
      "added": 12539,
      "added_by_status": {
          "yet": 495,
          "owned": 8740,
          "beaten": 1908,
          "toplay": 165,
          "dropped": 1024,
          "playing": 207
      },
      "metacritic": 89,
      "playtime": 10,
      "suggestions_count": 665,
      "updated": "2020-08-07T02:30:06",
      "user_game": null,
      "reviews_count": 2773,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 18,
                  "name": "PlayStation 4",
                  "slug": "playstation4",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 6288,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2012-09-18",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 14,
                  "name": "Xbox 360",
                  "slug": "xbox360",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 2764,
                  "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
              },
              "released_at": "2012-09-18",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 16,
                  "name": "PlayStation 3",
                  "slug": "playstation3",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 3626,
                  "image_background": "https://media.rawg.io/media/games/490/49016e06ae2103881ff6373248843069.jpg"
              },
              "released_at": "2012-09-18",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2012-09-18",
              "requirements_en": {
                  "minimum": "<strong>Minimum:</strong><br><ul class=\"bb_ul\"><li><strong>OS:</strong> Windows XP SP3<br>\t</li><li><strong>Processor:</strong> 2.4 GHz Dual Core Processor<br>\t</li><li><strong>Memory:</strong> 2 GB(XP)/ 2 GB(Vista)<br>\t</li><li><strong>Hard Disk Space:</strong> 13 GB free<br>\t</li><li><strong>Video Memory:</strong> 256 MB<br>\t</li><li><strong>Video Card:</strong> NVIDIA GeForce 8500 /ATI Radeon HD 2600<br>\t</li><li><strong>Sound:</strong> DirectX 9.0c Compatible<br>\t</li><li><strong>Other Requirements:</strong>Initial installation requires one-time internet connection for Steam authentication; software installations required (included with the game) include Steam Client, DirectX 9, Microsoft .NET 4 Framework, Visual C++ Redistributable 2005, Visual C++ Redistributable 2008, Visual C++ Redistributable 2010, and AMD CPU Drivers (XP Only/AMD Only)</li></ul>",
                  "recommended": "<strong>Recommended:</strong><br><ul class=\"bb_ul\"><li><strong>OS:</strong> Windows XP SP3/Vista/Win 7<br>\t</li><li><strong>Processor:</strong> 2.3 GHz Quad Core processor<br>\t</li><li><strong>Memory:</strong> 2 GB<br>\t</li><li><strong>Hard Disk Space:</strong> 20 GB free<br>\t</li><li><strong>Video Memory:</strong> 512MB<br>\t</li><li><strong>Video Card:</strong> NVIDIA GeForce GTX 560 / ATI Radeon HD 5850<br>\t</li><li><strong>Sound:</strong> DirectX 9.0c Compatible<br>\t</li><li><strong>Other Requirements:</strong>Initial installation requires one-time internet connection for Steam authentication; software installations required (included with the game) include Steam Client, DirectX 9, Microsoft .NET 4 Framework, Visual C++ Redistributable 2005, Visual C++ Redistributable 2008, Visual C++ Redistributable 2010, and AMD CPU Drivers (XP Only/AMD Only)</li></ul>"
              },
              "requirements_ru": {
                  "minimum": "Core 2 Duo/Athlon 64 X2 2.4 ГГц,2 Гб памяти,GeForce 8500/Radeon HD 2600,13 Гб на винчестере,интернет-соединение",
                  "recommended": "Core i5/Phenom X4 2.3 ГГц,2 Гб памяти,GeForce GTX 560/Radeon HD 5850,20 Гб на винчестере,интернет-соединение"
              }
          },
          {
              "platform": {
                  "id": 1,
                  "name": "Xbox One",
                  "slug": "xbox-one",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 5216,
                  "image_background": "https://media.rawg.io/media/games/f46/f466571d536f2e3ea9e815ad17177501.jpg"
              },
              "released_at": "2012-09-18",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 5,
                  "name": "macOS",
                  "slug": "macos",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 91804,
                  "image_background": "https://media.rawg.io/media/games/b54/b54598d1d5cc31899f4f0a7e3122a7b0.jpg"
              },
              "released_at": "2012-09-18",
              "requirements_en": null,
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 2,
                  "name": "PlayStation",
                  "slug": "playstation"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          },
          {
              "platform": {
                  "id": 5,
                  "name": "Apple Macintosh",
                  "slug": "mac"
              }
          }
      ],
      "genres": [
          {
              "id": 4,
              "name": "Action",
              "slug": "action",
              "games_count": 149659,
              "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
          },
          {
              "id": 2,
              "name": "Shooter",
              "slug": "shooter",
              "games_count": 51719,
              "image_background": "https://media.rawg.io/media/games/9fa/9fa63622543e5d4f6d99aa9d73b043de.jpg"
          },
          {
              "id": 5,
              "name": "RPG",
              "slug": "role-playing-games-rpg",
              "games_count": 45874,
              "image_background": "https://media.rawg.io/media/games/995/9951d9d55323d08967640f7b9ab3e342.jpg"
          }
      ],
      "stores": [
          {
              "id": 4000,
              "store": {
                  "id": 3,
                  "name": "PlayStation Store",
                  "slug": "playstation-store",
                  "domain": "store.playstation.com",
                  "games_count": 7745,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 213037,
              "store": {
                  "id": 8,
                  "name": "Google Play",
                  "slug": "google-play",
                  "domain": "play.google.com",
                  "games_count": 16824,
                  "image_background": "https://media.rawg.io/media/games/1bd/1bd2657b81eb0c99338120ad444b24ff.jpg"
              }
          },
          {
              "id": 11088,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          },
          {
              "id": 34042,
              "store": {
                  "id": 7,
                  "name": "Xbox 360 Store",
                  "slug": "xbox360",
                  "domain": "marketplace.xbox.com",
                  "games_count": 1917,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 71617,
              "store": {
                  "id": 4,
                  "name": "App Store",
                  "slug": "apple-appstore",
                  "domain": "apps.apple.com",
                  "games_count": 72461,
                  "image_background": "https://media.rawg.io/media/games/7ac/7aca7ccf0e70cd0974cb899ab9e5158e.jpg"
              }
          },
          {
              "id": 817,
              "store": {
                  "id": 2,
                  "name": "Xbox Store",
                  "slug": "xbox-store",
                  "domain": "microsoft.com",
                  "games_count": 4712,
                  "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 31,
              "name": "Singleplayer",
              "slug": "singleplayer",
              "language": "eng",
              "games_count": 162985,
              "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 40847,
              "name": "Steam Achievements",
              "slug": "steam-achievements",
              "language": "eng",
              "games_count": 25765,
              "image_background": "https://media.rawg.io/media/games/4ba/4ba9b4b68ffcc7019b112174883ba4d6.jpg"
          },
          {
              "id": 7,
              "name": "Multiplayer",
              "slug": "multiplayer",
              "language": "eng",
              "games_count": 30873,
              "image_background": "https://media.rawg.io/media/games/8cc/8cce7c0e99dcc43d66c8efd42f9d03e3.jpg"
          },
          {
              "id": 7808,
              "name": "steam-trading-cards",
              "slug": "steam-trading-cards",
              "language": "eng",
              "games_count": 7582,
              "image_background": "https://media.rawg.io/media/games/4cf/4cfc6b7f1850590a4634b08bfab308ab.jpg"
          },
          {
              "id": 13,
              "name": "Atmospheric",
              "slug": "atmospheric",
              "language": "eng",
              "games_count": 21630,
              "image_background": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg"
          },
          {
              "id": 40849,
              "name": "Steam Cloud",
              "slug": "steam-cloud",
              "language": "eng",
              "games_count": 11732,
              "image_background": "https://media.rawg.io/media/games/c6b/c6bfece1daf8d06bc0a60632ac78e5bf.jpg"
          },
          {
              "id": 40836,
              "name": "Full controller support",
              "slug": "full-controller-support",
              "language": "eng",
              "games_count": 11963,
              "image_background": "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg"
          },
          {
              "id": 24,
              "name": "RPG",
              "slug": "rpg",
              "language": "eng",
              "games_count": 14383,
              "image_background": "https://media.rawg.io/media/games/c24/c24ec439abf4a2e92f3429dfa83f7f94.jpg"
          },
          {
              "id": 18,
              "name": "Co-op",
              "slug": "co-op",
              "language": "eng",
              "games_count": 8306,
              "image_background": "https://media.rawg.io/media/games/ec3/ec3a7db7b8ab5a71aad622fe7c62632f.jpg"
          },
          {
              "id": 36,
              "name": "Open World",
              "slug": "open-world",
              "language": "eng",
              "games_count": 5045,
              "image_background": "https://media.rawg.io/media/games/6cd/6cd653e0aaef5ff8bbd295bf4bcb12eb.jpg"
          },
          {
              "id": 411,
              "name": "cooperative",
              "slug": "cooperative",
              "language": "eng",
              "games_count": 3372,
              "image_background": "https://media.rawg.io/media/games/f87/f87457e8347484033cb34cde6101d08d.jpg"
          },
          {
              "id": 32,
              "name": "Sci-fi",
              "slug": "sci-fi",
              "language": "eng",
              "games_count": 14086,
              "image_background": "https://media.rawg.io/media/games/8e4/8e4de3f54ac659e08a7ba6a2b731682a.jpg"
          },
          {
              "id": 30,
              "name": "FPS",
              "slug": "fps",
              "language": "eng",
              "games_count": 10374,
              "image_background": "https://media.rawg.io/media/games/26d/26d4437715bee60138dab4a7c8c59c92.jpg"
          },
          {
              "id": 9,
              "name": "Online Co-Op",
              "slug": "online-co-op",
              "language": "eng",
              "games_count": 3482,
              "image_background": "https://media.rawg.io/media/games/48c/48cb04ca483be865e3a83119c94e6097.jpg"
          },
          {
              "id": 4,
              "name": "Funny",
              "slug": "funny",
              "language": "eng",
              "games_count": 18531,
              "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
          },
          {
              "id": 123,
              "name": "Comedy",
              "slug": "comedy",
              "language": "eng",
              "games_count": 8823,
              "image_background": "https://media.rawg.io/media/games/ffe/ffed87105b14f5beff72ff44a7793fd5.jpg"
          },
          {
              "id": 97,
              "name": "Action RPG",
              "slug": "action-rpg",
              "language": "eng",
              "games_count": 4647,
              "image_background": "https://media.rawg.io/media/games/83f/83f6f70a7c1b86cd2637b029d8b42caa.jpg"
          },
          {
              "id": 167,
              "name": "Futuristic",
              "slug": "futuristic",
              "language": "eng",
              "games_count": 3296,
              "image_background": "https://media.rawg.io/media/games/90f/90fd5e569bc4c4a666c588a732124908.jpg"
          },
          {
              "id": 120,
              "name": "Memes",
              "slug": "memes",
              "language": "eng",
              "games_count": 1384,
              "image_background": "https://media.rawg.io/media/games/270/270b412b66688081497b3d70c100b208.jpg"
          },
          {
              "id": 148,
              "name": "Dark Humor",
              "slug": "dark-humor",
              "language": "eng",
              "games_count": 2049,
              "image_background": "https://media.rawg.io/media/games/37a/37adf971ee0732869c431e4936bb2080.jpg"
          },
          {
              "id": 98,
              "name": "Loot",
              "slug": "loot",
              "language": "eng",
              "games_count": 1581,
              "image_background": "https://media.rawg.io/media/games/530/5302dd22a190e664531236ca724e8726.jpg"
          },
          {
              "id": 166,
              "name": "Stylized",
              "slug": "stylized",
              "language": "eng",
              "games_count": 2748,
              "image_background": "https://media.rawg.io/media/games/13a/13a97b75b6e6b999901f6dd6fda47848.jpg"
          }
      ],
      "esrb_rating": {
          "id": 4,
          "name": "Mature",
          "slug": "mature"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
          },
          {
              "id": 7041,
              "image": "https://media.rawg.io/media/screenshots/adb/adbbb37113618ee107459cd5c344f2a8.jpg"
          },
          {
              "id": 7062,
              "image": "https://media.rawg.io/media/screenshots/616/61643dd96e936d29eb68cf53b2334e53.jpg"
          },
          {
              "id": 7070,
              "image": "https://media.rawg.io/media/screenshots/864/8644946ba14a03ab69f0766c42a03f80.jpg"
          },
          {
              "id": 7072,
              "image": "https://media.rawg.io/media/screenshots/f87/f87ad2b8f02b56e36c57b25cf8eac042.jpg"
          },
          {
              "id": 7081,
              "image": "https://media.rawg.io/media/screenshots/194/194e0962afa272604300001718a07793.jpg"
          },
          {
              "id": 7088,
              "image": "https://media.rawg.io/media/screenshots/297/29716964351ecd82545f1de3a50dfc4e.jpg"
          }
      ]
  },
  {
      "id": 28,
      "slug": "red-dead-redemption-2",
      "name": "Red Dead Redemption 2",
      "released": "2018-10-26",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg",
      "rating": 4.58,
      "rating_top": 5,
      "ratings": [
          {
              "id": 5,
              "title": "exceptional",
              "count": 2946,
              "percent": 72.96
          },
          {
              "id": 4,
              "title": "recommended",
              "count": 746,
              "percent": 18.47
          },
          {
              "id": 3,
              "title": "meh",
              "count": 227,
              "percent": 5.62
          },
          {
              "id": 1,
              "title": "skip",
              "count": 119,
              "percent": 2.95
          }
      ],
      "ratings_count": 3958,
      "reviews_text_count": 60,
      "added": 12017,
      "added_by_status": {
          "yet": 734,
          "owned": 6257,
          "beaten": 2350,
          "toplay": 1399,
          "dropped": 468,
          "playing": 809
      },
      "metacritic": 96,
      "playtime": 22,
      "suggestions_count": 606,
      "updated": "2020-11-23T02:33:54",
      "user_game": null,
      "reviews_count": 4038,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2018-10-26",
              "requirements_en": {
                  "minimum": "<strong>Minimum:</strong><br><ul class=\"bb_ul\"><li>Requires a 64-bit processor and operating system<br></li><li><strong>OS:</strong> Windows 7 - Service Pack 1 (6.1.7601)<br></li><li><strong>Processor:</strong> Intel® Core™ i5-2500K / AMD FX-6300<br></li><li><strong>Memory:</strong> 8 GB RAM<br></li><li><strong>Graphics:</strong> Nvidia GeForce GTX 770 2GB / AMD Radeon R9 280 3GB<br></li><li><strong>Network:</strong> Broadband Internet connection<br></li><li><strong>Storage:</strong> 150 GB available space<br></li><li><strong>Sound Card:</strong> Direct X Compatible</li></ul>",
                  "recommended": "<strong>Recommended:</strong><br><ul class=\"bb_ul\"><li>Requires a 64-bit processor and operating system<br></li><li><strong>OS:</strong> Windows 10 - April 2018 Update (v1803)<br></li><li><strong>Processor:</strong> Intel® Core™ i7-4770K / AMD Ryzen 5 1500X<br></li><li><strong>Memory:</strong> 12 GB RAM<br></li><li><strong>Graphics:</strong> Nvidia GeForce GTX 1060 6GB / AMD Radeon RX 480 4GB<br></li><li><strong>Network:</strong> Broadband Internet connection<br></li><li><strong>Storage:</strong> 150 GB available space<br></li><li><strong>Sound Card:</strong> Direct X Compatible</li></ul>"
              },
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 18,
                  "name": "PlayStation 4",
                  "slug": "playstation4",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 6288,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2018-10-26",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 1,
                  "name": "Xbox One",
                  "slug": "xbox-one",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 5216,
                  "image_background": "https://media.rawg.io/media/games/f46/f466571d536f2e3ea9e815ad17177501.jpg"
              },
              "released_at": "2018-10-26",
              "requirements_en": null,
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 2,
                  "name": "PlayStation",
                  "slug": "playstation"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          }
      ],
      "genres": [
          {
              "id": 4,
              "name": "Action",
              "slug": "action",
              "games_count": 149659,
              "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
          },
          {
              "id": 3,
              "name": "Adventure",
              "slug": "adventure",
              "games_count": 113029,
              "image_background": "https://media.rawg.io/media/games/9dd/9ddabb34840ea9227556670606cf8ea3.jpg"
          }
      ],
      "stores": [
          {
              "id": 257732,
              "store": {
                  "id": 3,
                  "name": "PlayStation Store",
                  "slug": "playstation-store",
                  "domain": "store.playstation.com",
                  "games_count": 7745,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 374316,
              "store": {
                  "id": 11,
                  "name": "Epic Games",
                  "slug": "epic-games",
                  "domain": "epicgames.com",
                  "games_count": 942,
                  "image_background": "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg"
              }
          },
          {
              "id": 384218,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          },
          {
              "id": 48782,
              "store": {
                  "id": 2,
                  "name": "Xbox Store",
                  "slug": "xbox-store",
                  "domain": "microsoft.com",
                  "games_count": 4712,
                  "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 31,
              "name": "Singleplayer",
              "slug": "singleplayer",
              "language": "eng",
              "games_count": 162985,
              "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 7,
              "name": "Multiplayer",
              "slug": "multiplayer",
              "language": "eng",
              "games_count": 30873,
              "image_background": "https://media.rawg.io/media/games/8cc/8cce7c0e99dcc43d66c8efd42f9d03e3.jpg"
          },
          {
              "id": 13,
              "name": "Atmospheric",
              "slug": "atmospheric",
              "language": "eng",
              "games_count": 21630,
              "image_background": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg"
          },
          {
              "id": 42,
              "name": "Great Soundtrack",
              "slug": "great-soundtrack",
              "language": "eng",
              "games_count": 3202,
              "image_background": "https://media.rawg.io/media/games/b7b/b7b8381707152afc7d91f5d95de70e39.jpg"
          },
          {
              "id": 18,
              "name": "Co-op",
              "slug": "co-op",
              "language": "eng",
              "games_count": 8306,
              "image_background": "https://media.rawg.io/media/games/ec3/ec3a7db7b8ab5a71aad622fe7c62632f.jpg"
          },
          {
              "id": 118,
              "name": "Story Rich",
              "slug": "story-rich",
              "language": "eng",
              "games_count": 14512,
              "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
          },
          {
              "id": 36,
              "name": "Open World",
              "slug": "open-world",
              "language": "eng",
              "games_count": 5045,
              "image_background": "https://media.rawg.io/media/games/6cd/6cd653e0aaef5ff8bbd295bf4bcb12eb.jpg"
          },
          {
              "id": 8,
              "name": "First-Person",
              "slug": "first-person",
              "language": "eng",
              "games_count": 21101,
              "image_background": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg"
          },
          {
              "id": 149,
              "name": "Third Person",
              "slug": "third-person",
              "language": "eng",
              "games_count": 6912,
              "image_background": "https://media.rawg.io/media/games/d69/d69810315bd7e226ea2d21f9156af629.jpg"
          },
          {
              "id": 40845,
              "name": "Partial Controller Support",
              "slug": "partial-controller-support",
              "language": "eng",
              "games_count": 8369,
              "image_background": "https://media.rawg.io/media/games/c80/c80bcf321da44d69b18a06c04d942662.jpg"
          },
          {
              "id": 30,
              "name": "FPS",
              "slug": "fps",
              "language": "eng",
              "games_count": 10374,
              "image_background": "https://media.rawg.io/media/games/26d/26d4437715bee60138dab4a7c8c59c92.jpg"
          },
          {
              "id": 9,
              "name": "Online Co-Op",
              "slug": "online-co-op",
              "language": "eng",
              "games_count": 3482,
              "image_background": "https://media.rawg.io/media/games/48c/48cb04ca483be865e3a83119c94e6097.jpg"
          },
          {
              "id": 26,
              "name": "Gore",
              "slug": "gore",
              "language": "eng",
              "games_count": 4411,
              "image_background": "https://media.rawg.io/media/games/d58/d588947d4286e7b5e0e12e1bea7d9844.jpg"
          },
          {
              "id": 37,
              "name": "Sandbox",
              "slug": "sandbox",
              "language": "eng",
              "games_count": 4817,
              "image_background": "https://media.rawg.io/media/games/48c/48cb04ca483be865e3a83119c94e6097.jpg"
          },
          {
              "id": 6,
              "name": "Exploration",
              "slug": "exploration",
              "language": "eng",
              "games_count": 15127,
              "image_background": "https://media.rawg.io/media/games/d82/d82990b9c67ba0d2d09d4e6fa88885a7.jpg"
          },
          {
              "id": 34,
              "name": "Violent",
              "slug": "violent",
              "language": "eng",
              "games_count": 5233,
              "image_background": "https://media.rawg.io/media/games/a0e/a0ef08621301a1eab5e04fa5c96978fa.jpeg"
          },
          {
              "id": 150,
              "name": "Third-Person Shooter",
              "slug": "third-person-shooter",
              "language": "eng",
              "games_count": 2264,
              "image_background": "https://media.rawg.io/media/games/a3c/a3c529a12c896c0ef02db5b4741de2ba.jpg"
          },
          {
              "id": 157,
              "name": "PvP",
              "slug": "pvp",
              "language": "eng",
              "games_count": 5486,
              "image_background": "https://media.rawg.io/media/games/569/56978b5a77f13aa2ec5d09ec81d01cad.jpg"
          },
          {
              "id": 40837,
              "name": "In-App Purchases",
              "slug": "in-app-purchases",
              "language": "eng",
              "games_count": 1679,
              "image_background": "https://media.rawg.io/media/games/26b/26b27e1da9e3727fcb12e3e4e86c8c19.jpg"
          },
          {
              "id": 192,
              "name": "Mature",
              "slug": "mature",
              "language": "eng",
              "games_count": 1417,
              "image_background": "https://media.rawg.io/media/games/8ca/8ca40b562a755d6a0e30d48e6c74b178.jpg"
          },
          {
              "id": 89,
              "name": "Historical",
              "slug": "historical",
              "language": "eng",
              "games_count": 1946,
              "image_background": "https://media.rawg.io/media/games/116/116b93c6876a361a96b2eee3ee58ab13.jpg"
          },
          {
              "id": 110,
              "name": "Cinematic",
              "slug": "cinematic",
              "language": "eng",
              "games_count": 896,
              "image_background": "https://media.rawg.io/media/games/569/56978b5a77f13aa2ec5d09ec81d01cad.jpg"
          },
          {
              "id": 77,
              "name": "Realistic",
              "slug": "realistic",
              "language": "eng",
              "games_count": 2490,
              "image_background": "https://media.rawg.io/media/games/511/5115617b4180a4e4505e0de09e62c6a0.jpg"
          },
          {
              "id": 144,
              "name": "Crime",
              "slug": "crime",
              "language": "eng",
              "games_count": 2199,
              "image_background": "https://media.rawg.io/media/games/5fa/5fae5fec3c943179e09da67a4427d68f.jpg"
          },
          {
              "id": 478,
              "name": "3rd-Person Perspective",
              "slug": "3rd-person-perspective",
              "language": "eng",
              "games_count": 86,
              "image_background": "https://media.rawg.io/media/games/053/053fc543bf488349610f1ae2d0c1b51b.jpg"
          },
          {
              "id": 270,
              "name": "Blood",
              "slug": "blood",
              "language": "eng",
              "games_count": 1693,
              "image_background": "https://media.rawg.io/media/games/4fe/4feffcec6315c5f5a96442a8444431ca.jpg"
          },
          {
              "id": 45878,
              "name": "Online PvP",
              "slug": "online-pvp",
              "language": "eng",
              "games_count": 2135,
              "image_background": "https://media.rawg.io/media/games/998/9980c4296f311d8bcc5b451ca51e4fe1.jpg"
          },
          {
              "id": 78,
              "name": "America",
              "slug": "america",
              "language": "eng",
              "games_count": 326,
              "image_background": "https://media.rawg.io/media/games/c69/c69e0952cdea6baa7cf0739b2e7792fb.jpg"
          },
          {
              "id": 578,
              "name": "Masterpiece",
              "slug": "masterpiece",
              "language": "eng",
              "games_count": 227,
              "image_background": "https://media.rawg.io/media/games/793/79307648580a262f6cac402c3007efe0.jpg"
          },
          {
              "id": 577,
              "name": "Beautiful",
              "slug": "beautiful",
              "language": "eng",
              "games_count": 1748,
              "image_background": "https://media.rawg.io/media/games/22a/22a3b2ddb5b344b1081cc28768f8ac84.jpg"
          },
          {
              "id": 181,
              "name": "Hunting",
              "slug": "hunting",
              "language": "eng",
              "games_count": 741,
              "image_background": "https://media.rawg.io/media/screenshots/73e/73e4d78a55248fc26a4e06726b6bd969.jpg"
          },
          {
              "id": 152,
              "name": "Western",
              "slug": "western",
              "language": "eng",
              "games_count": 1046,
              "image_background": "https://media.rawg.io/media/games/985/985dc43fe4fd5f0a7ae2a725673d6ac6.jpg"
          },
          {
              "id": 5452,
              "name": "3rd-person",
              "slug": "3rd-person",
              "language": "eng",
              "games_count": 88,
              "image_background": "https://media.rawg.io/media/screenshots/8fa/8fad3b7660e51a78d4eefd6da04b645a.jpg"
          }
      ],
      "esrb_rating": {
          "id": 4,
          "name": "Mature",
          "slug": "mature"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 778173,
              "image": "https://media.rawg.io/media/screenshots/7b8/7b8895a23e8ca0dbd9e1ba24696579d9.jpg"
          },
          {
              "id": 778174,
              "image": "https://media.rawg.io/media/screenshots/b8c/b8cee381079d58b981594ede46a3d6ca.jpg"
          },
          {
              "id": 778175,
              "image": "https://media.rawg.io/media/screenshots/fd6/fd6e41d4c30c098158568aef32dfed35.jpg"
          },
          {
              "id": 778176,
              "image": "https://media.rawg.io/media/screenshots/2ed/2ed3b2791b3bbed6b98bf362694aeb73.jpg"
          },
          {
              "id": 778177,
              "image": "https://media.rawg.io/media/screenshots/857/8573b9f4f06a0c112d6e39cdf3544881.jpg"
          },
          {
              "id": 778178,
              "image": "https://media.rawg.io/media/screenshots/985/985e3e1f1d1af1ab0797d43a95d472cc.jpg"
          }
      ]
  },
  {
      "id": 13537,
      "slug": "half-life-2",
      "name": "Half-Life 2",
      "released": "2004-11-16",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/b8c/b8c243eaa0fbac8115e0cdccac3f91dc.jpg",
      "rating": 4.49,
      "rating_top": 5,
      "ratings": [
          {
              "id": 5,
              "title": "exceptional",
              "count": 2055,
              "percent": 63.48
          },
          {
              "id": 4,
              "title": "recommended",
              "count": 901,
              "percent": 27.83
          },
          {
              "id": 3,
              "title": "meh",
              "count": 190,
              "percent": 5.87
          },
          {
              "id": 1,
              "title": "skip",
              "count": 91,
              "percent": 2.81
          }
      ],
      "ratings_count": 3223,
      "reviews_text_count": 11,
      "added": 11579,
      "added_by_status": {
          "yet": 543,
          "owned": 7301,
          "beaten": 3002,
          "toplay": 232,
          "dropped": 422,
          "playing": 79
      },
      "metacritic": 96,
      "playtime": 7,
      "suggestions_count": 559,
      "updated": "2019-09-17T15:58:20",
      "user_game": null,
      "reviews_count": 3237,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2004-11-16",
              "requirements_en": null,
              "requirements_ru": {
                  "minimum": "Pentium III/Athlon 1.2 ГГц,256 Мб памяти,3D-ускоритель с 64 Мб памяти,5 Гб на винчестере,доступ в Интернет",
                  "recommended": "Pentium 4/Athlon XP 2.5 ГГц,512 Мб памяти,3D-ускоритель со 128 Мб памяти,5 Гб на винчестере,доступ в Интернет"
              }
          },
          {
              "platform": {
                  "id": 14,
                  "name": "Xbox 360",
                  "slug": "xbox360",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 2764,
                  "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
              },
              "released_at": "2004-11-16",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 6,
                  "name": "Linux",
                  "slug": "linux",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 66467,
                  "image_background": "https://media.rawg.io/media/games/d69/d69810315bd7e226ea2d21f9156af629.jpg"
              },
              "released_at": "2004-11-16",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 80,
                  "name": "Xbox",
                  "slug": "xbox-old",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 708,
                  "image_background": "https://media.rawg.io/media/games/2f5/2f5eb72fe45540e93ac2726877551a20.jpg"
              },
              "released_at": "2004-11-16",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 21,
                  "name": "Android",
                  "slug": "android",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 47490,
                  "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
              },
              "released_at": "2004-11-16",
              "requirements_en": {
                  "minimum": "4.4 and up"
              },
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 5,
                  "name": "macOS",
                  "slug": "macos",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 91804,
                  "image_background": "https://media.rawg.io/media/games/b54/b54598d1d5cc31899f4f0a7e3122a7b0.jpg"
              },
              "released_at": "2004-11-16",
              "requirements_en": null,
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          },
          {
              "platform": {
                  "id": 8,
                  "name": "Android",
                  "slug": "android"
              }
          },
          {
              "platform": {
                  "id": 5,
                  "name": "Apple Macintosh",
                  "slug": "mac"
              }
          },
          {
              "platform": {
                  "id": 6,
                  "name": "Linux",
                  "slug": "linux"
              }
          }
      ],
      "genres": [
          {
              "id": 4,
              "name": "Action",
              "slug": "action",
              "games_count": 149659,
              "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
          },
          {
              "id": 2,
              "name": "Shooter",
              "slug": "shooter",
              "games_count": 51719,
              "image_background": "https://media.rawg.io/media/games/9fa/9fa63622543e5d4f6d99aa9d73b043de.jpg"
          }
      ],
      "stores": [
          {
              "id": 14891,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          },
          {
              "id": 41441,
              "store": {
                  "id": 8,
                  "name": "Google Play",
                  "slug": "google-play",
                  "domain": "play.google.com",
                  "games_count": 16824,
                  "image_background": "https://media.rawg.io/media/games/1bd/1bd2657b81eb0c99338120ad444b24ff.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 31,
              "name": "Singleplayer",
              "slug": "singleplayer",
              "language": "eng",
              "games_count": 162985,
              "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 40847,
              "name": "Steam Achievements",
              "slug": "steam-achievements",
              "language": "eng",
              "games_count": 25765,
              "image_background": "https://media.rawg.io/media/games/4ba/4ba9b4b68ffcc7019b112174883ba4d6.jpg"
          },
          {
              "id": 7,
              "name": "Multiplayer",
              "slug": "multiplayer",
              "language": "eng",
              "games_count": 30873,
              "image_background": "https://media.rawg.io/media/games/8cc/8cce7c0e99dcc43d66c8efd42f9d03e3.jpg"
          },
          {
              "id": 7808,
              "name": "steam-trading-cards",
              "slug": "steam-trading-cards",
              "language": "eng",
              "games_count": 7582,
              "image_background": "https://media.rawg.io/media/games/4cf/4cfc6b7f1850590a4634b08bfab308ab.jpg"
          },
          {
              "id": 13,
              "name": "Atmospheric",
              "slug": "atmospheric",
              "language": "eng",
              "games_count": 21630,
              "image_background": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg"
          },
          {
              "id": 40849,
              "name": "Steam Cloud",
              "slug": "steam-cloud",
              "language": "eng",
              "games_count": 11732,
              "image_background": "https://media.rawg.io/media/games/c6b/c6bfece1daf8d06bc0a60632ac78e5bf.jpg"
          },
          {
              "id": 42,
              "name": "Great Soundtrack",
              "slug": "great-soundtrack",
              "language": "eng",
              "games_count": 3202,
              "image_background": "https://media.rawg.io/media/games/b7b/b7b8381707152afc7d91f5d95de70e39.jpg"
          },
          {
              "id": 118,
              "name": "Story Rich",
              "slug": "story-rich",
              "language": "eng",
              "games_count": 14512,
              "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
          },
          {
              "id": 8,
              "name": "First-Person",
              "slug": "first-person",
              "language": "eng",
              "games_count": 21101,
              "image_background": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg"
          },
          {
              "id": 32,
              "name": "Sci-fi",
              "slug": "sci-fi",
              "language": "eng",
              "games_count": 14086,
              "image_background": "https://media.rawg.io/media/games/8e4/8e4de3f54ac659e08a7ba6a2b731682a.jpg"
          },
          {
              "id": 40845,
              "name": "Partial Controller Support",
              "slug": "partial-controller-support",
              "language": "eng",
              "games_count": 8369,
              "image_background": "https://media.rawg.io/media/games/c80/c80bcf321da44d69b18a06c04d942662.jpg"
          },
          {
              "id": 16,
              "name": "Horror",
              "slug": "horror",
              "language": "eng",
              "games_count": 32483,
              "image_background": "https://media.rawg.io/media/games/e6d/e6de699bd788497f4b52e2f41f9698f2.jpg"
          },
          {
              "id": 30,
              "name": "FPS",
              "slug": "fps",
              "language": "eng",
              "games_count": 10374,
              "image_background": "https://media.rawg.io/media/games/26d/26d4437715bee60138dab4a7c8c59c92.jpg"
          },
          {
              "id": 193,
              "name": "Classic",
              "slug": "classic",
              "language": "eng",
              "games_count": 1676,
              "image_background": "https://media.rawg.io/media/games/4ba/4ba9b4b68ffcc7019b112174883ba4d6.jpg"
          },
          {
              "id": 63,
              "name": "Zombies",
              "slug": "zombies",
              "language": "eng",
              "games_count": 8465,
              "image_background": "https://media.rawg.io/media/games/4cb/4cb463b5588adc672124fb041f09e91c.jpg"
          },
          {
              "id": 62,
              "name": "Moddable",
              "slug": "moddable",
              "language": "eng",
              "games_count": 679,
              "image_background": "https://media.rawg.io/media/games/4a0/4a0a1316102366260e6f38fd2a9cfdce.jpg"
          },
          {
              "id": 40833,
              "name": "Captions available",
              "slug": "captions-available",
              "language": "eng",
              "games_count": 1146,
              "image_background": "https://media.rawg.io/media/games/226/2262cea0b385db6cf399f4be831603b0.jpg"
          },
          {
              "id": 114,
              "name": "Physics",
              "slug": "physics",
              "language": "eng",
              "games_count": 15622,
              "image_background": "https://media.rawg.io/media/games/a3c/a3c529a12c896c0ef02db5b4741de2ba.jpg"
          },
          {
              "id": 172,
              "name": "Aliens",
              "slug": "aliens",
              "language": "eng",
              "games_count": 5413,
              "image_background": "https://media.rawg.io/media/games/963/963815b2a1a88475a31f311b591e70fb.jpg"
          },
          {
              "id": 119,
              "name": "Dystopian",
              "slug": "dystopian",
              "language": "eng",
              "games_count": 1445,
              "image_background": "https://media.rawg.io/media/games/c2e/c2e6ad5c838d551aeff376f1f3d9d65e.jpg"
          },
          {
              "id": 40839,
              "name": "Includes Source SDK",
              "slug": "includes-source-sdk",
              "language": "eng",
              "games_count": 55,
              "image_background": "https://media.rawg.io/media/screenshots/4e5/4e5e71d53468bcf5d6686c46fec95d78.jpg"
          },
          {
              "id": 319,
              "name": "Silent Protagonist",
              "slug": "silent-protagonist",
              "language": "eng",
              "games_count": 69,
              "image_background": "https://media.rawg.io/media/games/372/3724c266c9d028a6cff791dd8df4b98e.jpg"
          },
          {
              "id": 62349,
              "name": "vr mod",
              "slug": "vr-mod",
              "language": "eng",
              "games_count": 17,
              "image_background": "https://media.rawg.io/media/games/645/64578c2a6daa30995692525172fd13ef.jpg"
          }
      ],
      "esrb_rating": {
          "id": 4,
          "name": "Mature",
          "slug": "mature"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/b8c/b8c243eaa0fbac8115e0cdccac3f91dc.jpg"
          },
          {
              "id": 115804,
              "image": "https://media.rawg.io/media/screenshots/8af/8af6188357426890cbc8c8a34d9e7b75.jpg"
          },
          {
              "id": 115805,
              "image": "https://media.rawg.io/media/screenshots/3b5/3b542c954ba5bd2f32da067c8122cd80.jpg"
          },
          {
              "id": 115806,
              "image": "https://media.rawg.io/media/screenshots/3d6/3d6066e45d259d2e83bf6767e6113d94.jpg"
          },
          {
              "id": 115807,
              "image": "https://media.rawg.io/media/screenshots/e49/e49327df2404df6c5dafa8eac7990852.jpg"
          },
          {
              "id": 115808,
              "image": "https://media.rawg.io/media/screenshots/5dd/5dd3e53131bbfe6278bd15b9abe261a0.jpg"
          },
          {
              "id": 115809,
              "image": "https://media.rawg.io/media/screenshots/e99/e995e154d4f9e2df0367adea528a72c5.jpg"
          }
      ]
  },
  {
      "id": 4286,
      "slug": "bioshock",
      "name": "BioShock",
      "released": "2007-08-21",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/bc0/bc06a29ceac58652b684deefe7d56099.jpg",
      "rating": 4.37,
      "rating_top": 5,
      "ratings": [
          {
              "id": 5,
              "title": "exceptional",
              "count": 1517,
              "percent": 53.34
          },
          {
              "id": 4,
              "title": "recommended",
              "count": 1040,
              "percent": 36.57
          },
          {
              "id": 3,
              "title": "meh",
              "count": 198,
              "percent": 6.96
          },
          {
              "id": 1,
              "title": "skip",
              "count": 89,
              "percent": 3.13
          }
      ],
      "ratings_count": 2812,
      "reviews_text_count": 21,
      "added": 11509,
      "added_by_status": {
          "yet": 514,
          "owned": 7382,
          "beaten": 2669,
          "toplay": 261,
          "dropped": 577,
          "playing": 106
      },
      "metacritic": 96,
      "playtime": 3,
      "suggestions_count": 650,
      "updated": "2022-02-11T13:42:23",
      "user_game": null,
      "reviews_count": 2844,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 14,
                  "name": "Xbox 360",
                  "slug": "xbox360",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 2764,
                  "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
              },
              "released_at": "2007-08-21",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 16,
                  "name": "PlayStation 3",
                  "slug": "playstation3",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 3626,
                  "image_background": "https://media.rawg.io/media/games/490/49016e06ae2103881ff6373248843069.jpg"
              },
              "released_at": "2007-08-21",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 3,
                  "name": "iOS",
                  "slug": "ios",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 74133,
                  "image_background": "https://media.rawg.io/media/games/d5a/d5a24f9f71315427fa6e966fdd98dfa6.jpg"
              },
              "released_at": "2007-08-21",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 7,
                  "name": "Nintendo Switch",
                  "slug": "nintendo-switch",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 4771,
                  "image_background": "https://media.rawg.io/media/games/7cf/7cfc9220b401b7a300e409e539c9afd5.jpg"
              },
              "released_at": "2007-08-21",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 1,
                  "name": "Xbox One",
                  "slug": "xbox-one",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 5216,
                  "image_background": "https://media.rawg.io/media/games/f46/f466571d536f2e3ea9e815ad17177501.jpg"
              },
              "released_at": "2007-08-21",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2007-08-21",
              "requirements_en": {
                  "minimum": "<h2 class=\"bb_tag\"><strong>Minimum: </strong></h2><ul class=\"bb_ul\"><li><strong>Operating System</strong>: Windows XP (with Service Pack 2) or Windows Vista<br></li><li><strong>CPU</strong>: Intel single-core Pentium 4 processor at 2.4GHz<br></li><li><strong>RAM</strong>: 1 GB<br></li><li><strong>Video Card</strong>: Direct X 9.0c compliant video card with 128MB RAM and Pixel Shader 3.0 (NVIDIA 6600 or better/ATI X1300 or better, excluding ATI X1550)<br></li><li><strong>Sound Card</strong>: 100% direct X 9.0c compatible sound card<br></li><li><strong>Hard Drive Space</strong>: 8GB<br></li><li>Game requires Internet connection for activation</li></ul>",
                  "recommended": "<h2 class=\"bb_tag\"><strong>Recommended: </strong></h2><ul class=\"bb_ul\"><li><strong>CPU</strong>: Intel Core 2 Duo processor<br></li><li><strong>RAM</strong>: 2GB<br></li><li><strong>Video Card</strong>: DX 9 - Direct X 9.0c compliant video card with 512 MB RAM and Pixel Shader 3.0 (NVIDIA GeForce 7900 GT or better), DX 10 - NVIDIA GeForce 8600 or better<br></li><li><strong>Sound Card</strong>: SoundBlaster(r) X-Fi(tm) series (optimized foruse with Creative Labs EAX ADVANCED HD 4.0 or EAX ADVANCED HD 5.0 compatible sound cards)</li></ul>"
              },
              "requirements_ru": {
                  "minimum": "Pentium 4/Athlon 64 2.5 ГГц,1 Гб памяти,3D-ускоритель со 128 Мб памяти и SM 3.0, 7.5 Гб на винчестере, Windows XP SP2 или Vista,Интернет-соединение",
                  "recommended": "Core 2 Duo/Athlon 64 X2 3 ГГц,2 Гб памяти,3D-ускоритель с 512 Мб памяти и SM 3.0, 7.5 Гб на винчестере, Windows Vista,Интернет-соединение"
              }
          },
          {
              "platform": {
                  "id": 5,
                  "name": "macOS",
                  "slug": "macos",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 91804,
                  "image_background": "https://media.rawg.io/media/games/b54/b54598d1d5cc31899f4f0a7e3122a7b0.jpg"
              },
              "released_at": "2007-08-21",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 18,
                  "name": "PlayStation 4",
                  "slug": "playstation4",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 6288,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2007-08-21",
              "requirements_en": null,
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 2,
                  "name": "PlayStation",
                  "slug": "playstation"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          },
          {
              "platform": {
                  "id": 4,
                  "name": "iOS",
                  "slug": "ios"
              }
          },
          {
              "platform": {
                  "id": 5,
                  "name": "Apple Macintosh",
                  "slug": "mac"
              }
          },
          {
              "platform": {
                  "id": 7,
                  "name": "Nintendo",
                  "slug": "nintendo"
              }
          }
      ],
      "genres": [
          {
              "id": 4,
              "name": "Action",
              "slug": "action",
              "games_count": 149659,
              "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
          },
          {
              "id": 2,
              "name": "Shooter",
              "slug": "shooter",
              "games_count": 51719,
              "image_background": "https://media.rawg.io/media/games/9fa/9fa63622543e5d4f6d99aa9d73b043de.jpg"
          }
      ],
      "stores": [
          {
              "id": 4614,
              "store": {
                  "id": 3,
                  "name": "PlayStation Store",
                  "slug": "playstation-store",
                  "domain": "store.playstation.com",
                  "games_count": 7745,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 79531,
              "store": {
                  "id": 4,
                  "name": "App Store",
                  "slug": "apple-appstore",
                  "domain": "apps.apple.com",
                  "games_count": 72461,
                  "image_background": "https://media.rawg.io/media/games/7ac/7aca7ccf0e70cd0974cb899ab9e5158e.jpg"
              }
          },
          {
              "id": 440407,
              "store": {
                  "id": 2,
                  "name": "Xbox Store",
                  "slug": "xbox-store",
                  "domain": "microsoft.com",
                  "games_count": 4712,
                  "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
              }
          },
          {
              "id": 20580,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          },
          {
              "id": 33844,
              "store": {
                  "id": 7,
                  "name": "Xbox 360 Store",
                  "slug": "xbox360",
                  "domain": "marketplace.xbox.com",
                  "games_count": 1917,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 31,
              "name": "Singleplayer",
              "slug": "singleplayer",
              "language": "eng",
              "games_count": 162985,
              "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 13,
              "name": "Atmospheric",
              "slug": "atmospheric",
              "language": "eng",
              "games_count": 21630,
              "image_background": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg"
          },
          {
              "id": 42,
              "name": "Great Soundtrack",
              "slug": "great-soundtrack",
              "language": "eng",
              "games_count": 3202,
              "image_background": "https://media.rawg.io/media/games/b7b/b7b8381707152afc7d91f5d95de70e39.jpg"
          },
          {
              "id": 24,
              "name": "RPG",
              "slug": "rpg",
              "language": "eng",
              "games_count": 14383,
              "image_background": "https://media.rawg.io/media/games/c24/c24ec439abf4a2e92f3429dfa83f7f94.jpg"
          },
          {
              "id": 118,
              "name": "Story Rich",
              "slug": "story-rich",
              "language": "eng",
              "games_count": 14512,
              "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
          },
          {
              "id": 8,
              "name": "First-Person",
              "slug": "first-person",
              "language": "eng",
              "games_count": 21101,
              "image_background": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg"
          },
          {
              "id": 32,
              "name": "Sci-fi",
              "slug": "sci-fi",
              "language": "eng",
              "games_count": 14086,
              "image_background": "https://media.rawg.io/media/games/8e4/8e4de3f54ac659e08a7ba6a2b731682a.jpg"
          },
          {
              "id": 40845,
              "name": "Partial Controller Support",
              "slug": "partial-controller-support",
              "language": "eng",
              "games_count": 8369,
              "image_background": "https://media.rawg.io/media/games/c80/c80bcf321da44d69b18a06c04d942662.jpg"
          },
          {
              "id": 16,
              "name": "Horror",
              "slug": "horror",
              "language": "eng",
              "games_count": 32483,
              "image_background": "https://media.rawg.io/media/games/e6d/e6de699bd788497f4b52e2f41f9698f2.jpg"
          },
          {
              "id": 30,
              "name": "FPS",
              "slug": "fps",
              "language": "eng",
              "games_count": 10374,
              "image_background": "https://media.rawg.io/media/games/26d/26d4437715bee60138dab4a7c8c59c92.jpg"
          },
          {
              "id": 193,
              "name": "Classic",
              "slug": "classic",
              "language": "eng",
              "games_count": 1676,
              "image_background": "https://media.rawg.io/media/games/4ba/4ba9b4b68ffcc7019b112174883ba4d6.jpg"
          },
          {
              "id": 97,
              "name": "Action RPG",
              "slug": "action-rpg",
              "language": "eng",
              "games_count": 4647,
              "image_background": "https://media.rawg.io/media/games/83f/83f6f70a7c1b86cd2637b029d8b42caa.jpg"
          },
          {
              "id": 41,
              "name": "Dark",
              "slug": "dark",
              "language": "eng",
              "games_count": 10634,
              "image_background": "https://media.rawg.io/media/games/7f6/7f6cd70ba2ad57053b4847c13569f2d8.jpg"
          },
          {
              "id": 119,
              "name": "Dystopian",
              "slug": "dystopian",
              "language": "eng",
              "games_count": 1445,
              "image_background": "https://media.rawg.io/media/games/c2e/c2e6ad5c838d551aeff376f1f3d9d65e.jpg"
          },
          {
              "id": 154,
              "name": "Steampunk",
              "slug": "steampunk",
              "language": "eng",
              "games_count": 920,
              "image_background": "https://media.rawg.io/media/games/c5b/c5b3b6aa220050f7f504f4477cb51d3b.jpg"
          },
          {
              "id": 208,
              "name": "Alternate History",
              "slug": "alternate-history",
              "language": "eng",
              "games_count": 1202,
              "image_background": "https://media.rawg.io/media/screenshots/245/245579c536d2a06e69d391573d911679.jpg"
          },
          {
              "id": 287,
              "name": "Political",
              "slug": "political",
              "language": "eng",
              "games_count": 423,
              "image_background": "https://media.rawg.io/media/screenshots/617/6173ebd9a0ed696369e25a9066e57a68.jpg"
          },
          {
              "id": 250,
              "name": "Underwater",
              "slug": "underwater",
              "language": "eng",
              "games_count": 1690,
              "image_background": "https://media.rawg.io/media/screenshots/e1b/e1ba70b0da3b80b9691a7a2db2fcd395.jpg"
          }
      ],
      "esrb_rating": {
          "id": 4,
          "name": "Mature",
          "slug": "mature"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/bc0/bc06a29ceac58652b684deefe7d56099.jpg"
          },
          {
              "id": 170993,
              "image": "https://media.rawg.io/media/screenshots/01f/01f62d7064838a5c3202acfc61503487.jpg"
          },
          {
              "id": 170994,
              "image": "https://media.rawg.io/media/screenshots/7f5/7f517e07e36e4af5a7c0b86a7d42853f.jpg"
          },
          {
              "id": 170995,
              "image": "https://media.rawg.io/media/screenshots/aca/aca089b963a42ec4cbf56b5e5334af8e.jpg"
          },
          {
              "id": 170996,
              "image": "https://media.rawg.io/media/screenshots/3aa/3aa6f71eba1d64e671bd45826ca96560.jpg"
          },
          {
              "id": 170997,
              "image": "https://media.rawg.io/media/screenshots/d8e/d8ed29c7c0b41e4013588847944ed446.jpg"
          },
          {
              "id": 170998,
              "image": "https://media.rawg.io/media/screenshots/146/146e418797aca19296f90d259207414c.jpg"
          }
      ]
  },
  {
      "id": 1030,
      "slug": "limbo",
      "name": "Limbo",
      "released": "2010-07-21",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/942/9424d6bb763dc38d9378b488603c87fa.jpg",
      "rating": 4.16,
      "rating_top": 4,
      "ratings": [
          {
              "id": 4,
              "title": "recommended",
              "count": 1476,
              "percent": 52.25
          },
          {
              "id": 5,
              "title": "exceptional",
              "count": 995,
              "percent": 35.22
          },
          {
              "id": 3,
              "title": "meh",
              "count": 266,
              "percent": 9.42
          },
          {
              "id": 1,
              "title": "skip",
              "count": 88,
              "percent": 3.12
          }
      ],
      "ratings_count": 2792,
      "reviews_text_count": 22,
      "added": 11276,
      "added_by_status": {
          "yet": 471,
          "owned": 7217,
          "beaten": 2695,
          "toplay": 245,
          "dropped": 565,
          "playing": 83
      },
      "metacritic": 88,
      "playtime": 3,
      "suggestions_count": 185,
      "updated": "2021-08-13T19:30:26",
      "user_game": null,
      "reviews_count": 2825,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 6,
                  "name": "Linux",
                  "slug": "linux",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 66467,
                  "image_background": "https://media.rawg.io/media/games/d69/d69810315bd7e226ea2d21f9156af629.jpg"
              },
              "released_at": "2010-07-21",
              "requirements_en": {
                  "minimum": "<ul class=\"bb_ul\"><li><strong>OS:</strong> SteamOS, Ubuntu 12.04 or later, or otherwise compatible Linux distribution.<br>\t\t\t\t\t\t</li><li><strong>Processor:</strong> 2GHz<br>\t\t\t\t\t\t</li><li><strong>Memory:</strong> 1 GB RAM <br>\t\t\t\t\t\t</li><li><strong>Hard Disk Space:</strong> 150MB\t<br>\t\t\t\t\t\t</li><li><strong>Video Card:</strong> OpenGL 2.0 compatible video card with 256 MB shared or dedicated RAM <br>\t\t\t\t\t</li></ul>"
              },
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 19,
                  "name": "PS Vita",
                  "slug": "ps-vita",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 1958,
                  "image_background": "https://media.rawg.io/media/games/2ae/2aedae90b1377a0f3e5ce54d24f8e41a.jpg"
              },
              "released_at": "2010-07-21",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 21,
                  "name": "Android",
                  "slug": "android",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 47490,
                  "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
              },
              "released_at": "2010-07-21",
              "requirements_en": {
                  "minimum": "4.4 and up"
              },
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 1,
                  "name": "Xbox One",
                  "slug": "xbox-one",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 5216,
                  "image_background": "https://media.rawg.io/media/games/f46/f466571d536f2e3ea9e815ad17177501.jpg"
              },
              "released_at": "2010-07-21",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 7,
                  "name": "Nintendo Switch",
                  "slug": "nintendo-switch",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 4771,
                  "image_background": "https://media.rawg.io/media/games/7cf/7cfc9220b401b7a300e409e539c9afd5.jpg"
              },
              "released_at": "2010-07-21",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 3,
                  "name": "iOS",
                  "slug": "ios",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 74133,
                  "image_background": "https://media.rawg.io/media/games/d5a/d5a24f9f71315427fa6e966fdd98dfa6.jpg"
              },
              "released_at": "2010-07-21",
              "requirements_en": {
                  "minimum": "iPad 2 Wifi, iPad 2 3G, iPhone 4S, iPad Third Gen, iPad Third Gen 4G, iPhone 5, iPod Touch Fifth Gen, iPad Fourth Gen, iPad Fourth Gen 4G, iPad Mini, iPad Mini 4G, iPhone 5c, iPhone 5s, iPad Air, iPad Air Cellular, iPad Mini Retina, iPad Mini Retina Cellular, iPhone 6, iPhone 6 Plus, iPad Air 2, iPad Air 2 Cellular, iPad Mini 3, iPad Mini 3 Cellular, iPod Touch Sixth Gen, iPhone 6s, iPhone 6s Plus, iPad Mini 4, iPad Mini 4 Cellular, iPad Pro, iPad Pro Cellular, iPad Pro 9.7, iPad Pro 9.7 Cellular, iPhone SE, iPhone 7, iPhone 7 Plus, iPad 6 1 1, iPad 6 1 2, iPad 7 1, iPad 7 2, iPad 7 3, iPad 7 4, iPhone 8, iPhone 8 Plus, iPhone X, iPad 7 5, iPad 7 6, iPhone X S, iPhone X S Max, iPhone X R, iPad 8 1 2, iPad 8 3 4, iPad 8 5 6, iPad 8 7 8, iPad Mini 5, iPad Mini 5 Cellular, iPad Air 3, iPad Air 3 Cellular, iPod Touch Seventh Gen"
              },
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2010-07-21",
              "requirements_en": {
                  "minimum": "<ul class=\"bb_ul\"><li><strong>OS:</strong> Windows XP, Vista, 7<br>\t\t\t\t\t\t</li><li><strong>Processor:</strong> 2 GHz<br>\t\t\t\t\t\t</li><li><strong>Memory:</strong> 512MB<br>\t\t\t\t\t\t</li><li><strong>Hard Disk Space:</strong> 150MB\t<br>\t\t\t\t\t\t</li><li><strong>Video Card:</strong> 5 years or younger. Integrated graphics and very low budget cards may not work. Shader Model 3.0 required<br>\t\t\t\t\t\t</li><li><strong>DirectX®:</strong> 9.0c\t<br>\t\t\t\t\t\t</li></ul>"
              },
              "requirements_ru": {
                  "minimum": "Pentium 4/Athlon XP 2 ГГц,512 Мб памяти,3D-ускоритель с 256 Мб памяти,150 Мб на винчестере",
                  "recommended": "Core 2 Duo/Atlon X2 2 ГГц,1 Гб памяти,3D-ускоритель с 512 Мб памяти,150 Мб на винчестере"
              }
          },
          {
              "platform": {
                  "id": 5,
                  "name": "macOS",
                  "slug": "macos",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 91804,
                  "image_background": "https://media.rawg.io/media/games/b54/b54598d1d5cc31899f4f0a7e3122a7b0.jpg"
              },
              "released_at": "2010-07-21",
              "requirements_en": {
                  "minimum": "Please be advised that LIMBO only runs Macs produced in 2009 and onwards.<br><ul class=\"bb_ul\"><li><strong>OS:</strong> OS X version Snow Leopard 10.6.3 or later.<br>\t\t\t\t\t\t</li><li><strong>Processor:</strong> Intel Mac<br>\t\t\t\t\t\t</li><li><strong>Memory:</strong> 1 GB RAM <br>\t\t\t\t\t\t</li><li><strong>Hard Disk Space:</strong> 150MB\t<br>\t\t\t\t\t\t</li><li><strong>Video Card:</strong> OpenGL 2.0 compatible video card with 256 MB shared or dedicated RAM (ATI or NVIDIA) <br>\t\t\t\t\t</li></ul>"
              },
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 14,
                  "name": "Xbox 360",
                  "slug": "xbox360",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 2764,
                  "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
              },
              "released_at": "2010-07-21",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 16,
                  "name": "PlayStation 3",
                  "slug": "playstation3",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 3626,
                  "image_background": "https://media.rawg.io/media/games/490/49016e06ae2103881ff6373248843069.jpg"
              },
              "released_at": "2010-07-21",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 18,
                  "name": "PlayStation 4",
                  "slug": "playstation4",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 6288,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2010-07-21",
              "requirements_en": null,
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 2,
                  "name": "PlayStation",
                  "slug": "playstation"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          },
          {
              "platform": {
                  "id": 4,
                  "name": "iOS",
                  "slug": "ios"
              }
          },
          {
              "platform": {
                  "id": 8,
                  "name": "Android",
                  "slug": "android"
              }
          },
          {
              "platform": {
                  "id": 5,
                  "name": "Apple Macintosh",
                  "slug": "mac"
              }
          },
          {
              "platform": {
                  "id": 6,
                  "name": "Linux",
                  "slug": "linux"
              }
          },
          {
              "platform": {
                  "id": 7,
                  "name": "Nintendo",
                  "slug": "nintendo"
              }
          }
      ],
      "genres": [
          {
              "id": 3,
              "name": "Adventure",
              "slug": "adventure",
              "games_count": 113029,
              "image_background": "https://media.rawg.io/media/games/9dd/9ddabb34840ea9227556670606cf8ea3.jpg"
          },
          {
              "id": 51,
              "name": "Indie",
              "slug": "indie",
              "games_count": 44488,
              "image_background": "https://media.rawg.io/media/screenshots/c97/c97b943741f5fbc936fe054d9d58851d.jpg"
          },
          {
              "id": 7,
              "name": "Puzzle",
              "slug": "puzzle",
              "games_count": 84387,
              "image_background": "https://media.rawg.io/media/games/8cd/8cd179c85bd3de8f79bef245b15075fb.jpg"
          },
          {
              "id": 83,
              "name": "Platformer",
              "slug": "platformer",
              "games_count": 85779,
              "image_background": "https://media.rawg.io/media/games/4cb/4cb855e8ef1578415a928e53c9f51867.png"
          }
      ],
      "stores": [
          {
              "id": 1054,
              "store": {
                  "id": 4,
                  "name": "App Store",
                  "slug": "apple-appstore",
                  "domain": "apps.apple.com",
                  "games_count": 72461,
                  "image_background": "https://media.rawg.io/media/games/7ac/7aca7ccf0e70cd0974cb899ab9e5158e.jpg"
              }
          },
          {
              "id": 3679,
              "store": {
                  "id": 3,
                  "name": "PlayStation Store",
                  "slug": "playstation-store",
                  "domain": "store.playstation.com",
                  "games_count": 7745,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 7493,
              "store": {
                  "id": 2,
                  "name": "Xbox Store",
                  "slug": "xbox-store",
                  "domain": "microsoft.com",
                  "games_count": 4712,
                  "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
              }
          },
          {
              "id": 10311,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          },
          {
              "id": 26852,
              "store": {
                  "id": 5,
                  "name": "GOG",
                  "slug": "gog",
                  "domain": "gog.com",
                  "games_count": 4149,
                  "image_background": "https://media.rawg.io/media/games/713/713269608dc8f2f40f5a670a14b2de94.jpg"
              }
          },
          {
              "id": 33137,
              "store": {
                  "id": 7,
                  "name": "Xbox 360 Store",
                  "slug": "xbox360",
                  "domain": "marketplace.xbox.com",
                  "games_count": 1917,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 49142,
              "store": {
                  "id": 6,
                  "name": "Nintendo Store",
                  "slug": "nintendo",
                  "domain": "nintendo.com",
                  "games_count": 8825,
                  "image_background": "https://media.rawg.io/media/games/b72/b7233d5d5b1e75e86bb860ccc7aeca85.jpg"
              }
          },
          {
              "id": 40035,
              "store": {
                  "id": 8,
                  "name": "Google Play",
                  "slug": "google-play",
                  "domain": "play.google.com",
                  "games_count": 16824,
                  "image_background": "https://media.rawg.io/media/games/1bd/1bd2657b81eb0c99338120ad444b24ff.jpg"
              }
          },
          {
              "id": 335541,
              "store": {
                  "id": 11,
                  "name": "Epic Games",
                  "slug": "epic-games",
                  "domain": "epicgames.com",
                  "games_count": 942,
                  "image_background": "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 31,
              "name": "Singleplayer",
              "slug": "singleplayer",
              "language": "eng",
              "games_count": 162985,
              "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 13,
              "name": "Atmospheric",
              "slug": "atmospheric",
              "language": "eng",
              "games_count": 21630,
              "image_background": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg"
          },
          {
              "id": 40836,
              "name": "Full controller support",
              "slug": "full-controller-support",
              "language": "eng",
              "games_count": 11963,
              "image_background": "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg"
          },
          {
              "id": 45,
              "name": "2D",
              "slug": "2d",
              "language": "eng",
              "games_count": 159451,
              "image_background": "https://media.rawg.io/media/games/283/283e7e600366b0da7021883d27159b27.jpg"
          },
          {
              "id": 16,
              "name": "Horror",
              "slug": "horror",
              "language": "eng",
              "games_count": 32483,
              "image_background": "https://media.rawg.io/media/games/e6d/e6de699bd788497f4b52e2f41f9698f2.jpg"
          },
          {
              "id": 49,
              "name": "Difficult",
              "slug": "difficult",
              "language": "eng",
              "games_count": 10816,
              "image_background": "https://media.rawg.io/media/games/226/2262cea0b385db6cf399f4be831603b0.jpg"
          },
          {
              "id": 115,
              "name": "Controller",
              "slug": "controller",
              "language": "eng",
              "games_count": 7311,
              "image_background": "https://media.rawg.io/media/games/b80/b80de593e66136f8a35c57960cc8fa3b.jpg"
          },
          {
              "id": 41,
              "name": "Dark",
              "slug": "dark",
              "language": "eng",
              "games_count": 10634,
              "image_background": "https://media.rawg.io/media/games/7f6/7f6cd70ba2ad57053b4847c13569f2d8.jpg"
          },
          {
              "id": 336,
              "name": "controller support",
              "slug": "controller-support",
              "language": "eng",
              "games_count": 293,
              "image_background": "https://media.rawg.io/media/games/003/0031c0067559d41df19cf98ad87e02aa.jpg"
          },
          {
              "id": 111,
              "name": "Short",
              "slug": "short",
              "language": "eng",
              "games_count": 42002,
              "image_background": "https://media.rawg.io/media/games/8ca/8ca40b562a755d6a0e30d48e6c74b178.jpg"
          },
          {
              "id": 113,
              "name": "Side Scroller",
              "slug": "side-scroller",
              "language": "eng",
              "games_count": 7687,
              "image_background": "https://media.rawg.io/media/games/6fc/6fcb1c529c764700d55f3bbc1b0fbb5b.jpg"
          },
          {
              "id": 114,
              "name": "Physics",
              "slug": "physics",
              "language": "eng",
              "games_count": 15622,
              "image_background": "https://media.rawg.io/media/games/a3c/a3c529a12c896c0ef02db5b4741de2ba.jpg"
          },
          {
              "id": 110,
              "name": "Cinematic",
              "slug": "cinematic",
              "language": "eng",
              "games_count": 896,
              "image_background": "https://media.rawg.io/media/games/569/56978b5a77f13aa2ec5d09ec81d01cad.jpg"
          },
          {
              "id": 83,
              "name": "Puzzle-Platformer",
              "slug": "puzzle-platformer",
              "language": "eng",
              "games_count": 8644,
              "image_background": "https://media.rawg.io/media/screenshots/405/40567fe45e6074a5b2bfbd4a3fea7809.jpg"
          },
          {
              "id": 46,
              "name": "Surreal",
              "slug": "surreal",
              "language": "eng",
              "games_count": 3755,
              "image_background": "https://media.rawg.io/media/screenshots/5a3/5a335ee04477c97d393e8ba03f8e6d91.jpg"
          },
          {
              "id": 112,
              "name": "Minimalist",
              "slug": "minimalist",
              "language": "eng",
              "games_count": 11519,
              "image_background": "https://media.rawg.io/media/screenshots/112/112c9ecfe850e318bb999660361782bb.jpeg"
          }
      ],
      "esrb_rating": {
          "id": 3,
          "name": "Teen",
          "slug": "teen"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/942/9424d6bb763dc38d9378b488603c87fa.jpg"
          },
          {
              "id": 30985,
              "image": "https://media.rawg.io/media/screenshots/512/512f4bc2092016478ddcb9e7e60aeec0.jpg"
          },
          {
              "id": 30986,
              "image": "https://media.rawg.io/media/screenshots/63d/63d30699e8fcab9c808e6714d9d3fd59.jpg"
          },
          {
              "id": 30987,
              "image": "https://media.rawg.io/media/screenshots/de0/de04bbc0fd9904071ef25bf23113c8c4.jpg"
          },
          {
              "id": 30988,
              "image": "https://media.rawg.io/media/screenshots/eed/eedbbca4ae2debf2d4e23e55d1f6cff7.jpg"
          },
          {
              "id": 30989,
              "image": "https://media.rawg.io/media/screenshots/59f/59f472b3ed7b414777a29213d70b4d17.jpg"
          },
          {
              "id": 30991,
              "image": "https://media.rawg.io/media/screenshots/e58/e58d31146e4a9e3786dabcbfc30126bc.jpg"
          }
      ]
  },
  {
      "id": 2454,
      "slug": "doom",
      "name": "DOOM (2016)",
      "released": "2016-05-13",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/c4b/c4b0cab189e73432de3a250d8cf1c84e.jpg",
      "rating": 4.39,
      "rating_top": 5,
      "ratings": [
          {
              "id": 5,
              "title": "exceptional",
              "count": 1611,
              "percent": 52.8
          },
          {
              "id": 4,
              "title": "recommended",
              "count": 1152,
              "percent": 37.76
          },
          {
              "id": 3,
              "title": "meh",
              "count": 221,
              "percent": 7.24
          },
          {
              "id": 1,
              "title": "skip",
              "count": 67,
              "percent": 2.2
          }
      ],
      "ratings_count": 3016,
      "reviews_text_count": 26,
      "added": 10912,
      "added_by_status": {
          "yet": 477,
          "owned": 6852,
          "beaten": 2318,
          "toplay": 408,
          "dropped": 574,
          "playing": 283
      },
      "metacritic": 85,
      "playtime": 11,
      "suggestions_count": 635,
      "updated": "2021-10-31T22:57:16",
      "user_game": null,
      "reviews_count": 3051,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "Xbox One",
                  "slug": "xbox-one",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 5216,
                  "image_background": "https://media.rawg.io/media/games/f46/f466571d536f2e3ea9e815ad17177501.jpg"
              },
              "released_at": "2016-05-13",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2016-05-13",
              "requirements_en": {
                  "minimum": "<strong>Minimum:</strong><br><ul class=\"bb_ul\"><li><strong>OS:</strong> Windows7,Windows8,Windows10<br></li><li><strong>Processor:</strong> Intel cpu i3<br></li><li><strong>Memory:</strong> 4 GB RAM<br></li><li><strong>Graphics:</strong> GTX 650<br></li><li><strong>Storage:</strong> 2 GB available space<br></li><li><strong>Sound Card:</strong> Realtek</li></ul>",
                  "recommended": "<strong>Recommended:</strong><br><ul class=\"bb_ul\"><li><strong>OS:</strong> Windows7,Windows8,Windows10<br></li><li><strong>Processor:</strong> Intel cpu i5<br></li><li><strong>Memory:</strong> 8 GB RAM<br></li><li><strong>Graphics:</strong> GTX 770<br></li><li><strong>Storage:</strong> 4 GB available space<br></li><li><strong>Sound Card:</strong> Realtek</li></ul>"
              },
              "requirements_ru": {
                  "minimum": "i386-33, 4 Мб",
                  "recommended": "i486-40, 8 Мб"
              }
          },
          {
              "platform": {
                  "id": 7,
                  "name": "Nintendo Switch",
                  "slug": "nintendo-switch",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 4771,
                  "image_background": "https://media.rawg.io/media/games/7cf/7cfc9220b401b7a300e409e539c9afd5.jpg"
              },
              "released_at": "2016-05-13",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 18,
                  "name": "PlayStation 4",
                  "slug": "playstation4",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 6288,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2016-05-13",
              "requirements_en": null,
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 2,
                  "name": "PlayStation",
                  "slug": "playstation"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          },
          {
              "platform": {
                  "id": 7,
                  "name": "Nintendo",
                  "slug": "nintendo"
              }
          }
      ],
      "genres": [
          {
              "id": 4,
              "name": "Action",
              "slug": "action",
              "games_count": 149659,
              "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
          },
          {
              "id": 2,
              "name": "Shooter",
              "slug": "shooter",
              "games_count": 51719,
              "image_background": "https://media.rawg.io/media/games/9fa/9fa63622543e5d4f6d99aa9d73b043de.jpg"
          }
      ],
      "stores": [
          {
              "id": 355582,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          },
          {
              "id": 2571,
              "store": {
                  "id": 3,
                  "name": "PlayStation Store",
                  "slug": "playstation-store",
                  "domain": "store.playstation.com",
                  "games_count": 7745,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 38659,
              "store": {
                  "id": 6,
                  "name": "Nintendo Store",
                  "slug": "nintendo",
                  "domain": "nintendo.com",
                  "games_count": 8825,
                  "image_background": "https://media.rawg.io/media/games/b72/b7233d5d5b1e75e86bb860ccc7aeca85.jpg"
              }
          },
          {
              "id": 8223,
              "store": {
                  "id": 2,
                  "name": "Xbox Store",
                  "slug": "xbox-store",
                  "domain": "microsoft.com",
                  "games_count": 4712,
                  "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 31,
              "name": "Singleplayer",
              "slug": "singleplayer",
              "language": "eng",
              "games_count": 162985,
              "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 7,
              "name": "Multiplayer",
              "slug": "multiplayer",
              "language": "eng",
              "games_count": 30873,
              "image_background": "https://media.rawg.io/media/games/8cc/8cce7c0e99dcc43d66c8efd42f9d03e3.jpg"
          },
          {
              "id": 13,
              "name": "Atmospheric",
              "slug": "atmospheric",
              "language": "eng",
              "games_count": 21630,
              "image_background": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg"
          },
          {
              "id": 42,
              "name": "Great Soundtrack",
              "slug": "great-soundtrack",
              "language": "eng",
              "games_count": 3202,
              "image_background": "https://media.rawg.io/media/games/b7b/b7b8381707152afc7d91f5d95de70e39.jpg"
          },
          {
              "id": 18,
              "name": "Co-op",
              "slug": "co-op",
              "language": "eng",
              "games_count": 8306,
              "image_background": "https://media.rawg.io/media/games/ec3/ec3a7db7b8ab5a71aad622fe7c62632f.jpg"
          },
          {
              "id": 411,
              "name": "cooperative",
              "slug": "cooperative",
              "language": "eng",
              "games_count": 3372,
              "image_background": "https://media.rawg.io/media/games/f87/f87457e8347484033cb34cde6101d08d.jpg"
          },
          {
              "id": 8,
              "name": "First-Person",
              "slug": "first-person",
              "language": "eng",
              "games_count": 21101,
              "image_background": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg"
          },
          {
              "id": 32,
              "name": "Sci-fi",
              "slug": "sci-fi",
              "language": "eng",
              "games_count": 14086,
              "image_background": "https://media.rawg.io/media/games/8e4/8e4de3f54ac659e08a7ba6a2b731682a.jpg"
          },
          {
              "id": 40845,
              "name": "Partial Controller Support",
              "slug": "partial-controller-support",
              "language": "eng",
              "games_count": 8369,
              "image_background": "https://media.rawg.io/media/games/c80/c80bcf321da44d69b18a06c04d942662.jpg"
          },
          {
              "id": 16,
              "name": "Horror",
              "slug": "horror",
              "language": "eng",
              "games_count": 32483,
              "image_background": "https://media.rawg.io/media/games/e6d/e6de699bd788497f4b52e2f41f9698f2.jpg"
          },
          {
              "id": 30,
              "name": "FPS",
              "slug": "fps",
              "language": "eng",
              "games_count": 10374,
              "image_background": "https://media.rawg.io/media/games/26d/26d4437715bee60138dab4a7c8c59c92.jpg"
          },
          {
              "id": 49,
              "name": "Difficult",
              "slug": "difficult",
              "language": "eng",
              "games_count": 10816,
              "image_background": "https://media.rawg.io/media/games/226/2262cea0b385db6cf399f4be831603b0.jpg"
          },
          {
              "id": 26,
              "name": "Gore",
              "slug": "gore",
              "language": "eng",
              "games_count": 4411,
              "image_background": "https://media.rawg.io/media/games/d58/d588947d4286e7b5e0e12e1bea7d9844.jpg"
          },
          {
              "id": 193,
              "name": "Classic",
              "slug": "classic",
              "language": "eng",
              "games_count": 1676,
              "image_background": "https://media.rawg.io/media/games/4ba/4ba9b4b68ffcc7019b112174883ba4d6.jpg"
          },
          {
              "id": 63,
              "name": "Zombies",
              "slug": "zombies",
              "language": "eng",
              "games_count": 8465,
              "image_background": "https://media.rawg.io/media/games/4cb/4cb463b5588adc672124fb041f09e91c.jpg"
          },
          {
              "id": 131,
              "name": "Fast-Paced",
              "slug": "fast-paced",
              "language": "eng",
              "games_count": 9049,
              "image_background": "https://media.rawg.io/media/games/736/73619bd336c894d6941d926bfd563946.jpg"
          },
          {
              "id": 120,
              "name": "Memes",
              "slug": "memes",
              "language": "eng",
              "games_count": 1384,
              "image_background": "https://media.rawg.io/media/games/270/270b412b66688081497b3d70c100b208.jpg"
          },
          {
              "id": 271,
              "name": "Remake",
              "slug": "remake",
              "language": "eng",
              "games_count": 1448,
              "image_background": "https://media.rawg.io/media/games/509/509c81a5da92a8d0645d9e160d155017.jpg"
          },
          {
              "id": 270,
              "name": "Blood",
              "slug": "blood",
              "language": "eng",
              "games_count": 1693,
              "image_background": "https://media.rawg.io/media/games/4fe/4feffcec6315c5f5a96442a8444431ca.jpg"
          },
          {
              "id": 187,
              "name": "Demons",
              "slug": "demons",
              "language": "eng",
              "games_count": 1448,
              "image_background": "https://media.rawg.io/media/games/645/64578c2a6daa30995692525172fd13ef.jpg"
          }
      ],
      "esrb_rating": {
          "id": 4,
          "name": "Mature",
          "slug": "mature"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/c4b/c4b0cab189e73432de3a250d8cf1c84e.jpg"
          },
          {
              "id": 22393,
              "image": "https://media.rawg.io/media/screenshots/353/353c1e834e7da7d6ceaa6beaff529c29.jpg"
          },
          {
              "id": 22394,
              "image": "https://media.rawg.io/media/screenshots/e50/e50f822107b8cc6af57aa21d76524149.jpg"
          },
          {
              "id": 22398,
              "image": "https://media.rawg.io/media/screenshots/ae9/ae9e9f7bfe19c63bd16151f81f81a7ed.jpg"
          },
          {
              "id": 22400,
              "image": "https://media.rawg.io/media/screenshots/14e/14e33eccb109558b0524761340ff2023.jpg"
          },
          {
              "id": 22402,
              "image": "https://media.rawg.io/media/screenshots/45d/45d16955ac9e90141b726684a07db02a.jpg"
          },
          {
              "id": 22404,
              "image": "https://media.rawg.io/media/screenshots/b77/b77629938389a41160d3b2a56eaed568.jpg"
          }
      ]
  },
  {
      "id": 3070,
      "slug": "fallout-4",
      "name": "Fallout 4",
      "released": "2015-11-09",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/d82/d82990b9c67ba0d2d09d4e6fa88885a7.jpg",
      "rating": 3.79,
      "rating_top": 4,
      "ratings": [
          {
              "id": 4,
              "title": "recommended",
              "count": 1343,
              "percent": 47.88
          },
          {
              "id": 3,
              "title": "meh",
              "count": 740,
              "percent": 26.38
          },
          {
              "id": 5,
              "title": "exceptional",
              "count": 577,
              "percent": 20.57
          },
          {
              "id": 1,
              "title": "skip",
              "count": 145,
              "percent": 5.17
          }
      ],
      "ratings_count": 2780,
      "reviews_text_count": 17,
      "added": 10791,
      "added_by_status": {
          "yet": 514,
          "owned": 6783,
          "beaten": 1830,
          "toplay": 318,
          "dropped": 1076,
          "playing": 270
      },
      "metacritic": 84,
      "playtime": 43,
      "suggestions_count": 439,
      "updated": "2020-07-06T04:52:40",
      "user_game": null,
      "reviews_count": 2805,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "Xbox One",
                  "slug": "xbox-one",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 5216,
                  "image_background": "https://media.rawg.io/media/games/f46/f466571d536f2e3ea9e815ad17177501.jpg"
              },
              "released_at": "2015-11-09",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2015-11-09",
              "requirements_en": {
                  "minimum": "<strong>Minimum:</strong><br><ul class=\"bb_ul\"><li><strong>OS:</strong> Windows 7/8/10 (64-bit OS required)<br></li><li><strong>Processor:</strong> Intel Core i5-2300 2.8 GHz/AMD Phenom II X4 945 3.0 GHz or equivalent<br></li><li><strong>Memory:</strong> 8 GB RAM<br></li><li><strong>Graphics:</strong> NVIDIA GTX 550 Ti 2GB/AMD Radeon HD 7870 2GB or equivalent<br></li><li><strong>Storage:</strong> 30 GB available space</li></ul>",
                  "recommended": "<strong>Recommended:</strong><br><ul class=\"bb_ul\"><li><strong>OS:</strong> Windows 7/8/10 (64-bit OS required)<br></li><li><strong>Processor:</strong> Intel Core i7 4790 3.6 GHz/AMD FX-9590 4.7 GHz or equivalent<br></li><li><strong>Memory:</strong> 8 GB RAM<br></li><li><strong>Graphics:</strong> NVIDIA GTX 780 3GB/AMD Radeon R9 290X 4GB or equivalent<br></li><li><strong>Storage:</strong> 30 GB available space</li></ul>"
              },
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 18,
                  "name": "PlayStation 4",
                  "slug": "playstation4",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 6288,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2015-11-09",
              "requirements_en": null,
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 2,
                  "name": "PlayStation",
                  "slug": "playstation"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          }
      ],
      "genres": [
          {
              "id": 4,
              "name": "Action",
              "slug": "action",
              "games_count": 149659,
              "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
          },
          {
              "id": 5,
              "name": "RPG",
              "slug": "role-playing-games-rpg",
              "games_count": 45874,
              "image_background": "https://media.rawg.io/media/games/995/9951d9d55323d08967640f7b9ab3e342.jpg"
          }
      ],
      "stores": [
          {
              "id": 3252,
              "store": {
                  "id": 3,
                  "name": "PlayStation Store",
                  "slug": "playstation-store",
                  "domain": "store.playstation.com",
                  "games_count": 7745,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 9047,
              "store": {
                  "id": 2,
                  "name": "Xbox Store",
                  "slug": "xbox-store",
                  "domain": "microsoft.com",
                  "games_count": 4712,
                  "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
              }
          },
          {
              "id": 13248,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 31,
              "name": "Singleplayer",
              "slug": "singleplayer",
              "language": "eng",
              "games_count": 162985,
              "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 40847,
              "name": "Steam Achievements",
              "slug": "steam-achievements",
              "language": "eng",
              "games_count": 25765,
              "image_background": "https://media.rawg.io/media/games/4ba/4ba9b4b68ffcc7019b112174883ba4d6.jpg"
          },
          {
              "id": 13,
              "name": "Atmospheric",
              "slug": "atmospheric",
              "language": "eng",
              "games_count": 21630,
              "image_background": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg"
          },
          {
              "id": 40849,
              "name": "Steam Cloud",
              "slug": "steam-cloud",
              "language": "eng",
              "games_count": 11732,
              "image_background": "https://media.rawg.io/media/games/c6b/c6bfece1daf8d06bc0a60632ac78e5bf.jpg"
          },
          {
              "id": 40836,
              "name": "Full controller support",
              "slug": "full-controller-support",
              "language": "eng",
              "games_count": 11963,
              "image_background": "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg"
          },
          {
              "id": 42,
              "name": "Great Soundtrack",
              "slug": "great-soundtrack",
              "language": "eng",
              "games_count": 3202,
              "image_background": "https://media.rawg.io/media/games/b7b/b7b8381707152afc7d91f5d95de70e39.jpg"
          },
          {
              "id": 24,
              "name": "RPG",
              "slug": "rpg",
              "language": "eng",
              "games_count": 14383,
              "image_background": "https://media.rawg.io/media/games/c24/c24ec439abf4a2e92f3429dfa83f7f94.jpg"
          },
          {
              "id": 118,
              "name": "Story Rich",
              "slug": "story-rich",
              "language": "eng",
              "games_count": 14512,
              "image_background": "https://media.rawg.io/media/games/8d6/8d69eb6c32ed6acfd75f82d532144993.jpg"
          },
          {
              "id": 36,
              "name": "Open World",
              "slug": "open-world",
              "language": "eng",
              "games_count": 5045,
              "image_background": "https://media.rawg.io/media/games/6cd/6cd653e0aaef5ff8bbd295bf4bcb12eb.jpg"
          },
          {
              "id": 8,
              "name": "First-Person",
              "slug": "first-person",
              "language": "eng",
              "games_count": 21101,
              "image_background": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg"
          },
          {
              "id": 149,
              "name": "Third Person",
              "slug": "third-person",
              "language": "eng",
              "games_count": 6912,
              "image_background": "https://media.rawg.io/media/games/d69/d69810315bd7e226ea2d21f9156af629.jpg"
          },
          {
              "id": 32,
              "name": "Sci-fi",
              "slug": "sci-fi",
              "language": "eng",
              "games_count": 14086,
              "image_background": "https://media.rawg.io/media/games/8e4/8e4de3f54ac659e08a7ba6a2b731682a.jpg"
          },
          {
              "id": 30,
              "name": "FPS",
              "slug": "fps",
              "language": "eng",
              "games_count": 10374,
              "image_background": "https://media.rawg.io/media/games/26d/26d4437715bee60138dab4a7c8c59c92.jpg"
          },
          {
              "id": 37,
              "name": "Sandbox",
              "slug": "sandbox",
              "language": "eng",
              "games_count": 4817,
              "image_background": "https://media.rawg.io/media/games/48c/48cb04ca483be865e3a83119c94e6097.jpg"
          },
          {
              "id": 1,
              "name": "Survival",
              "slug": "survival",
              "language": "eng",
              "games_count": 5948,
              "image_background": "https://media.rawg.io/media/games/476/476178ef18ab0534771d099f51cdc694.jpg"
          },
          {
              "id": 6,
              "name": "Exploration",
              "slug": "exploration",
              "language": "eng",
              "games_count": 15127,
              "image_background": "https://media.rawg.io/media/games/d82/d82990b9c67ba0d2d09d4e6fa88885a7.jpg"
          },
          {
              "id": 97,
              "name": "Action RPG",
              "slug": "action-rpg",
              "language": "eng",
              "games_count": 4647,
              "image_background": "https://media.rawg.io/media/games/83f/83f6f70a7c1b86cd2637b029d8b42caa.jpg"
          },
          {
              "id": 150,
              "name": "Third-Person Shooter",
              "slug": "third-person-shooter",
              "language": "eng",
              "games_count": 2264,
              "image_background": "https://media.rawg.io/media/games/a3c/a3c529a12c896c0ef02db5b4741de2ba.jpg"
          },
          {
              "id": 43,
              "name": "Post-apocalyptic",
              "slug": "post-apocalyptic",
              "language": "eng",
              "games_count": 2587,
              "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
          }
      ],
      "esrb_rating": {
          "id": 4,
          "name": "Mature",
          "slug": "mature"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/d82/d82990b9c67ba0d2d09d4e6fa88885a7.jpg"
          },
          {
              "id": 27994,
              "image": "https://media.rawg.io/media/screenshots/f55/f5598897e0e418c67521f2213dceb459.jpg"
          },
          {
              "id": 27996,
              "image": "https://media.rawg.io/media/screenshots/37c/37ce90b25d84e531743917165115d24c.jpg"
          },
          {
              "id": 28000,
              "image": "https://media.rawg.io/media/screenshots/fd3/fd3a97519e6d1b73f429f6bfcfb3bcf5.jpg"
          },
          {
              "id": 28002,
              "image": "https://media.rawg.io/media/screenshots/069/0691b4c1b839e55531d8c3206cd83dd7.jpg"
          },
          {
              "id": 28004,
              "image": "https://media.rawg.io/media/screenshots/cc0/cc0b3e29b579faae8d8585fd9ecff142.jpg"
          },
          {
              "id": 28006,
              "image": "https://media.rawg.io/media/screenshots/99c/99c81029aeace339293753186246099f.jpg"
          }
      ]
  },
  {
      "id": 32,
      "slug": "destiny-2",
      "name": "Destiny 2",
      "released": "2017-09-06",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/34b/34b1f1850a1c06fd971bc6ab3ac0ce0e.jpg",
      "rating": 3.57,
      "rating_top": 4,
      "ratings": [
          {
              "id": 4,
              "title": "recommended",
              "count": 1017,
              "percent": 45.65
          },
          {
              "id": 3,
              "title": "meh",
              "count": 710,
              "percent": 31.87
          },
          {
              "id": 5,
              "title": "exceptional",
              "count": 313,
              "percent": 14.05
          },
          {
              "id": 1,
              "title": "skip",
              "count": 188,
              "percent": 8.44
          }
      ],
      "ratings_count": 2203,
      "reviews_text_count": 19,
      "added": 10698,
      "added_by_status": {
          "yet": 355,
          "owned": 7992,
          "beaten": 672,
          "toplay": 138,
          "dropped": 1157,
          "playing": 384
      },
      "metacritic": 82,
      "playtime": 5,
      "suggestions_count": 1201,
      "updated": "2021-08-10T12:37:08",
      "user_game": null,
      "reviews_count": 2228,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "Xbox One",
                  "slug": "xbox-one",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 5216,
                  "image_background": "https://media.rawg.io/media/games/f46/f466571d536f2e3ea9e815ad17177501.jpg"
              },
              "released_at": "2017-09-06",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2017-09-06",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 18,
                  "name": "PlayStation 4",
                  "slug": "playstation4",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 6288,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2017-09-06",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 171,
                  "name": "Web",
                  "slug": "web",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 209391,
                  "image_background": "https://media.rawg.io/media/games/2ba/2ba37c3516b73e4b67bb3c1a69bb6478.jpg"
              },
              "released_at": "2017-09-06",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 186,
                  "name": "Xbox Series S/X",
                  "slug": "xbox-series-x",
                  "image": null,
                  "year_end": null,
                  "year_start": 2020,
                  "games_count": 445,
                  "image_background": "https://media.rawg.io/media/games/253/2534a46f3da7fa7c315f1387515ca393.jpg"
              },
              "released_at": "2017-09-06",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 187,
                  "name": "PlayStation 5",
                  "slug": "playstation5",
                  "image": null,
                  "year_end": null,
                  "year_start": 2020,
                  "games_count": 512,
                  "image_background": "https://media.rawg.io/media/games/560/56056a71c74f751552c9baedebf8f317.jpg"
              },
              "released_at": "2017-09-06",
              "requirements_en": null,
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 2,
                  "name": "PlayStation",
                  "slug": "playstation"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          },
          {
              "platform": {
                  "id": 14,
                  "name": "Web",
                  "slug": "web"
              }
          }
      ],
      "genres": [
          {
              "id": 4,
              "name": "Action",
              "slug": "action",
              "games_count": 149659,
              "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
          },
          {
              "id": 2,
              "name": "Shooter",
              "slug": "shooter",
              "games_count": 51719,
              "image_background": "https://media.rawg.io/media/games/9fa/9fa63622543e5d4f6d99aa9d73b043de.jpg"
          },
          {
              "id": 3,
              "name": "Adventure",
              "slug": "adventure",
              "games_count": 113029,
              "image_background": "https://media.rawg.io/media/games/9dd/9ddabb34840ea9227556670606cf8ea3.jpg"
          },
          {
              "id": 59,
              "name": "Massively Multiplayer",
              "slug": "massively-multiplayer",
              "games_count": 2861,
              "image_background": "https://media.rawg.io/media/games/095/0953bf01cd4e4dd204aba85489ac9868.jpg"
          }
      ],
      "stores": [
          {
              "id": 32,
              "store": {
                  "id": 3,
                  "name": "PlayStation Store",
                  "slug": "playstation-store",
                  "domain": "store.playstation.com",
                  "games_count": 7745,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 808,
              "store": {
                  "id": 2,
                  "name": "Xbox Store",
                  "slug": "xbox-store",
                  "domain": "microsoft.com",
                  "games_count": 4712,
                  "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
              }
          },
          {
              "id": 326831,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 31,
              "name": "Singleplayer",
              "slug": "singleplayer",
              "language": "eng",
              "games_count": 162985,
              "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 7,
              "name": "Multiplayer",
              "slug": "multiplayer",
              "language": "eng",
              "games_count": 30873,
              "image_background": "https://media.rawg.io/media/games/8cc/8cce7c0e99dcc43d66c8efd42f9d03e3.jpg"
          },
          {
              "id": 13,
              "name": "Atmospheric",
              "slug": "atmospheric",
              "language": "eng",
              "games_count": 21630,
              "image_background": "https://media.rawg.io/media/games/618/618c2031a07bbff6b4f611f10b6bcdbc.jpg"
          },
          {
              "id": 40836,
              "name": "Full controller support",
              "slug": "full-controller-support",
              "language": "eng",
              "games_count": 11963,
              "image_background": "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg"
          },
          {
              "id": 42,
              "name": "Great Soundtrack",
              "slug": "great-soundtrack",
              "language": "eng",
              "games_count": 3202,
              "image_background": "https://media.rawg.io/media/games/b7b/b7b8381707152afc7d91f5d95de70e39.jpg"
          },
          {
              "id": 18,
              "name": "Co-op",
              "slug": "co-op",
              "language": "eng",
              "games_count": 8306,
              "image_background": "https://media.rawg.io/media/games/ec3/ec3a7db7b8ab5a71aad622fe7c62632f.jpg"
          },
          {
              "id": 36,
              "name": "Open World",
              "slug": "open-world",
              "language": "eng",
              "games_count": 5045,
              "image_background": "https://media.rawg.io/media/games/6cd/6cd653e0aaef5ff8bbd295bf4bcb12eb.jpg"
          },
          {
              "id": 411,
              "name": "cooperative",
              "slug": "cooperative",
              "language": "eng",
              "games_count": 3372,
              "image_background": "https://media.rawg.io/media/games/f87/f87457e8347484033cb34cde6101d08d.jpg"
          },
          {
              "id": 8,
              "name": "First-Person",
              "slug": "first-person",
              "language": "eng",
              "games_count": 21101,
              "image_background": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg"
          },
          {
              "id": 32,
              "name": "Sci-fi",
              "slug": "sci-fi",
              "language": "eng",
              "games_count": 14086,
              "image_background": "https://media.rawg.io/media/games/8e4/8e4de3f54ac659e08a7ba6a2b731682a.jpg"
          },
          {
              "id": 30,
              "name": "FPS",
              "slug": "fps",
              "language": "eng",
              "games_count": 10374,
              "image_background": "https://media.rawg.io/media/games/26d/26d4437715bee60138dab4a7c8c59c92.jpg"
          },
          {
              "id": 9,
              "name": "Online Co-Op",
              "slug": "online-co-op",
              "language": "eng",
              "games_count": 3482,
              "image_background": "https://media.rawg.io/media/games/48c/48cb04ca483be865e3a83119c94e6097.jpg"
          },
          {
              "id": 6,
              "name": "Exploration",
              "slug": "exploration",
              "language": "eng",
              "games_count": 15127,
              "image_background": "https://media.rawg.io/media/games/d82/d82990b9c67ba0d2d09d4e6fa88885a7.jpg"
          },
          {
              "id": 79,
              "name": "Free to Play",
              "slug": "free-to-play",
              "language": "eng",
              "games_count": 4446,
              "image_background": "https://media.rawg.io/media/games/e1f/e1ffbeb1bac25b19749ad285ca29e158.jpg"
          },
          {
              "id": 397,
              "name": "Online multiplayer",
              "slug": "online-multiplayer",
              "language": "eng",
              "games_count": 3804,
              "image_background": "https://media.rawg.io/media/games/e4a/e4ab7f784bdc38c76ce6e4cef9715d18.jpg"
          },
          {
              "id": 69,
              "name": "Action-Adventure",
              "slug": "action-adventure",
              "language": "eng",
              "games_count": 10881,
              "image_background": "https://media.rawg.io/media/games/2ad/2ad87a4a69b1104f02435c14c5196095.jpg"
          },
          {
              "id": 25,
              "name": "Space",
              "slug": "space",
              "language": "eng",
              "games_count": 36092,
              "image_background": "https://media.rawg.io/media/games/530/5302dd22a190e664531236ca724e8726.jpg"
          },
          {
              "id": 157,
              "name": "PvP",
              "slug": "pvp",
              "language": "eng",
              "games_count": 5486,
              "image_background": "https://media.rawg.io/media/games/569/56978b5a77f13aa2ec5d09ec81d01cad.jpg"
          },
          {
              "id": 167,
              "name": "Futuristic",
              "slug": "futuristic",
              "language": "eng",
              "games_count": 3296,
              "image_background": "https://media.rawg.io/media/games/90f/90fd5e569bc4c4a666c588a732124908.jpg"
          },
          {
              "id": 172,
              "name": "Aliens",
              "slug": "aliens",
              "language": "eng",
              "games_count": 5413,
              "image_background": "https://media.rawg.io/media/games/963/963815b2a1a88475a31f311b591e70fb.jpg"
          },
          {
              "id": 406,
              "name": "Story",
              "slug": "story",
              "language": "eng",
              "games_count": 10246,
              "image_background": "https://media.rawg.io/media/games/615/61503312a95d451198d80d9bae275f79.jpg"
          },
          {
              "id": 1465,
              "name": "combat",
              "slug": "combat",
              "language": "eng",
              "games_count": 6890,
              "image_background": "https://media.rawg.io/media/games/f54/f54e9fb2f4aac37810ea1a69a3e4480a.jpg"
          },
          {
              "id": 478,
              "name": "3rd-Person Perspective",
              "slug": "3rd-person-perspective",
              "language": "eng",
              "games_count": 86,
              "image_background": "https://media.rawg.io/media/games/053/053fc543bf488349610f1ae2d0c1b51b.jpg"
          },
          {
              "id": 413,
              "name": "online",
              "slug": "online",
              "language": "eng",
              "games_count": 6230,
              "image_background": "https://media.rawg.io/media/games/174/1743b3dd185bda4a7be349347d4064df.jpg"
          },
          {
              "id": 158,
              "name": "MMORPG",
              "slug": "mmorpg",
              "language": "eng",
              "games_count": 1086,
              "image_background": "https://media.rawg.io/media/screenshots/37f/37f6c595ddfc5050a02f0f95d8805d77.jpg"
          },
          {
              "id": 98,
              "name": "Loot",
              "slug": "loot",
              "language": "eng",
              "games_count": 1581,
              "image_background": "https://media.rawg.io/media/games/530/5302dd22a190e664531236ca724e8726.jpg"
          },
          {
              "id": 171,
              "name": "PvE",
              "slug": "pve",
              "language": "eng",
              "games_count": 1865,
              "image_background": "https://media.rawg.io/media/games/4be/4be6a6ad0364751a96229c56bf69be59.jpg"
          },
          {
              "id": 2030,
              "name": "city",
              "slug": "city",
              "language": "eng",
              "games_count": 8556,
              "image_background": "https://media.rawg.io/media/screenshots/fbd/fbd5d0e3dee011b5231ba162c3e32e07_rqfVJfP.jpg"
          },
          {
              "id": 205,
              "name": "Lore-Rich",
              "slug": "lore-rich",
              "language": "eng",
              "games_count": 454,
              "image_background": "https://media.rawg.io/media/screenshots/bf0/bf08a4fb21df12939e94782ccfa7a858.jpg"
          },
          {
              "id": 744,
              "name": "friends",
              "slug": "friends",
              "language": "eng",
              "games_count": 14451,
              "image_background": "https://media.rawg.io/media/games/56e/56ed40948bebaf1968234aa6e3c74771.jpg"
          },
          {
              "id": 5816,
              "name": "console",
              "slug": "console",
              "language": "eng",
              "games_count": 1345,
              "image_background": "https://media.rawg.io/media/games/5dd/5dd4d2dd986d2826800bc37fff64aa4f.jpg"
          },
          {
              "id": 578,
              "name": "Masterpiece",
              "slug": "masterpiece",
              "language": "eng",
              "games_count": 227,
              "image_background": "https://media.rawg.io/media/games/793/79307648580a262f6cac402c3007efe0.jpg"
          },
          {
              "id": 3109,
              "name": "weapons",
              "slug": "weapons",
              "language": "eng",
              "games_count": 1489,
              "image_background": "https://media.rawg.io/media/games/e1f/e1ffbeb1bac25b19749ad285ca29e158.jpg"
          },
          {
              "id": 1484,
              "name": "skill",
              "slug": "skill",
              "language": "eng",
              "games_count": 3306,
              "image_background": "https://media.rawg.io/media/games/e63/e634a4493d4771c4eb8e335b24101492.jpg"
          },
          {
              "id": 3046,
              "name": "destroy",
              "slug": "destroy",
              "language": "eng",
              "games_count": 4289,
              "image_background": "https://media.rawg.io/media/screenshots/a36/a3621416d48dbea931b4b82dcc9d99d3.jpg"
          },
          {
              "id": 1743,
              "name": "collect",
              "slug": "collect",
              "language": "eng",
              "games_count": 7481,
              "image_background": "https://media.rawg.io/media/screenshots/e79/e798477413a08e16369dc064dc55524b.jpg"
          },
          {
              "id": 2184,
              "name": "hunt",
              "slug": "hunt",
              "language": "eng",
              "games_count": 2185,
              "image_background": "https://media.rawg.io/media/games/c19/c193180583c34e5753a1aaf15a586761.jpg"
          },
          {
              "id": 754,
              "name": "gun",
              "slug": "gun",
              "language": "eng",
              "games_count": 2928,
              "image_background": "https://media.rawg.io/media/games/f03/f030ebc8073430ce93a83c2d93ef163d.jpg"
          },
          {
              "id": 1527,
              "name": "rain",
              "slug": "rain",
              "language": "eng",
              "games_count": 815,
              "image_background": "https://media.rawg.io/media/screenshots/97a/97a7c4b98c8fd13bf91ce6cd27667fd3.jpg"
          },
          {
              "id": 691,
              "name": "quick",
              "slug": "quick",
              "language": "eng",
              "games_count": 882,
              "image_background": "https://media.rawg.io/media/screenshots/180/180050bb0f8ce1d8c58476f7e5ba95a4.jpg"
          },
          {
              "id": 18426,
              "name": "enemy",
              "slug": "enemy",
              "language": "eng",
              "games_count": 1815,
              "image_background": "https://media.rawg.io/media/screenshots/fbe/fbeeec3045f8d8c42a00d9f99ccfaba4.jpg"
          },
          {
              "id": 2863,
              "name": "darkness",
              "slug": "darkness",
              "language": "eng",
              "games_count": 341,
              "image_background": "https://media.rawg.io/media/games/eb6/eb65582e5eade59096e2d74d59c09d9a.jpg"
          },
          {
              "id": 6580,
              "name": "defender",
              "slug": "defender",
              "language": "eng",
              "games_count": 142,
              "image_background": "https://media.rawg.io/media/screenshots/d49/d49118cc0b312fd6db5a9bf851b9c260.jpg"
          }
      ],
      "esrb_rating": {
          "id": 3,
          "name": "Teen",
          "slug": "teen"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/34b/34b1f1850a1c06fd971bc6ab3ac0ce0e.jpg"
          },
          {
              "id": 2629150,
              "image": "https://media.rawg.io/media/screenshots/818/818cc34134cb22fb18fda8edec7144a3.jpg"
          },
          {
              "id": 2629151,
              "image": "https://media.rawg.io/media/screenshots/003/003a559bc0b47a4e5f2928f18a8d9142.jpg"
          },
          {
              "id": 2629152,
              "image": "https://media.rawg.io/media/screenshots/75d/75d8fbb3254f5b06f1a3f9a026d9c122.jpg"
          },
          {
              "id": 2629153,
              "image": "https://media.rawg.io/media/screenshots/ca3/ca3bdc1a51fc90a96c860ab6db8a313c.jpg"
          },
          {
              "id": 2629154,
              "image": "https://media.rawg.io/media/screenshots/575/5751a70c954618a99ec574f32be7ad43.jpg"
          },
          {
              "id": 2629155,
              "image": "https://media.rawg.io/media/screenshots/2e7/2e7304d3b9e670f943d0bd1e4be090f0.jpg"
          }
      ]
  },
  {
      "id": 11859,
      "slug": "team-fortress-2",
      "name": "Team Fortress 2",
      "released": "2007-10-10",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/46d/46d98e6910fbc0706e2948a7cc9b10c5.jpg",
      "rating": 3.66,
      "rating_top": 4,
      "ratings": [
          {
              "id": 4,
              "title": "recommended",
              "count": 1114,
              "percent": 45.54
          },
          {
              "id": 3,
              "title": "meh",
              "count": 599,
              "percent": 24.49
          },
          {
              "id": 5,
              "title": "exceptional",
              "count": 494,
              "percent": 20.2
          },
          {
              "id": 1,
              "title": "skip",
              "count": 239,
              "percent": 9.77
          }
      ],
      "ratings_count": 2424,
      "reviews_text_count": 18,
      "added": 10574,
      "added_by_status": {
          "yet": 147,
          "owned": 8187,
          "beaten": 647,
          "toplay": 32,
          "dropped": 1422,
          "playing": 139
      },
      "metacritic": 92,
      "playtime": 9,
      "suggestions_count": 521,
      "updated": "2020-07-08T03:57:06",
      "user_game": null,
      "reviews_count": 2446,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2007-10-10",
              "requirements_en": {
                  "minimum": "<strong>Minimum:</strong><br><ul class=\"bb_ul\"><li><strong>OS:</strong> Windows® 7 (32/64-bit)/Vista/XP<br></li><li><strong>Processor:</strong> 1.7 GHz Processor or better<br></li><li><strong>Memory:</strong> 512 MB RAM<br></li><li><strong>DirectX:</strong> Version 8.1<br></li><li><strong>Network:</strong> Broadband Internet connection<br></li><li><strong>Storage:</strong> 15 GB available space</li></ul>",
                  "recommended": "<strong>Recommended:</strong><br><ul class=\"bb_ul\"><li><strong>OS:</strong> Windows® 7 (32/64-bit)<br></li><li><strong>Processor:</strong> Pentium 4 processor (3.0GHz, or better)<br></li><li><strong>Memory:</strong> 1 GB RAM<br></li><li><strong>DirectX:</strong> Version 9.0c<br></li><li><strong>Network:</strong> Broadband Internet connection<br></li><li><strong>Storage:</strong> 15 GB available space</li></ul>"
              },
              "requirements_ru": {
                  "minimum": "Pentium 4/Athlon XP 1.7 ГГц,512 Мб памяти,3D-ускоритель со 128 Мб памяти,7.5 Гб на винчестере,Интернет-соединение 128 Кб/c",
                  "recommended": "Core 2 Duo/Athlon 64 3 ГГц,1 Гб памяти,3D-ускоритель с 512 Мб памяти,12 Гб на винчестере,Интернет-соединение 512 Кб/c"
              }
          },
          {
              "platform": {
                  "id": 5,
                  "name": "macOS",
                  "slug": "macos",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 91804,
                  "image_background": "https://media.rawg.io/media/games/b54/b54598d1d5cc31899f4f0a7e3122a7b0.jpg"
              },
              "released_at": "2007-10-10",
              "requirements_en": {
                  "minimum": "<strong>Minimum:</strong><br><ul class=\"bb_ul\"><li><strong>OS:</strong> OS X version Leopard 10.5.8 and above<br></li><li><strong>Processor:</strong> 1.7 GHz Processor or better<br></li><li><strong>Memory:</strong> 1 GB RAM<br></li><li><strong>Graphics:</strong> NVIDIA GeForce 8 or higher, ATI X1600 or higher, Intel HD 3000 or higher<br></li><li><strong>Network:</strong> Broadband Internet connection<br></li><li><strong>Storage:</strong> 15 GB available space</li></ul>"
              },
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 6,
                  "name": "Linux",
                  "slug": "linux",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 66467,
                  "image_background": "https://media.rawg.io/media/games/d69/d69810315bd7e226ea2d21f9156af629.jpg"
              },
              "released_at": "2007-10-10",
              "requirements_en": {
                  "minimum": "<strong>Minimum:</strong><br><ul class=\"bb_ul\"><li><strong>OS:</strong> Ubuntu 12.04<br></li><li><strong>Processor:</strong> Dual core from Intel or AMD at 2.8 GHz<br></li><li><strong>Memory:</strong> 1 GB RAM<br></li><li><strong>Graphics:</strong> nVidia GeForce 8600/9600GT, ATI/AMD Radeon HD2600/3600 (Graphic Drivers: nVidia 310, AMD 12.11), OpenGL 2.1<br></li><li><strong>Network:</strong> Broadband Internet connection<br></li><li><strong>Storage:</strong> 15 GB available space<br></li><li><strong>Sound Card:</strong> OpenAL Compatible Sound Card</li></ul>"
              },
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 5,
                  "name": "Apple Macintosh",
                  "slug": "mac"
              }
          },
          {
              "platform": {
                  "id": 6,
                  "name": "Linux",
                  "slug": "linux"
              }
          }
      ],
      "genres": [
          {
              "id": 4,
              "name": "Action",
              "slug": "action",
              "games_count": 149659,
              "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
          },
          {
              "id": 2,
              "name": "Shooter",
              "slug": "shooter",
              "games_count": 51719,
              "image_background": "https://media.rawg.io/media/games/9fa/9fa63622543e5d4f6d99aa9d73b043de.jpg"
          }
      ],
      "stores": [
          {
              "id": 13018,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 40847,
              "name": "Steam Achievements",
              "slug": "steam-achievements",
              "language": "eng",
              "games_count": 25765,
              "image_background": "https://media.rawg.io/media/games/4ba/4ba9b4b68ffcc7019b112174883ba4d6.jpg"
          },
          {
              "id": 7,
              "name": "Multiplayer",
              "slug": "multiplayer",
              "language": "eng",
              "games_count": 30873,
              "image_background": "https://media.rawg.io/media/games/8cc/8cce7c0e99dcc43d66c8efd42f9d03e3.jpg"
          },
          {
              "id": 7808,
              "name": "steam-trading-cards",
              "slug": "steam-trading-cards",
              "language": "eng",
              "games_count": 7582,
              "image_background": "https://media.rawg.io/media/games/4cf/4cfc6b7f1850590a4634b08bfab308ab.jpg"
          },
          {
              "id": 18,
              "name": "Co-op",
              "slug": "co-op",
              "language": "eng",
              "games_count": 8306,
              "image_background": "https://media.rawg.io/media/games/ec3/ec3a7db7b8ab5a71aad622fe7c62632f.jpg"
          },
          {
              "id": 411,
              "name": "cooperative",
              "slug": "cooperative",
              "language": "eng",
              "games_count": 3372,
              "image_background": "https://media.rawg.io/media/games/f87/f87457e8347484033cb34cde6101d08d.jpg"
          },
          {
              "id": 8,
              "name": "First-Person",
              "slug": "first-person",
              "language": "eng",
              "games_count": 21101,
              "image_background": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg"
          },
          {
              "id": 40845,
              "name": "Partial Controller Support",
              "slug": "partial-controller-support",
              "language": "eng",
              "games_count": 8369,
              "image_background": "https://media.rawg.io/media/games/c80/c80bcf321da44d69b18a06c04d942662.jpg"
          },
          {
              "id": 30,
              "name": "FPS",
              "slug": "fps",
              "language": "eng",
              "games_count": 10374,
              "image_background": "https://media.rawg.io/media/games/26d/26d4437715bee60138dab4a7c8c59c92.jpg"
          },
          {
              "id": 9,
              "name": "Online Co-Op",
              "slug": "online-co-op",
              "language": "eng",
              "games_count": 3482,
              "image_background": "https://media.rawg.io/media/games/48c/48cb04ca483be865e3a83119c94e6097.jpg"
          },
          {
              "id": 4,
              "name": "Funny",
              "slug": "funny",
              "language": "eng",
              "games_count": 18531,
              "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
          },
          {
              "id": 123,
              "name": "Comedy",
              "slug": "comedy",
              "language": "eng",
              "games_count": 8823,
              "image_background": "https://media.rawg.io/media/games/ffe/ffed87105b14f5beff72ff44a7793fd5.jpg"
          },
          {
              "id": 79,
              "name": "Free to Play",
              "slug": "free-to-play",
              "language": "eng",
              "games_count": 4446,
              "image_background": "https://media.rawg.io/media/games/e1f/e1ffbeb1bac25b19749ad285ca29e158.jpg"
          },
          {
              "id": 80,
              "name": "Tactical",
              "slug": "tactical",
              "language": "eng",
              "games_count": 3179,
              "image_background": "https://media.rawg.io/media/games/238/2383a172b4d50a7b44e07980eb7141ea.jpg"
          },
          {
              "id": 11669,
              "name": "stats",
              "slug": "stats",
              "language": "eng",
              "games_count": 4077,
              "image_background": "https://media.rawg.io/media/games/bff/bff077fb7c3b037bd5ed920bf447c863.jpg"
          },
          {
              "id": 40852,
              "name": "Steam Workshop",
              "slug": "steam-workshop",
              "language": "eng",
              "games_count": 1196,
              "image_background": "https://media.rawg.io/media/games/d58/d588947d4286e7b5e0e12e1bea7d9844.jpg"
          },
          {
              "id": 62,
              "name": "Moddable",
              "slug": "moddable",
              "language": "eng",
              "games_count": 679,
              "image_background": "https://media.rawg.io/media/games/4a0/4a0a1316102366260e6f38fd2a9cfdce.jpg"
          },
          {
              "id": 40838,
              "name": "Includes level editor",
              "slug": "includes-level-editor",
              "language": "eng",
              "games_count": 1498,
              "image_background": "https://media.rawg.io/media/games/93e/93ee6101e1c943732f06080dddb0fe4c.jpg"
          },
          {
              "id": 40832,
              "name": "Cross-Platform Multiplayer",
              "slug": "cross-platform-multiplayer",
              "language": "eng",
              "games_count": 1932,
              "image_background": "https://media.rawg.io/media/games/447/4470c1e76f01acfaf5af9c207d1c1c92.jpg"
          },
          {
              "id": 40833,
              "name": "Captions available",
              "slug": "captions-available",
              "language": "eng",
              "games_count": 1146,
              "image_background": "https://media.rawg.io/media/games/226/2262cea0b385db6cf399f4be831603b0.jpg"
          },
          {
              "id": 40837,
              "name": "In-App Purchases",
              "slug": "in-app-purchases",
              "language": "eng",
              "games_count": 1679,
              "image_background": "https://media.rawg.io/media/games/26b/26b27e1da9e3727fcb12e3e4e86c8c19.jpg"
          },
          {
              "id": 11,
              "name": "Team-Based",
              "slug": "team-based",
              "language": "eng",
              "games_count": 1000,
              "image_background": "https://media.rawg.io/media/games/0fa/0fadc446fd1e9ae9e23a32793d9a5406.jpg"
          },
          {
              "id": 125,
              "name": "Crafting",
              "slug": "crafting",
              "language": "eng",
              "games_count": 2582,
              "image_background": "https://media.rawg.io/media/games/739/73990e3ec9f43a9e8ecafe207fa4f368.jpg"
          },
          {
              "id": 40856,
              "name": "Valve Anti-Cheat enabled",
              "slug": "valve-anti-cheat-enabled",
              "language": "eng",
              "games_count": 104,
              "image_background": "https://media.rawg.io/media/games/736/73619bd336c894d6941d926bfd563946.jpg"
          },
          {
              "id": 170,
              "name": "Competitive",
              "slug": "competitive",
              "language": "eng",
              "games_count": 896,
              "image_background": "https://media.rawg.io/media/screenshots/69b/69bb243ea9896ddfc2e051b58e81624d.jpg"
          },
          {
              "id": 197,
              "name": "Robots",
              "slug": "robots",
              "language": "eng",
              "games_count": 6633,
              "image_background": "https://media.rawg.io/media/games/26d/26d4437715bee60138dab4a7c8c59c92.jpg"
          },
          {
              "id": 40834,
              "name": "Commentary available",
              "slug": "commentary-available",
              "language": "eng",
              "games_count": 243,
              "image_background": "https://media.rawg.io/media/games/b7b/b7b8381707152afc7d91f5d95de70e39.jpg"
          },
          {
              "id": 164,
              "name": "Cartoony",
              "slug": "cartoony",
              "language": "eng",
              "games_count": 2422,
              "image_background": "https://media.rawg.io/media/games/c89/c89ca70716080733d03724277df2c6c7.jpg"
          },
          {
              "id": 179,
              "name": "Cartoon",
              "slug": "cartoon",
              "language": "eng",
              "games_count": 3220,
              "image_background": "https://media.rawg.io/media/games/226/2262cea0b385db6cf399f4be831603b0.jpg"
          },
          {
              "id": 265,
              "name": "Class-Based",
              "slug": "class-based",
              "language": "eng",
              "games_count": 251,
              "image_background": "https://media.rawg.io/media/games/ccc/ccc0d5396e3331d58e5eb58a6a1fa1b7.jpg"
          },
          {
              "id": 245,
              "name": "Trading",
              "slug": "trading",
              "language": "eng",
              "games_count": 844,
              "image_background": "https://media.rawg.io/media/games/099/09958b7676fce13f46b59b56154e23cd.jpg"
          }
      ],
      "esrb_rating": {
          "id": 4,
          "name": "Mature",
          "slug": "mature"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/46d/46d98e6910fbc0706e2948a7cc9b10c5.jpg"
          },
          {
              "id": 97905,
              "image": "https://media.rawg.io/media/screenshots/596/5968ba06bac8bee0ec7e9d03c970c421.jpg"
          },
          {
              "id": 97906,
              "image": "https://media.rawg.io/media/screenshots/94f/94f4eb0b3d1fde7a37ec84f0f66f7f87.jpg"
          },
          {
              "id": 97907,
              "image": "https://media.rawg.io/media/screenshots/a0a/a0ad82cad18d0a2466d1d5f12bf8858c.jpg"
          },
          {
              "id": 97908,
              "image": "https://media.rawg.io/media/screenshots/a83/a83038d2ec296522ab1b9ab0521b1ec3.jpg"
          },
          {
              "id": 97909,
              "image": "https://media.rawg.io/media/screenshots/8d4/8d488a3e65256ec777c8097b0faacc78.jpg"
          },
          {
              "id": 97910,
              "image": "https://media.rawg.io/media/screenshots/707/707c7488bd6e35bc74d274a923bc1df2.jpg"
          }
      ]
  },
  {
      "id": 3939,
      "slug": "payday-2",
      "name": "PAYDAY 2",
      "released": "2013-08-13",
      "tba": false,
      "background_image": "https://media.rawg.io/media/games/73e/73eecb8909e0c39fb246f457b5d6cbbe.jpg",
      "rating": 3.5,
      "rating_top": 4,
      "ratings": [
          {
              "id": 4,
              "title": "recommended",
              "count": 909,
              "percent": 51.38
          },
          {
              "id": 3,
              "title": "meh",
              "count": 497,
              "percent": 28.09
          },
          {
              "id": 1,
              "title": "skip",
              "count": 186,
              "percent": 10.51
          },
          {
              "id": 5,
              "title": "exceptional",
              "count": 177,
              "percent": 10.01
          }
      ],
      "ratings_count": 1756,
      "reviews_text_count": 11,
      "added": 10474,
      "added_by_status": {
          "yet": 401,
          "owned": 8224,
          "beaten": 594,
          "toplay": 76,
          "dropped": 1079,
          "playing": 100
      },
      "metacritic": 79,
      "playtime": 9,
      "suggestions_count": 420,
      "updated": "2019-11-05T16:34:08",
      "user_game": null,
      "reviews_count": 1769,
      "saturated_color": "0f0f0f",
      "dominant_color": "0f0f0f",
      "platforms": [
          {
              "platform": {
                  "id": 6,
                  "name": "Linux",
                  "slug": "linux",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 66467,
                  "image_background": "https://media.rawg.io/media/games/d69/d69810315bd7e226ea2d21f9156af629.jpg"
              },
              "released_at": "2013-08-13",
              "requirements_en": null,
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 4,
                  "name": "PC",
                  "slug": "pc",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 441553,
                  "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
              },
              "released_at": "2013-08-13",
              "requirements_en": {
                  "minimum": "<strong>Minimum:</strong><br><ul class=\"bb_ul\"><li><strong>OS:</strong>Windows 7<br>\t</li><li><strong>Processor:</strong>2 GHz Intel Dual Core Processor<br>\t</li><li><strong>Memory:</strong>4 GB RAM<br>\t</li><li><strong>Graphics:</strong>Nvidia &amp; AMD (512MB VRAM)<br>\t</li><li><strong>DirectX®:</strong>9.0c<br>\t</li><li><strong>Hard Drive:</strong>31 GB HD space <br>\t</li><li><strong>Sound:</strong>DirectX 9.0c compatible</li></ul>",
                  "recommended": "<strong>Recommended:</strong><br><ul class=\"bb_ul\"><li><strong>OS:</strong>Windows 10<br>\t</li><li><strong>Processor:</strong>2.3 GHz Intel Quad Core Processor<br>\t</li><li><strong>Memory:</strong>8 GB RAM<br>\t</li><li><strong>Graphics:</strong>Nvidia &amp; AMD (1GB VRAM)<br>\t</li><li><strong>DirectX®:</strong>9.0c<br>\t</li><li><strong>Hard Drive:</strong>45 GB HD space<br>\t</li><li><strong>Sound:</strong>DirectX 9.0c compatible</li></ul>"
              },
              "requirements_ru": null
          },
          {
              "platform": {
                  "id": 1,
                  "name": "Xbox One",
                  "slug": "xbox-one",
                  "image": null,
                  "year_end": null,
                  "year_start": null,
                  "games_count": 5216,
                  "image_background": "https://media.rawg.io/media/games/f46/f466571d536f2e3ea9e815ad17177501.jpg"
              },
              "released_at": "2013-08-13",
              "requirements_en": null,
              "requirements_ru": null
          }
      ],
      "parent_platforms": [
          {
              "platform": {
                  "id": 1,
                  "name": "PC",
                  "slug": "pc"
              }
          },
          {
              "platform": {
                  "id": 3,
                  "name": "Xbox",
                  "slug": "xbox"
              }
          },
          {
              "platform": {
                  "id": 6,
                  "name": "Linux",
                  "slug": "linux"
              }
          }
      ],
      "genres": [
          {
              "id": 4,
              "name": "Action",
              "slug": "action",
              "games_count": 149659,
              "image_background": "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg"
          },
          {
              "id": 2,
              "name": "Shooter",
              "slug": "shooter",
              "games_count": 51719,
              "image_background": "https://media.rawg.io/media/games/9fa/9fa63622543e5d4f6d99aa9d73b043de.jpg"
          }
      ],
      "stores": [
          {
              "id": 4258,
              "store": {
                  "id": 3,
                  "name": "PlayStation Store",
                  "slug": "playstation-store",
                  "domain": "store.playstation.com",
                  "games_count": 7745,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          },
          {
              "id": 10780,
              "store": {
                  "id": 1,
                  "name": "Steam",
                  "slug": "steam",
                  "domain": "store.steampowered.com",
                  "games_count": 62836,
                  "image_background": "https://media.rawg.io/media/games/456/456dea5e1c7e3cd07060c14e96612001.jpg"
              }
          },
          {
              "id": 27939,
              "store": {
                  "id": 6,
                  "name": "Nintendo Store",
                  "slug": "nintendo",
                  "domain": "nintendo.com",
                  "games_count": 8825,
                  "image_background": "https://media.rawg.io/media/games/b72/b7233d5d5b1e75e86bb860ccc7aeca85.jpg"
              }
          },
          {
              "id": 34027,
              "store": {
                  "id": 7,
                  "name": "Xbox 360 Store",
                  "slug": "xbox360",
                  "domain": "marketplace.xbox.com",
                  "games_count": 1917,
                  "image_background": "https://media.rawg.io/media/games/588/588c6bdff3d4baf66ec36b1c05b793bf.jpg"
              }
          }
      ],
      "clip": null,
      "tags": [
          {
              "id": 31,
              "name": "Singleplayer",
              "slug": "singleplayer",
              "language": "eng",
              "games_count": 162985,
              "image_background": "https://media.rawg.io/media/games/511/5118aff5091cb3efec399c808f8c598f.jpg"
          },
          {
              "id": 40847,
              "name": "Steam Achievements",
              "slug": "steam-achievements",
              "language": "eng",
              "games_count": 25765,
              "image_background": "https://media.rawg.io/media/games/4ba/4ba9b4b68ffcc7019b112174883ba4d6.jpg"
          },
          {
              "id": 7,
              "name": "Multiplayer",
              "slug": "multiplayer",
              "language": "eng",
              "games_count": 30873,
              "image_background": "https://media.rawg.io/media/games/8cc/8cce7c0e99dcc43d66c8efd42f9d03e3.jpg"
          },
          {
              "id": 7808,
              "name": "steam-trading-cards",
              "slug": "steam-trading-cards",
              "language": "eng",
              "games_count": 7582,
              "image_background": "https://media.rawg.io/media/games/4cf/4cfc6b7f1850590a4634b08bfab308ab.jpg"
          },
          {
              "id": 40836,
              "name": "Full controller support",
              "slug": "full-controller-support",
              "language": "eng",
              "games_count": 11963,
              "image_background": "https://media.rawg.io/media/games/16b/16b1b7b36e2042d1128d5a3e852b3b2f.jpg"
          },
          {
              "id": 42,
              "name": "Great Soundtrack",
              "slug": "great-soundtrack",
              "language": "eng",
              "games_count": 3202,
              "image_background": "https://media.rawg.io/media/games/b7b/b7b8381707152afc7d91f5d95de70e39.jpg"
          },
          {
              "id": 18,
              "name": "Co-op",
              "slug": "co-op",
              "language": "eng",
              "games_count": 8306,
              "image_background": "https://media.rawg.io/media/games/ec3/ec3a7db7b8ab5a71aad622fe7c62632f.jpg"
          },
          {
              "id": 411,
              "name": "cooperative",
              "slug": "cooperative",
              "language": "eng",
              "games_count": 3372,
              "image_background": "https://media.rawg.io/media/games/f87/f87457e8347484033cb34cde6101d08d.jpg"
          },
          {
              "id": 8,
              "name": "First-Person",
              "slug": "first-person",
              "language": "eng",
              "games_count": 21101,
              "image_background": "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg"
          },
          {
              "id": 30,
              "name": "FPS",
              "slug": "fps",
              "language": "eng",
              "games_count": 10374,
              "image_background": "https://media.rawg.io/media/games/26d/26d4437715bee60138dab4a7c8c59c92.jpg"
          },
          {
              "id": 9,
              "name": "Online Co-Op",
              "slug": "online-co-op",
              "language": "eng",
              "games_count": 3482,
              "image_background": "https://media.rawg.io/media/games/48c/48cb04ca483be865e3a83119c94e6097.jpg"
          },
          {
              "id": 4,
              "name": "Funny",
              "slug": "funny",
              "language": "eng",
              "games_count": 18531,
              "image_background": "https://media.rawg.io/media/games/960/960b601d9541cec776c5fa42a00bf6c4.jpg"
          },
          {
              "id": 15,
              "name": "Stealth",
              "slug": "stealth",
              "language": "eng",
              "games_count": 4855,
              "image_background": "https://media.rawg.io/media/games/15c/15c95a4915f88a3e89c821526afe05fc.jpg"
          },
          {
              "id": 80,
              "name": "Tactical",
              "slug": "tactical",
              "language": "eng",
              "games_count": 3179,
              "image_background": "https://media.rawg.io/media/games/238/2383a172b4d50a7b44e07980eb7141ea.jpg"
          },
          {
              "id": 40837,
              "name": "In-App Purchases",
              "slug": "in-app-purchases",
              "language": "eng",
              "games_count": 1679,
              "image_background": "https://media.rawg.io/media/games/26b/26b27e1da9e3727fcb12e3e4e86c8c19.jpg"
          },
          {
              "id": 11,
              "name": "Team-Based",
              "slug": "team-based",
              "language": "eng",
              "games_count": 1000,
              "image_background": "https://media.rawg.io/media/games/0fa/0fadc446fd1e9ae9e23a32793d9a5406.jpg"
          },
          {
              "id": 144,
              "name": "Crime",
              "slug": "crime",
              "language": "eng",
              "games_count": 2199,
              "image_background": "https://media.rawg.io/media/games/5fa/5fae5fec3c943179e09da67a4427d68f.jpg"
          },
          {
              "id": 171,
              "name": "PvE",
              "slug": "pve",
              "language": "eng",
              "games_count": 1865,
              "image_background": "https://media.rawg.io/media/games/4be/4be6a6ad0364751a96229c56bf69be59.jpg"
          },
          {
              "id": 216,
              "name": "Heist",
              "slug": "heist",
              "language": "eng",
              "games_count": 345,
              "image_background": "https://media.rawg.io/media/games/2ad/2ad87a4a69b1104f02435c14c5196095.jpg"
          },
          {
              "id": 274,
              "name": "Gun Customization",
              "slug": "gun-customization",
              "language": "eng",
              "games_count": 254,
              "image_background": "https://media.rawg.io/media/games/560/560847de3a0fd510bbe6c305abca0f0f.jpg"
          }
      ],
      "esrb_rating": {
          "id": 5,
          "name": "Adults Only",
          "slug": "adults-only"
      },
      "short_screenshots": [
          {
              "id": -1,
              "image": "https://media.rawg.io/media/games/73e/73eecb8909e0c39fb246f457b5d6cbbe.jpg"
          },
          {
              "id": 74194,
              "image": "https://media.rawg.io/media/screenshots/c38/c38f5aa479eebab20cedcdae370e6e18.jpg"
          },
          {
              "id": 74195,
              "image": "https://media.rawg.io/media/screenshots/442/442be5656b314e3289ecd1486b5282f1.jpg"
          },
          {
              "id": 74196,
              "image": "https://media.rawg.io/media/screenshots/c2c/c2ccfeaeda357f932d1899a91f298850.jpg"
          },
          {
              "id": 74197,
              "image": "https://media.rawg.io/media/screenshots/a18/a18da938def6ce6e5b571f1c20272ab0.jpg"
          },
          {
              "id": 74198,
              "image": "https://media.rawg.io/media/screenshots/a5d/a5da0d01195f01cdedec974d52892128.jpg"
          },
          {
              "id": 74199,
              "image": "https://media.rawg.io/media/screenshots/4ee/4ee5c3c8b850ab4ba8e04b9f5d5ab060.jpg"
          }
      ]
  }
  ]